import React from 'react'

import Divider from 'components_new/atoms/Divider'
import Emoji from 'components_new/atoms/Emoji'
import Text from 'components_new/atoms/Text'

import IconTip from 'components_new/molecules/IconTip'

export const resources = {
  sv: {
    chat: {
      homepal_ai_title: 'Homepal AI',
      greeting: 'Jag är Homepals AI. Hur kan jag hjälpa dig idag?',
      analyzing: 'Analyserar…',
      reasoning: 'Resonemang',
      reasoning_streaming: 'Tänker…',
      tool_loaded_schema: 'Läste datamodellen',
      tool_fetched_data: 'Hämtade underlag',
      tool_aggregated: 'Summerade per dimension',
      tool_loading_schema: 'Läser datamodellen…',
      tool_fetching_data: 'Hämtar underlag…',
      tool_aggregating: 'Summerar per dimension…',
      tool_found_values: 'Slog upp värden i underlaget',
      thought_for_seconds: 'Tänkte i {{seconds}} s · {{count}} steg',
      thought_for_seconds_one: 'Tänkte i {{seconds}} s · {{count}} steg',
      steps_short: '{{count}} steg',
      steps_short_one: '{{count}} steg',
      follow_up: 'Någonting annat? Jag är redo!',
      generated_from: 'Genererat baserat på {{count}} poster från {{title}}.',
      input_placeholder: 'Ställ en fråga om datan…',
      send: 'Skicka',
      beta: 'Beta',
      beta_tooltip:
        'AI-chatten är i beta och förbättras löpande utifrån din feedback. Tyck till med tummarna under svaren.',
      disclaimer: 'AI kan göra fel. Verifiera viktig information.',
      empty_disclaimer:
        'Genom att ställa en fråga ger du AI-modellen tillgång till tabellen. GDPR-känsliga kolumner utesluts alltid.',
      starter_deviations: 'Sammanfatta och lyft avvikelser',
      starter_concentration: 'Vad är raderna koncentrerade kring?',
      toggle_panel: 'Visa eller dölj AI-chatt',
      feedback_helpful: 'Bra svar',
      feedback_not_helpful: 'Dåligt svar',
      feedback_title: 'Vad var problemet?',
      feedback_reason_wrong_numbers: 'Fel siffror',
      feedback_reason_not_answered: 'Svarade ej på min fråga',
      feedback_reason_cannot_help: 'Kunde inte svara på min fråga',
      feedback_reason_wrong_proposal: 'Fel ändring på tavlan',
      feedback_reason_board_unchanged: 'Ändrade inte tavlan',
      feedback_reason_misunderstood: 'Förstod inte vad jag menade',
      feedback_reason_other: 'Annat',
      feedback_comment_placeholder: 'Beskriv gärna mer (valfritt)',
      feedback_submit: 'Skicka',
      nudge_text:
        'Hjälpte det senaste svaret dig? Ett snabbt betyg lär mig vad som fungerar för dig, så nästa svar blir bättre.',
      nudge_thanks: 'Tack! Det här hjälper mig ge dig bättre svar framöver.',
      stream_interrupted: 'Svaret avbröts innan det blev klart. Försök igen.',
      history_title: 'Tidigare chattar',
      history_open_failed: 'Kunde inte öppna chatten. Försök igen.',
      history_today: 'Idag',
      history_yesterday: 'Igår',
      history_earlier: 'Tidigare',
      history_search_placeholder: 'Sök i tidigare chattar',
      history_scope_note:
        'Dina egna chattar härifrån. Varje chatt svarar utifrån den data som visades när den startades.',
      history_no_matches: 'Ingen chatt matchar sökningen.',
      history_empty: 'Du har inga tidigare chattar här än.',
      history_row_count: '{{count}} poster',
      history_other_view: 'Annat urval',
      resumed_chat_other_view:
        'Chatten startades med ett annat urval än tabellens.',
      resumed_chat_missing_filters: 'Överstrukna filter fanns inte med.',
      history_stale: 'Datan har uppdaterats sedan chatten startades',
      resumed_chat_stale:
        'Chatten svarar utifrån datan som fanns när den startades. Datan har uppdaterats sedan dess, så du kan läsa chatten men inte fortsätta i den.',
      resumed_chat_ask_again: 'Ställ frågan igen mot dagens data',
      input_placeholder_stale: 'Den här chatten går inte att fortsätta'
    },
    global: {
      filter: 'Filter',
      unhandled: 'Ohanterat',
      reject: 'Avvisa',
      undo: 'Ångra',
      priority: 'Prioritet',
      hi: 'Hej',
      copy: 'Kopiera',
      copied: 'Kopierat',
      ai_generated: 'Genererat med hjälp av vår AI-kategorisering.',
      advanced: 'Avancerat',
      data_updated: 'Livedata',
      data_locked: 'Låst data',
      total: 'Totalt',
      total_rows: 'Totalt {{count}} poster',
      showing_rows: 'Visar {{count}} av {{total}} poster',
      first_rows_only:
        'Visar de första {{count}} posterna. Lägg till ett filter för att se övriga.',
      showing_rows_of_first:
        'Visar {{count}} av de första {{total}} posterna. Lägg till ett filter för att se övriga.',
      rows_failed_to_load:
        'Posterna kunde inte hämtas. Försök igen eller begränsa urvalet med ett filter.',
      rows_failed_to_refresh:
        'Sökningen eller sorteringen kunde inte köras bland alla poster. Visar de poster som redan hämtats.',
      export_first_rows_only:
        'Exporten innehåller de {{count}} poster som visas, inte alla som matchar urvalet. Lägg till ett filter för att få med övriga.',
      export_all_rows:
        'Exporten innehåller alla poster som matchar urvalet, med tabellens kolumner, sökning och sortering. Stora urval tar en stund.',
      exporting_all_rows: 'Exporterar alla poster…',
      export_truncated:
        'Urvalet hade fler poster än Excel rymmer. Exporten innehåller de första {{count}}.',
      searching_all_rows: 'Söker bland alla poster…',
      sorting_all_rows: 'Sorterar bland alla poster…',
      sorted_among_fetched_rows:
        'Den här kolumnen sorteras bara bland de hämtade posterna.',
      matching_rows: '{{count}} poster matchar sökningen',
      first_matching_rows_only:
        'Visar de första {{count}} posterna som matchar sökningen. Förfina sökningen eller lägg till ett filter för att se övriga.',
      search_in_column: 'Sök i kolumn',
      search_in_column_placeholder: 'Sök i {{column}}',
      formula: 'Formel',
      formula_missing: 'Formel saknas',
      upload: 'Ladda upp',
      file_not_supported: 'Filen stöds ej',
      file_too_large: 'Filen är för stor',
      no_file_selected: 'Ingen fil vald',
      drop_here: 'Släpp här',
      drag_and_drop_here: 'Drag och släpp här',
      browse: 'Bläddra',
      location: 'Plats',
      supported_formats: 'Format som stöds',
      max_size: 'Maxstorlek',
      missing: 'Saknas',
      unpublished: 'Opublicerad',
      published: 'Publicerad',
      draft: 'Utkast',
      drafts: 'Utkast',
      internal: 'Internt',
      external: 'Externt',
      views: 'Visningar',
      view: 'Visning',
      date: 'Datum',
      accept: 'Acceptera',
      deny: 'Neka',
      feed: 'Flöde',
      pcs: 'st',
      company_type: 'Bolagstyp',
      all: 'Alla',
      my: 'Mina',
      tags: 'Taggar',
      profile: 'Profil',
      language: 'Språk',
      id: 'ID',
      edit_order: 'Redigera ordning',
      second: 'Sekund',
      seconds: 'Sekunder',
      minute: 'Minut',
      minutes: 'Minuter',
      hour: 'Timme',
      hours: 'Timmar',
      day: 'Dag',
      days: 'Dagar',
      week: 'Vecka',
      weeks: 'Veckor',
      month: 'Månad',
      months: 'Månader',
      year: 'År',
      years: 'År',
      open: 'Öppna',
      identifier: 'Identifierare',
      for: 'För',
      suggestion: 'Förslag',
      more_information: 'Mer information',
      and: 'Och',
      or: 'Eller',
      send_request: 'Skicka förfrågan',
      request_sent: 'Förfrågan skickad',
      misc_label: 'Övrigt',
      text: 'Text',
      title: 'Rubrik',
      subtitle: 'Underrubrik',
      nothing_selected_yet: 'Inget valt än',
      tools: 'Tillbehör',
      from: 'Från',
      by: 'Av',
      created_by: 'Skapad av',
      to: 'Till',
      go_to: 'Gå till',
      custom: 'Anpassad',
      apply: 'Applicera',
      quick_select: 'Snabbval',
      select: 'Välj',
      selected: 'Valda',
      select_all: 'Välj alla',
      show_selected: 'Visa endast valda',
      update: 'Uppdatera',
      save_as: 'Spara som',
      saved: 'Sparade',
      reset: 'Återställ',
      show_all: 'Visa alla',
      show_more: 'Visa mer',
      show_less: 'Visa mindre',
      read_more: 'Läs mer',
      share: 'Dela',
      share_name: 'Dela {{name}}',
      code: 'Kod',
      link: 'Länk',
      unlink: 'Ta bort länkning',
      will_be_unlinked_from: 'kommer att kopplas bort från',
      loading: 'Laddar',
      mobile: 'Mobil',
      missing_configuration: 'Saknar konfigurering',
      deactivate: 'Inaktivera',
      activated: 'Aktiverat',
      not_activated: 'Ej aktiverat',
      missing_data: 'Data saknas',
      access: 'Åtkomst',
      account: 'Konto',
      accounts: 'Konton',
      account_levels: 'Kontonivåer',
      activate: 'Aktivera',
      add: 'Lägg till',
      allocation_keys: 'Fördelningsnycklar',
      api: 'API',
      api_key: 'API-nyckel',
      api_keys: 'API-nycklar',
      authentication: 'Autentisering',
      auto: 'Auto',
      back: 'Tillbaka',
      cancel: 'Avbryt',
      confirm: 'Bekräfta',
      change_name: 'Byt namn',
      chart_of_accounts: 'Kontoplaner',
      close: 'Stäng',
      continue_in_background: 'Fortsätt i bakgrunden',
      close_side_panel: 'Stäng sidopanel',
      try_again: 'Försök igen',
      columns: 'Kolumner',
      coming_soon: 'Kommer snart',
      companies: 'Bolag',
      company_group: 'Kund',
      company_groups: 'Kunder',
      preview_company_group: 'Förhandsvisa kund',
      add_comment: 'Kommentera',
      original_value: 'Originalvärde',
      edited_value: 'Redigerat värde',
      comment_and_create_thread: 'Kommentera och skapa tråd...',
      reply_to_thread: 'Lämna ett svar...',
      delete_comment_thread: 'Radera den här kommentarstråden?',
      delete_comment: 'Radera kommentaren?',
      continue: 'Fortsätt',
      config: 'Konfigurering',
      integrations: 'Integrationer',
      copy_link: 'Kopiera länk',
      copy_to: 'Kopiera till',
      create: 'Skapa',
      created: 'Skapad',
      generated: 'Genererad',
      handled: 'Hanterad',
      reviewed: 'Granskad',
      unreviewed: 'Ej granskad',
      customization: 'Anpassningar',
      dashboard: 'Dashboard',
      dashboards: 'Dashboards',
      delete: 'Radera',
      to_delete: 'för att radera',
      description: 'Beskrivning',
      duplicate: 'Duplicera',
      economy: 'Ekonomi',
      edit: 'Redigera',
      edit_columns: 'Redigera kolumner',
      edit_title: 'Redigera titel',
      embed: 'Bädda in',
      export_to_excel: 'Exportera till .xlsx',
      export_to_excel_body:
        'Vill du använda eller analysera datan i en externt verktyg? Exportera den!',
      exporting_to_excel: 'Exporterar till .xlsx',
      fallback_label: 'Okänt namn',
      unknown: 'Okänd',
      missing_value: 'Saknar värde',
      member: 'Medlem',
      members: 'Medlemmar',
      groups: 'Grupper',
      home: 'Hem',
      homepal_admin: 'Admin',
      invite: 'Bjud in',
      invite_to_name: 'Bjud in till {{name}}',
      join: 'Gå med',
      last_changed_ago: 'Ändrades för {{time}} sedan',
      last_visited: 'Senast besökt',
      last_visited_ago: 'Besöktes för {{time}} sedan',
      time_ago: '{{time}} sedan',
      leave: 'Lämna',
      locked: 'Låsta',
      move: 'Flytta',
      move_to: 'Flytta till',
      name: 'Namn',
      next: 'Nästa',
      new: 'Nyhet',
      no_options_found: 'Hittade inga alternativ',
      none: 'Ingen',
      of: 'Av',
      open_side_panel: 'Öppna sidopanel',
      overview: 'Översikt',
      owner: 'Ansvarig',
      owners: 'Ansvariga',
      no_owner: 'Ingen ansvarig',
      no_owners: 'Inga ansvariga',
      optional: 'Valfritt',
      previous: 'Föregående',
      publish: 'Publicera',
      recommended: 'Rekommenderat',
      reset_all: 'Återställ alla',
      report: 'Rapport',
      reports: 'Rapporter',
      resource: 'Resurs',
      resources: 'Resurser',
      required: 'Obligatoriskt',
      results: 'Resultat',
      save: 'Spara',
      search: 'Sök',
      settings: 'Inställningar',
      size: 'Storlek',
      step: 'Steg',
      unnamed: 'Namnlös',
      unpublish: 'Avpublicera',
      updated: 'Uppdaterad',
      user: 'Användare',
      users: 'Användare',
      unit: 'Enhet',
      value: 'Värde',
      category: 'Kategori',
      status: 'Status',
      responsible: 'Ansvarig',
      subcategory: 'Underkategori',
      clear: 'Rensa',
      clear_all: 'Rensa alla',
      clear_search: 'Rensa sökning',
      shows: 'Visar',
      edit_mode: 'Redigeringsläge',
      exit_editing: 'Avsluta redigering',
      read_more_on_homepal_se: 'Läs mer på vår hemsida',
      about: 'Om',
      preview: 'Förhandsvisning',
      set_name: 'Ange namn',
      show: 'Visa',
      hide: 'Dölj',
      standard: 'Standard',
      custom_plural: 'Anpassade',
      done: 'Klar',
      get_started: 'Kom igång',
      sign_out: 'Logga ut',
      export: 'Exportera',
      exporting: 'Exporterar',
      exported: 'Exporterad',
      options: 'Alternativ',
      welcome: 'Välkommen',
      image: 'Bild',
      variant: 'Variant',
      transparent: 'Transparent',
      background: 'Bakgrund',
      format: 'Format',
      quality: 'Kvalitet',
      low: 'Låg',
      medium: 'Mellan',
      high: 'Hög',
      resolution: 'Upplösning',
      pixels: 'pixlar',
      pixels_short: 'px',
      file_exported: 'Filen har exporterats',
      login_required: 'Logga in i Homepal för att använda funktionaliteten',
      help_text: 'Hjälptext',
      restrict: 'Begränsa',
      lock: 'Lås',
      compare_with: 'Jämför med',
      compare_with_short: 'Jfr.',
      historical: 'Historiskt',
      forecast: 'Prognos',
      type: 'Typ',
      types: 'Typer',
      all_types: 'Alla typer',
      all_company_types: 'Alla bolagstyper',
      shared_with: 'Delas med',
      last_changed: 'Senast ändrad',
      trend: 'Trend',
      private: 'Privat',
      public: 'Publik',
      active: 'Aktivt',
      inactive: 'Inaktivt',
      move_left: 'Flytta vänster',
      move_right: 'Flytta höger',
      move_up: 'Flytta upp',
      move_down: 'Flytta ner',
      now: 'Nu',
      type_write: 'Skriv',
      will_be_deleted_are_you_sure:
        'kommer att raderas permanent och kan inte återställas.',
      economical_calculation: 'Ekonomisk beräkning',
      economical_calculations: 'Ekonomiska beräkningar',
      note: 'Tänk på!',
      default: 'Standard',
      page: 'Sida',
      pages: 'Sidor',
      locked_title: (
        <>
          Inget att se här... <Emoji name="lock" />
        </>
      ),
      error: 'Fel',
      error_500_title: 'Kunde inte ladda',
      error_500_helper_text:
        'Något gick fel när datan hämtades. Försök igen eller uppdatera sidan.',
      data_access: 'Dataåtkomst',
      actions: 'Aktiviteter',
      manage: 'Hantera',
      joined: 'Gick med',
      duplicate_name_error: 'Ett namn med det namnet finns redan',
      unsaved_changes: 'Osparade ändringar',
      sso: 'SSO',
      not_in_license: 'Ingår inte i er licens',
      no_access: 'Saknar åtkomst',
      pin: 'Fäst',
      unpin: 'Lossa',
      linked_resources: 'Länkade resurser',
      not_found: 'Hittades inte',
      something_went_wrong: 'Något gick fel',
      error_401_body: 'Du verkar inte ha tillåtelse att visa det här.',
      error_404_body: 'Vi kunde tyvärr inte hitta sidan du letade efter.',
      error_500_body: 'Någonting verkar ha gått fel på vår sida.',
      reply: 'Svara',
      export_as_xlsx: (
        <>
          Exportera som <b>.xlsx</b>
        </>
      ),
      favorite: 'Favorit',
      favorites: 'Favoriter',
      folder: 'Mapp',
      trash: 'Papperskorgen',
      restore: 'Återställ',
      grid: 'Rutnät',
      list: 'Lista',
      edition: 'Utgåva',
      editions: 'Utgåvor',
      chart: 'Diagram',
      untitled: 'Namnlös',
      explore: 'Utforska',
      templates: 'Mallar',
      more: 'Mer'
    },

    company_groups: {
      all_company_groups_have_access: 'Alla kunder har åtkomst',
      add_company: 'Lägg till bolag',
      edit_company_group: 'Redigera kund',
      delete_from_company_group: 'Ta bort från kund',
      delete_user_title: 'Radera användare?',
      delete_company_from_company_group_title: 'Radera bolag från kund?',
      'delete_company_from_company_group_body_{{companyGroupName}}_{{companyName}}':
        'Användare som tillhör kunden {{companyGroupName}} kommer inte längre kunna ta del av data kopplat till bolaget {{companyName}}. Är du säker?',
      no_companies_without_company_group:
        'Inga bolag saknar kundtillhörighet. Ta bort ett bolag från en kund för att lägga till det på denna kunden.',
      no_company_groups_without_chart_of_accounts:
        'Inga kunder saknar kontoplan. Ta bort en kund från en kontoplan för att lägga till den på denna kontoplanen.',
      missing_companies: '(Saknar bolag)',
      'rename_{{name}}': 'Döp om "{{name}}"',
      'invite_to_{{name}}': 'Bjud in till {{name}}',
      show_id: 'Visa id',
      '{{count}}_missing_company_group': '{{count}} bolag saknar kund',
      add_company_group: 'Lägg till kund',
      add_to_new_company_group: 'Lägg till i ny kund',
      structure_changed_warning:
        'Strukturen för kunder och bolag har ändrats. Datan är inte uppdaterad ännu — kör en datauppdatering för att ändringarna ska slå igenom.',
      rerun_ontology: 'Uppdatera data',
      rerun_ontology_running: 'Uppdaterar data',
      rerun_in_progress:
        'Datauppdatering pågår — ändringarna syns när den är klar.',
      'takes_about_{{minutes}}_min': 'Detta tar ungefär {{minutes}} min.',
      delete_company_group_warning: (
        <>
          Tillhörande användare kommer att raderas. Tillhörande bolag kommer att
          läggas under <i>Saknar kund</i>.
        </>
      ),
      helper_text: (
        <>
          <b>
            Här styr du vilka kunder som har tillgång till data under vilka
            bolag.
          </b>{' '}
          Uppdateringar kommer att slå igenom i era dashboards vid nästa
          inläsning.
        </>
      )
    },

    accounting: {
      accounting_periods: 'Bokslutsperioder',
      accounting_periods_helper_text:
        'Ange när era bokslutsperioder stängs. Kan även sättas till manuell hantering.',
      latest_closed_period: 'Senaste stängda bokslutsperiod',
      latest_closed_period_error_text:
        'Måste vara satt vid manuell hantering av bokslutsperioder.',
      no_chart_of_accounts: 'Det finns inga kontoplaner ännu.',
      select_predefined_calculation_helper_text:
        'Välj en fördefinierad beräkning för att få fram ett jämförelsetal för mätetalet. Det här går att göra på ekonomiska mätetal.',
      edit_account_references: 'Redigera kontoreferenser',
      'and_{{count}}_others': 'och {{count}} andra',
      edit_account_level: 'Redigera kontonivå',
      calculation_block: 'Räkneblock',
      constant: 'Konstant',
      select_account_level: 'Välj kontonivå',
      accounts: 'Konton',
      account_references: 'Kontoreferenser',
      account_references_helper_text:
        'Välj vilka konton som ska tillhöra respektive kontonivå.',
      account_level_in_use:
        'Kontonivån används i ett mätetal och går därför inte att ta bort',
      standard_account_level_locked:
        'Kontonivån är en del av Homepals standard och går inte att ta bort eller ändra',
      account_level_name_exists_error:
        'Det finns redan en kontonivå med det namnet.',
      add_account_level: 'Lägg till kontonivå',
      account_level: 'Kontonivå',
      account_levels: 'Kontonivåer',
      account_levels_description:
        'Ordningen används för att sortera visualiseringar i en naturlig och logisk följd för ekonomiska konton.',
      account_levels_helper_text:
        'Definiera kontonivåer som en trädstruktur och koppla konton till rätt nivå.',
      '{{count}}_unused_accounts_warning':
        '{{count}} konto(n) i kontoplanen används inte i någon kontonivå.',
      unused_accounts: 'Konton som inte används',
      unused_accounts_helper_text:
        'Följande konton i kontoplanen används inte i någon kontonivå.'
    },

    chart_of_accounts: {
      delete_chart_of_accounts_title: 'Ta bort kontoplan',
      delete_chart_of_accounts_body:
        'Kontoplanen kommer att raderas permanent. Kunder som använder kontoplanen kommer läggas under saknar kontoplan. Är du säker?',
      delete_account: 'Ta bort konto',
      edit_account: 'Redigera konto',
      account_number_exists_error: 'Kontonumret används redan i kontoplanen',
      account_number_invalid_error:
        'Kontonumret måste vara en siffra mellan 1000-9999',
      add_account: 'Lägg till konto',
      account_number: 'Kontonummer',
      edit_chart_of_accounts: 'Redigera kontoplan',
      edit_accounts: 'Redigera konton',
      create_chart_of_accounts: 'Skapa en kontoplan',
      duplicate_chart_of_accounts: 'Duplicera kontoplan',
      duplicate_chart_of_accounts_body:
        'Kontoplanens konton kopieras till en ny kontoplan. Kunderna på kontoplanen kopieras inte.',
      duplicate_account_references: 'Duplicera även kontoreferenser',
      '{{name}}_copy': '{{name}} (kopia)',
      upload_instructions:
        'Kontoplanen ska laddas in i CSV-format. Första kolumnen ska innehålla det 4-siffriga kontonumret och den andra kolumnen kontonamnet.',
      '{{count}}_missing_chart_of_accounts':
        '{{count}} kund(er) saknar kontoplan',
      main_chart_of_accounts: 'Huvudkontoplan',
      upload_file: 'Ladda upp fil',
      add_accounts_manually: 'Lägg till manuellt',
      manual_instructions:
        'Kontoplanen skapas tom. Därefter lägger du till konton ett i taget.',
      companies_required: 'Minst ett bolag krävs.',
      '{{count}}_companies': '{{count}} bolag',
      no_companies: 'Inga bolag, används inte än',
      companies_helper_text:
        'Bolagen använder den här kontoplanen i stället för huvudkontoplanen. Ett bolag kan bara ha en egen kontoplan.',
      company_specific_instructions:
        'Den nya kontoplanen gäller för bolagen du väljer. Övriga bolag använder huvudkontoplanen.',
      delete_company_specific_chart_of_accounts_body:
        'Kontoplanen kommer att raderas permanent. Bolagen på kontoplanen går tillbaka till huvudkontoplanen. Är du säker?',
      helper_text:
        'Hantera vilka konton som ska användas i applikationen. Uppdatera genom uppladdning av fil i CSV-format.'
    },

    economy: {
      page_title: 'Hantera ekonomi',
      page_body:
        'Se konton, kontonplaner och ekonomiska mätetal för er organisation.',
      metrics_helper_text:
        'Definiera beräkningar för finansiella mätetal eller skapa egna. Utgå från era konton.'
    },

    configuration: {
      page_title: 'Konfigurera specifikationer',
      page_body:
        'Konfigurera blandade funktioner och standardinställningar för organisationen.',
      all_included: 'Alla inkluderas',
      excluded_types: '{{types}} exkluderas',
      excluded_of: '{{excluded}} av {{total}} exkluderas',
      included_summary: '{{included}} inkluderas · {{excluded}} exkluderas',
      new_summary: '{{count}} nya',
      new_summary_one: '{{count}} ny',
      pending_data_run: 'Slår igenom efter nästa datakörning',
      pending_data_run_tooltip:
        'Ändrat {{date}}. Siffrorna i Homepal uppdateras när nästa datakörning är klar.',
      object_row_types_body:
        'Välj vilka debiteringstyper som inkluderas. Gäller hyran på objekten. Debiteringstyper på avtal påverkas inte. En exkluderad typ tas bort ur alla beräkningar som bygger på objektens hyra, till exempel vakanshyra, årskostnad, hyresbortfall, prisnivå och normhyra. Inställningen gäller hela organisationen. Typer som tillkommer efter att du har sparat markeras som nya.',
      new_since_last_save: 'Nya sedan du senast sparade',
      new_body: 'Nya typer inkluderas tills du exkluderar dem.',
      new_tag: 'Ny',
      in_data: 'I datan',
      missing_in_data: 'Saknas i datan',
      missing_body:
        'Typerna finns inte i den senaste datan och förblir exkluderade om de kommer tillbaka. Ta bort en typ om du inte längre vill exkludera den.',
      remove: 'Ta bort',
      acknowledged_on_save: '{{types}} markeras som granskade när du sparar.',
      acknowledged_on_save_one:
        '{{types}} markeras som granskad när du sparar.',
      takes_effect_after_data_run:
        'Ändringen slår igenom efter nästa datakörning.',
      new_types_banner:
        'Nya debiteringstyper på objekt: {{types}}. De inkluderas tills du exkluderar dem.',
      new_types_banner_one:
        'Ny debiteringstyp på objekt: {{types}}. Den inkluderas tills du exkluderar den.'
    },

    api_keys: {
      description:
        'Här visas dina API-nycklar. Dessa nycklar kan delas med en tredjepart som behöver bädda in dashboards på en webbplats. Med hjälp av en API-nyckel kan tredjeparten hämta information om era kunder samt generera unika länkar till dashboards. Dessa länkar är giltiga i 1 timme. Om du är osäker på hur detta fungerar, tveka inte att kontakta oss för hjälp.',
      create_key: 'Skapa en nyckel',
      page_title: 'Hantera API-nycklar',
      page_body: 'Skapa och återkalla nycklar för säkra systemintegrationer.',
      key_type_label: 'Typ av nyckel',
      name_helper:
        'Varje integration eller mottagare bör ha en egen nyckel för att kunna spåra användning och enkelt återkalla åtkomst vid behov.'
    },

    sso: {
      page_title: 'Hantera SSO',
      page_body: 'Sätt upp er SSO och hantera tillåtna emaildomäner.',
      sso_not_in_license_title: 'SSO ingår inte i er licens',
      sso_not_in_license_body:
        'Den här funktionen ingår inte i er nuvarande licens. Kontakta hej@homepal.se om ni vill aktivera SSO.',
      entra_id_title: 'Entra ID',
      entra_id_helper_text:
        'Aktivera Entra ID i autentisering för att tillåta användare att logga in på Homepal via deras Entra ID-konto.',
      specifications_title: 'Specifikationer',
      specifications_helper_text:
        'Sätt upp SAML SSO i Entra ID med hjälp av följande uppgifter:',
      details_title: 'Uppgifter',
      details_helper_text: 'Ange uppgifter från er SSO-tjänst i fälten nedan.',
      app_federation_metadata_url_label: 'App Federation Metadata URL',
      from_microsoft_azure_ad_caption: 'från Microsoft Azure AD',
      group_id_label: 'Grupp ID',
      group_id_helper_text:
        'Det här behövs endast om ni har flertalet homepal-uppsättningar i er organisation.',
      mail_domains_title: 'Maildomäner',
      mail_domains_helper_text:
        'Ange vilka maildomäner som ska få logga in med Microsoft Azure AD. Domänen ska skrivas utan \'@\' (ex: fastigheter.se).',
      warning_note_title: 'Tänk på!',
      warning_note_body:
        'Det går inte att ange publika domäner (så som gmail.com eller outlook.com). Ange domänen utan @.',
      idp_groups_title: 'Grupp-mappningar',
      idp_groups_helper_text:
        'Mappa IDP-grupper till Homepal-systemgrupper. Gruppmedlemskap synkroniseras automatiskt vid inloggning.',
      idp_group_id_label: 'IDP-grupp ID',
      add_idp_group: 'Lägg till grupp',
      need_help_caption: 'Behöver du hjälp?',
      show_detailed_instructions_link: 'Visa detaljerade instruktioner'
    },

    settings: {
      page_title: 'Hantera organisationens inställningar',
      page_body:
        'Anpassa hur applikationen och funktionaliteten fungerar för er organisation.'
    },

    status_banner: {
      read_more: 'Läs mer',
      collapse: 'Fäll ihop',
      more_messages_one: '+{{count}} meddelande',
      more_messages_other: '+{{count}} meddelanden',
      system_messages: '{{count}} systemmeddelanden',
      level_info: 'Info',
      level_important: 'Viktigt'
    },

    loading: {
      collecting_data: 'Samlar in data från dina system',
      syncing_processing: 'Synkroniserar och bearbetar din data',
      performing_calculations: 'Utför de beräkningar som krävs',
      simplifying_data: 'Gör din data enkel och begriplig',
      presenting_data: 'Försöker presentera din data',
      loading_metrics: 'Laddar in mätetal',
      analyzing_metrics: 'Analyserar vilka mätetal du kan skapa'
    },

    guides: {
      how_homepal_works: 'Hur fungerar Homepal?',

      welcome_title: 'Välkommen till Homepal! 🎉',
      welcome_body: (
        <Text paragraph variant="inherit">
          Homepal är ett verktyg för att automatisera din uppföljning och
          rapportering med hjälp av färdiga mätetal och tillgänglig data.
        </Text>
      ),
      welcome_hint: (
        <>
          Den här guiden tar <b>mindre än 2 minuter</b> och visar dig hur du
          enkelt hittar den information som du är intresserad av.
        </>
      ),

      dashboards_title: 'Dashboards',
      dashboards_body: (
        <>
          <Text paragraph variant="inherit">
            En <code>dashboard</code> är en yta (likt ett ritbräde) där olika
            nyckeltal, mätvärden och annan data visualiseras för att ge dig en
            enkel översikt.
          </Text>
          <Text paragraph variant="inherit">
            De dashboards som du har tillgång till visas direkt i din startvy
            eller ligger fördelade i mappar. Du kan även nå dem via sidomenyn
            till vänster om den är utfälld.
          </Text>
          <Text paragraph variant="inherit">
            <b>Om du inte ser några dashboards</b> bör du kontakta din
            administratör för att få rättigheter tilldelade.
          </Text>
        </>
      ),
      dashboards_hint: (
        <>
          För snabbare tillgång till dina viktigaste dashboards kan du markera
          dem som favoriter!
        </>
      ),

      tabs_title: 'Flikar',
      tabs_body: (
        <Text paragraph variant="inherit">
          Varje dashboard kan innehålla flera <code>flikar</code>. Använd dessa
          för att navigera mellan olika sidor i en dashboard.
        </Text>
      ),
      tabs_hint: (
        <>
          En dashboard <u>behöver inte</u> ha flera flikar. Ser du inga flikar
          är det antagligen för att det inte finns några.
        </>
      ),

      filters_title: 'Filter',
      filters_body: (
        <>
          <Text paragraph variant="inherit">
            Använd tillgängliga <code>filter</code> i sidomenyn till höger för
            att visa det urval som är intressant för dig.
          </Text>
          <Text paragraph variant="inherit">
            Du kan även anpassa vilken tidsperiod du vill titta på. Välj ett
            standardval som <code>Hittills det här året</code>,{' '}
            <code>Senaste 90 dagarna</code> eller <code>Igår</code> – eller mata
            in valfria datum.
          </Text>
        </>
      ),
      filters_hint: (
        <>
          Om du saknar möjlighet att filtrera på något specifikt bör du kontakta
          din administratör. En administratör kan enkelt och snabbt lägga till
          filter.
        </>
      ),

      widgets_title: 'Widgets',
      widgets_body: (
        <>
          <Text paragraph variant="inherit">
            Dashboards är uppbyggda av <code>widgets</code> (små rektanglar) som
            visar olika data i form av visualiseringar. I högra hörnet av en
            widget kan du:
          </Text>
          <Text paragraph variant="inherit">
            <ul className="ul">
              <li className="li">
                <b>Förstora</b> och fokusera visualiseringen
              </li>
              <li className="li">
                <b>Visa information</b> om datan
              </li>
              <li className="li">
                <b>Visa innehåll</b> i tabell
              </li>
              <li className="li">
                <b>Exportera till .xlsx</b>
              </li>
            </ul>
          </Text>
        </>
      ),
      widgets_hint: (
        <>
          Vill du hellre arbeta med widgetens data i ett annat verktyg?
          Exportera till .xlsx!
        </>
      ),

      charts_title: 'Grafer',
      charts_body: (
        <>
          <Text paragraph variant="inherit">
            I de flesta widgets visas datan i <code>grafer</code>. Klicka på ett
            segment (t.ex. en stapel, siffra eller pajbit) för att:
          </Text>
          <Text paragraph variant="inherit">
            <ul className="ul">
              <li className="li">
                <b>Lägga till i filter</b>
              </li>
              <li className="li">
                <b>Visa innehåll</b> bakom i tabell
              </li>
              <li className="li">
                <b>Dela upp</b> segmentet för vidare analys
              </li>
            </ul>
          </Text>
        </>
      ),
      charts_hint: (
        <>
          Klicka på ett diagramsegment för att snabbt analysera ett specifikt
          område.
        </>
      ),

      templates_title: 'Utforska',
      templates_body: (
        <>
          <Text paragraph variant="inherit">
            I sidomenyn till vänster (under <code>Utforska</code>) hittar du en
            katalog med branschens vanligaste dashboards, baserade på våra
            kunders kunskap.
          </Text>
          <Text paragraph variant="inherit">
            <b>Som administratör</b> kan du aktivera en dashboard direkt till er
            Homepal-miljö med ett klick.
          </Text>
        </>
      ),
      templates_hint: (
        <>
          Hittat en dashboard du gillar men saknar rättigheter att aktivera den?
          Kontakta din administratör!
        </>
      ),
      delete_confirmation_suffix: 'kommer att raderas permanent. Är du säker?'
    },

    allocation_keys: {
      about: (
        <>
          <strong>
            Fördelningsnycklar kan användas för att fördela centrala kostnader
            mellan fastigheter enligt specifika kriterier
          </strong>
          , som till exempel uthyrningsbar yta eller annan procentuell
          uppdelning. Genom att använda fördelningsnycklar får ni en mer
          rättvisande bild av kostnadsfördelningen och kan enklare följa upp
          ekonomin på fastighetsnivå.{' '}
          <strong>
            Uppdateringar i fördelningsnycklar slår igenom vid nästa inläsning
            från källsystem.
          </strong>
        </>
      ),
      distributes: 'Fördelar',
      empty_accounts_tooltip: 'Minst 1 konto måste väljas för fördelning.',
      empty_name_tooltip: 'Namnet får inte lämnas tomt.',
      name_key_title: 'Namnge din fördelningsnyckel',
      name_key_subtitle:
        'Ge din fördelningsnyckel ett namn så att du kan urskilja den från andra fördelningsnycklar.',
      select_accounts_title: 'Välj konton',
      select_accounts_subtitle:
        'Välj vilka konton som ska fördelas med nyckeln. Här kan du välja alla konton som ska fördelas på samma sätt.',
      select_allocation_title: 'Välj fördelning',
      select_allocation_subtitle:
        'Välj hur utfallen på konton som inte redan är fördelade via ett kostnadsställe ska fördelas mellan fastigheterna.',
      share: 'Andel (%)',
      total_allocation_zero_error: 'Den totala fördelning får inte vara 0%.',
      total_allocation_above_100_error:
        'Den totala fördelning får inte överskrida 100%.',
      total_allocation: 'Total fördelning'
    },

    companies: {
      activation_status_helper_text: (
        <>
          <b>Välj vilka bolag som ska inkluderas i datasynkroniseringen.</b>{' '}
          Data som är kopplad till exkluderade bolag kommer inte att vara
          tillgänglig i organisationens dashboards. Detta bör användas för att
          till exempel exkludera testbolag eller inaktiva bolag. Uppdateringar
          kommer att slå igenom i era dashboards vid nästa inläsning.
        </>
      ),
      page_title: 'Hantera bolag',
      page_body: 'Lägg till, redigera och koppla bolag i er portfölj.'
    },

    integrations: {
      page_title: 'Hantera integrationer',
      page_body:
        'Konfigurera och övervaka dina integrationer och deras anslutningar.',
      fortnox_page_title: 'Fortnox',
      fortnox_page_body:
        'Se anslutningsstatus för dina Fortnox-klienter och återanslut vid behov.',
      tenant_name: 'Klient',
      organization_number: 'Organisationsnummer',
      status: 'Status',
      message: 'Meddelande',
      last_successful_run: 'Senaste lyckade körning',
      last_checked_at: 'Senast kontrollerad',
      status_ok: 'Ansluten',
      status_needs_reauth: 'Behöver återanslutas',
      status_missing_license: 'Licens saknas',
      reconnect: 'Återanslut',
      authenticate_new_tenant: 'Anslut ny klient',
      remove_tenant: 'Ta bort klient',
      home_warning:
        'Fortnox: {{count}} klienter har tappat anslutningen och behöver åtgärdas.',
      home_warning_action: 'Visa',
      no_tenants: 'Inga klienter hittades.'
    },

    customization: {
      contrast_warning:
        'Kontrasten mellan textfärgen {{text}} och widgetbakgrunden är {{ratio}}:1. WCAG 2.1 AA kräver minst 4,5:1 för text.',
      background_colors_helper_text:
        'Välj anpassade bakgrundsfärger till dashboards och widgets. Notera att applikationens automatiska färgläge inaktiveras vid anpassade val.',
      text_colors_helper_text:
        'Välj anpassade textfärger till dashboards och widgets. Notera att applikationens automatiska färgläge inaktiveras vid anpassade val.',
      background_colors_title: 'Bakgrund',
      colors_helper_text:
        'Anpassa färgschema så att det matchar organisationens grafiska profil och identitet.',
      colors_title: 'Färger',
      dashboard_color: 'Dashboard',
      negative_color: 'Negativ färg',
      positive_color: 'Positiv färg',
      primary_color: 'Primär',
      profile_colors_title: 'Profil',
      secondary_color: 'Sekundär',
      status_colors_helper_text: (
        <>
          <strong>Tänk på!</strong> Du bör undvika att välja en grön, gul eller
          röd färg i dina anpassade graf- och textfärger ovan. Dessa används
          redan till att indikera positiv eller negativ utveckling i ett
          mätetal, och i vissa fall även som statusindikator.
        </>
      ),
      status_colors_title: 'Status',
      tertiary_color: 'Tertiär',
      text_colors_title: 'Text',
      warning_color: 'Varningsfärg',
      widget_color: 'Widget',
      page_title: 'Anpassa applikationen',
      page_body: 'Hantera färger och logotyp så att de matchar ditt varumärke.',
      logotype: 'Logotyp',
      logotype_helper_text:
        'Lägg till din logotyp för att få applikationen att kännas som er.'
    },

    dashboards: {
      error_not_found_body:
        'Dashboarden du letar efter finns inte eller har tagits bort.',
      error_server_body:
        'Något gick fel när dashboarden skulle hämtas. Försök igen eller gå tillbaka.',
      error_no_access_body:
        'Du har inte behörighet att visa den här dashboarden. Kontakta din administratör för att få åtkomst.',
      error_public_dashboard_body:
        'Dashboarden kunde inte hämtas. Kontrollera att länken är korrekt eller kontakta den som delade den med dig.',
      error_public_widget_body:
        'Widgeten kunde inte hämtas. Kontrollera att länken är korrekt eller kontakta den som delade den med dig.',
      dashboard_not_visible: 'Den här dashboarden visas inte för användare.',
      add_tag: 'Lägg till tagg',
      tags_helper_text:
        'Taggar används för att lägga till extra information om fliken vid inbäddning i tredjepartslösningar, t.ex. sortering eller annan metadata. Taggarna sparas som en lista i flikens custom fields.',
      disabled_preview_widget_tooltip:
        'Det går inte att inkludera widgets som har ytterligare dimensioner eller visar totalen.',
      editing_mode_active: (
        <>
          <b>Du är i redigeringsläge.</b> Alla ändringar uppdateras direkt och
          sparas automatiskt.
        </>
      ),
      editing_mode_limitations: (
        <>
          <b>Begränsad funktionalitet i redigeringsläge</b>
          <br />I redigeringsläge har vi begränsat vissa funktioner som är
          avsedda för visningsläge, exempelvis klickfunktioner i widgets, för
          att göra redigeringen smidigare.
        </>
      ),
      select_dashboard_to_copy_tab:
        'Välj den dashboard som du vill att din flik ska kopieras till.',
      select_dashboard_to_move_tab:
        'Välj den dashboard som du vill att din flik ska flyttas till.',
      move_tab_warning: (
        <>
          <b>Tänk på!</b> Om du flyttar fliken kommer den att försvinna från
          nuvarande dashboard. Även användarstatistik kommer att flyttas med
          till den nya dashboarden.
        </>
      ),
      copying_to_dashboard: 'Kopierar till dashboard',
      moving_to_dashboard: 'Flyttar till dashboard',
      tab_name_required_error: 'Din flik måste ha ett namn.',
      no_access_to_tab: 'Du saknar tillgång till den här fliken.',
      external_access_public: 'Extern åtkomst via publik länk',
      external_access_protected: 'Extern åtkomst via skyddad länk',
      add_tab: 'Lägg till flik',
      tab_not_public: 'Fliken är inte publik',
      copy_tab_public_link: 'Kopiera flikens publika länk',
      cannot_share_draft: 'Utkast kan inte delas',
      tab: 'Flik',
      widget: 'Widget',
      show_info: 'Visa information',
      show_content: 'Visa innehåll',
      dashboard_full: 'Dashboarden är full',
      all_dashboards: 'Alla dashboards',
      empty_dashboards_title: (
        <>
          Inga dashboards... ännu <Emoji name="seedling" />
        </>
      ),
      empty_folder_body: 'Flytta en dashboard till mappen så hamnar den här',
      empty_dashboards_body:
        'Skapa och publicera en dashboard så hamnar den här.',
      empty_drafts_body: 'Dashboards som inte har publicerats hamnar här',
      empty_favorites_body: 'Favoritmarkera en dashboard så hamnar den här',
      empty_favorites_title: (
        <>
          Inga favoriter... ännu <Emoji name="seedling" />
        </>
      ),
      empty_visits_body: 'Besök en dashboard så hamnar den här',
      empty_visits_title: (
        <>
          Inga besökta... ännu <Emoji name="seedling" />
        </>
      ),
      empty_drafts_title: (
        <>
          Inga utkast... ännu <Emoji name="seedling" />
        </>
      ),
      favorites: 'Favoriter',
      folders: 'Mappar',
      to_dashboards: 'Gå till alla dashboards',
      search_for_dashboard: 'Sök efter dashboard',
      create_dashboard: 'Skapa dashboard',
      create_folder: 'Skapa mapp',
      folder_in_folder_tooltip:
        'Det går inte att skapa en mapp i en annan mapp.',
      dashboard_limit_reached_tooltip:
        'Din organisation använder alla dashboards som ingår i er licens. Ta bort en dashboard eller kontakta oss för att utöka din licens.',
      delete_folder_question_title: 'Radera mapp?',
      delete_folder_body_1: 'Din mapp',
      delete_folder_body_2: (
        <>
          kommer att raderas permanent. Dashboards i mappen kommer läggas under{' '}
          <code>Saknar mapp</code>. Är du säker?
        </>
      ),
      sort_by_latest_visit_tooltip: (
        <>
          Sortera efter <b>Senast besökt</b>
        </>
      ),
      sort_by_alphabetical_tooltip: (
        <>
          Sortera efter <b>A-Ö</b>
        </>
      ),
      sort_by_latest_edit_tooltip: (
        <>
          Sortera efter <b>Senast ändrad</b>
        </>
      ),
      remove_from_group: 'Ta bort från grupp',
      select_folder: 'Välj mapp',
      delete_dashboard_title: 'Radera dashboard?',
      duplicate_tag: 'En tagg med det namnet finns redan.',
      favorite_unpublished_tooltip: 'Utkast kan inte favoritmarkeras',
      remove_favorite_tooltip: 'Ta bort från favoriter',
      add_favorite_tooltip: 'Lägg till i favoriter',
      templates_dashboards_title_1: (
        <>
          Utforska dashboards
          <br />
          från
        </>
      ),
      templates_dashboards_title_2: 'fastighetsbolag',
      templates_dashboards_body: (
        <>
          Bläddra bland riktiga dashboards och se hur dina branschkollegor
          följer upp sina verksamheter. Få inspiration, upptäck nya idéer och ta
          nästa steg mot en mer datadriven förvaltning med hjälp av vårt
          community.
        </>
      ),
      get_inspired_title: 'Bli inspirerad 💡',
      get_inspired_body:
        'Utforska exempel på dina branschkollegors mest älskade dashboards.',
      view_in_fullscreen: 'Visa i fullskärm',
      copied_to_clipboard: 'Kopierat till urklipp',
      activate_dashboard: 'Aktivera dashboard',
      activate_dashboard_info:
        'Dashboarden kommer läggas under "Utkast" och endast vara tillgänglig för dig tills du väljer att publicera den.',
      activate_disabled_no_permission:
        'Du har inte behörighet att skapa en ny dashboard. Kontakta er administratör om du behöver hjälp eller vill begära rättigheter.',
      activate_disabled_limit_reached:
        'Din organisation har nått gränsen för antalet dashboards i er licens. Ta bort en befintlig dashboard eller kontakta oss om du vill utöka er licens.',
      activate_disabled_no_access_metrics:
        'Du kan inte aktivera den här dashboarden eftersom den innehåller mätetal du saknar behörighet till. Kontakta en administratör om du behöver åtkomst.',
      activating_dashboard_loading_1: 'Sätter upp dashboarden',
      activating_dashboard_loading_2: 'Anpassar data',
      activate_restricted_period_info:
        'Dashboarden innehåller widgets med inställningen "t.o.m. senaste stängda bokslutsperiod". För att de ska visa rätt data behöver er senaste stängda bokslutsperiod vara inställd.',
      activate_restricted_period_link: 'Ställ in bokslutsperioder',
      activate_restricted_period_no_access:
        'Be en administratör eller ekonomiansvarig att ställa in bokslutsperioder.',
      created_by_homepal: 'Skapad av Homepal',
      created_by_homepal_body:
        'Den här dashboarden är skapad och anpassad av oss på Homepal med vår påhittade demodata. Konceptet och idén kommer från en av våra kunder.',
      created_by_customer_body:
        'Den här dashboarden är skapad av en av våra användare och har skickats in för att delas med branschkollegor. Homepal har granskat och publicerat den med demodata.',
      get_help_activating_dashboard_title: 'Få hjälp att bygga',
      get_help_activating_dashboard_body:
        'Vill du aktivera den här dashboarden i din organisation - men saknar kunskap om att bygga? Skicka en förfrågan så hjälper vi dig!',
      suggest_a_dashboard_title: 'Föreslå en dashboard',
      suggest_a_dashboard_short_title: 'Föreslå',
      submit_a_dashboard_short_title: 'Skicka in',
      suggest_a_dashboard_body:
        'Saknar du ett exempel på en viss typ av dashboard? Eller har du en idé på visualiserad data som du tror att du och dina branschkollegor hade haft nytta av?',
      suggest_a_dashboard_name_placeholder:
        'Ex. Benchmarking av felanmälningar i våra fastigheter',
      suggest_a_dashboard_description_placeholder:
        'Ex. Det hade varit intressant att få inspiration på hur man kan sätta upp en dashboard för att se hur felanmälningar ser ut i våra fastigheter – och framförallt jämföra dem mot varandra. Vilka mätetal och vilka visualiseringar är relevanta?',
      submit_a_dashboard_title: 'Skicka in en dashboard',
      submit_a_dashboard_body:
        'Har du ett exempel på en dashboard som du vill dela med dina branschkollegor? Vi anonymiserar den åt dig och publicerar den sedan här i vår katalog.',
      submit_a_dashboard_motivation_placeholder:
        'Ex. Jag tror att fliken som heter "Felanmälningar" hade kunnat vara väldigt intressant för andra bolag också. Ni får gärna publicera den här med er påhittade data!',
      motivation: 'Motivering',
      why_you_should_use_dashboard_title: 'Varför ska du använda dashboarden?',
      tips: 'Tips!',
      systems_in_use_title: 'Vilka system kan användas?',
      property_management_systems_title: 'Exempel på fastighetssystem',
      other_systems_title: 'Exempel på kompletterande system',
      about_dashboard: 'Om dashboarden',
      about_dashboard_missing: 'Beskrivning saknas...',
      about_dashboard_helper_text:
        'Förklara syftet med dashboarden och hur den ska användas.',
      about_dashboard_placeholder:
        'Ex. Den här dashboarden ger en tydlig överblick över hur mycket hyresintäkter som går förlorade till följd av vakanta lokaler eller outhyrda bostäder. Genom att visualisera de faktiska vakansernas påverkan på intäkterna kan du snabbt identifiera riskområden och möjligheter till förbättringar.\n\nSå här bör du använda dashboarden:\n\t• Total hyresbortfall: Börja med att titta på den totala summan av förlorade hyresintäkter.\n\t• Detta ger en snabb uppfattning om vakansernas påverkan på din verksamhet.\n\t• Vakansgrad per fastighet/område: Identifiera vilka fastigheter eller områden som...',
      name_placeholder: 'Ex. Översikt av hyresbortfall',
      name_helper_text:
        'Ge din dashboard ett namn som är tydligt och som skiljer sig åt från mängden.',
      name_error_text:
        'Din dashboard måste ha ett namn, och inte heta "Namnlös" eller innehålla "Kopia".',
      only_owners_and_added_can_use:
        'Endast ansvariga och tillagda grupper eller användare kan använda dashboarden.',
      user_or_group: 'användare eller grupp',
      cannot_remove_owner:
        'Du kan inte ta bort åtkomst för dashboardens ansvarig',
      cannot_remove_admin: 'Du kan inte ta bort åtkomst för admins',
      remove_access: 'Ta bort åtkomst',
      private_dashboard: 'Privat dashboard',
      access_helper_text: 'Välj hur dashboarden ska delas inom organisationen.',
      owner_helper_text:
        'Välj en ansvarig som hanterar dashboarden och agerar kontaktperson.',
      placement_title: 'Placering',
      placement_helper_text:
        'Placera din dashboard i en mapp så att den blir lätt att hitta.',
      folder_selection_requires_publish_tooltip:
        'Du måste publicera din dashboard innan du kan placera den i en mapp.',
      owner_change_requires_publish_tooltip:
        'Du måste publicera din dashboard innan du kan byta ansvarig.',
      edit_information: 'Redigera information',
      publish_dashboard: 'Publicera dashboard',
      initial_info_note: (
        <>
          <Text gutterBottom={true}>
            Den här informationen visas första gången användaren öppnar
            dashboarden. Därefter nås den via informationsknappen vid
            dashboardens rubrik.
          </Text>
          <Text>
            Det går alltid att redigera det här vid ett senare tillfälle.
          </Text>
        </>
      ),
      sensitive_metrics_note: (
        <Text>
          Det finns mätetal som kan vara känsliga. Tänk på att alla som får
          tillgång till dashboarden kan se dessa.
        </Text>
      ),
      intro_text_part_1: (
        <>
          Den här dashboarden ger dig insikter och data som förhoppningsvis
          underlättar ditt arbete.
          <br />
          Läs mer om vad ansvarig har att säga om
        </>
      ),
      intro_text_part_2: <>nedan:</>,
      delete_widget_title: 'Radera widget?',
      enable_external_access: 'Aktivera extern åtkomst',
      enable_external_access_helper_text:
        'För att kunna bädda in din {{component}} måste du välja en extern åtkomsttyp.',
      embed_link_title: 'Kopiera och klistra in',
      embed_link_helper_text:
        'Använd koden nedan i din tredjepartsapplikation (eller öppna länken direkt i din webbläsare) för att visa din {{component}}. Du kan använda filtret till höger eller inställningarna nedan för att modifiera din kod (eller länk) utifrån dina behov.',
      embed_settings_temporary_notice:
        'De här inställningarna sparas inte permanent utan används tillfälligt för att hjälpa dig lägga till dem i din länk eller ditt kodblock.',
      enable_external_access_to_embed:
        'Aktivera extern åtkomst för att börja bädda in.',
      confirm_change_access_type_title: 'Ändra åtkomsttyp',
      confirm_change_access_type_body:
        'Är du säker på att du vill ändra åtkomsttyp? Din nuvarande länk kommer att sluta fungera.',
      protected_link: 'Skyddad länk',
      protected_link_description:
        'Aktörer med en API-nyckel kan generera en skyddad och tillfällig länk som ger åtkomst till fliken i upp till en timme.',
      public_link: 'Publik länk',
      public_link_description:
        'Alla som har tillgång till den publika länken kan se fliken utan att vara inloggad.',
      auto_description:
        'Det enklaste alternativet. Inbäddningen kommer att ta upp den bredd och höjd som finns tillgänglig.',
      auto_label: 'Automatisk',
      fixed_description:
        'Försäkra dig om att inbäddningen alltid är en viss storlek genom att ställa in bredd och höjd.',
      fixed_label: 'Bestämd storlek',
      responsive_mode_label: 'Responsivt läge',
      responsive_mode_description:
        'Låter inbäddningen övergå till mobilt läge vid sin brytpunkt.',
      breakpoint_description:
        'Ange vid vilken bredd inbäddningen ska övergå i mobilt läge.',
      breakpoint_requirement_note: (
        <>
          Kräver att <b>Mobil</b> är aktiverat som responsivt läge.
        </>
      ),
      breakpoint_label: 'Brytpunkt',
      functionality_label: 'Funktionalitet',
      user_filter_description:
        'Låter användaren få tillgång till inbäddningens användarfilter.',
      user_filter_label: 'Användarfilter',
      image_export_description:
        'Låter användaren exportera inbäddningen som en bild.',
      image_export_label: 'Bildexport',
      hide_footer_description:
        'Ger dig en avskalad variant av inbäddningen utan sidfot.',
      hide_footer_label: 'Dölj sidfot',
      auto_refresh_description:
        'Laddar om sidan automatiskt, avsett för skärmar som står uppe länge utan att någon rör dem.',
      auto_refresh_label: 'Uppdatera automatiskt',
      auto_refresh_mode_label: 'Läge',
      auto_refresh_mode_description:
        'Underliggande data uppdateras normalt under natten, så ett klockslag på morgonen ger färska siffror hela dagen med en enda omladdning.',
      auto_refresh_mode_clock: 'Klockslag',
      auto_refresh_mode_interval: 'Intervall',
      auto_refresh_clock_description:
        'Sidan laddas om vid det här klockslaget varje dygn, enligt skärmens egen tid.',
      auto_refresh_clock_label: 'Tidpunkt',
      auto_refresh_interval_description:
        'Hur ofta sidan laddas om. Kortare intervall än tio minuter är inte tillåtna.',
      auto_refresh_interval_label: 'Intervall',
      auto_refresh_requirement_note:
        'Kräver att automatisk uppdatering är påslagen.',
      auto_refresh_option_10_minutes: 'Var tionde minut',
      auto_refresh_option_30_minutes: 'Var trettionde minut',
      auto_refresh_option_hourly: 'Varje timme',
      auto_refresh_option_2_hours: 'Varannan timme',
      auto_refresh_option_4_hours: 'Var fjärde timme',
      auto_refresh_option_12_hours: 'Var tolfte timme',
      temporary_settings_notice:
        'De här inställningarna sparas inte permanent utan används tillfälligt för att hjälpa dig lägga till dem i din länk.',
      filter_parameters_intro:
        'Lägg till parametrar i din länk för att dynamiskt filtrera din inbäddning.',
      can_i_filter_more_question: 'Kan jag filtrera på fler saker?',
      filter_limitations_info_1:
        'Du har endast tillgång till samma filter som dashboarden har i sin högra sidomeny.',
      filter_limitations_info_2:
        'Du behöver alltså lägga till ett filter där för att det ska gå att använda här.',
      private_embed_label: 'Privat inbäddning',
      token_instruction: (
        <>
          <code>YOUR_TOKEN</code> måste ersättas av den token du får från din
          API-förfrågan ovan.
        </>
      ),
      copy_embed_code: 'Kopiera inbäddningskod',
      copy_embed_link: 'Kopiera inbäddningslänk',
      // API details
      generate_temporary_link: 'Generera tillfällig länk',
      generate_temporary_link_helper:
        'Använd informationen nedan för att generera en tillfällig länk som ger åtkomst till fliken i upp till en timme. Länken finns i svaret du får från din API-förfrågan.',
      key: 'Nyckel',
      required: 'Obligatorisk',
      query_parameter: 'Query parameter',
      header: 'Header',
      create_manage_company_groups: 'Skapa och hantera kunder under',
      create_manage_api_keys: 'Skapa och hantera API-nycklar under',
      companies: 'Bolag',
      api_keys: 'API-nycklar',
      include_widgets: 'Inkludera widgets',
      include_widgets_helper:
        'Du kan välja att inkludera specifika widgets i svaret du får från API-förfrågan ovan. T.ex. för att kunna skapa en anpassad förhandsvisning i en tredjepartsapplikation.'
    },

    reports: {
      all_reports: 'Alla rapporter',
      create_report: 'Skapa rapport',
      description_placeholder: 'Den här rapporten fokuserar på...',
      empty_filters_body:
        'Lägg till ett eller flera filter som kan användas när en utgåva skapas.',
      empty_filters_cta: 'Lägg till filter',
      empty_filters_title: (
        <>
          Inga filter... ännu <Emoji name="seedling" />
        </>
      ),
      empty_reports_body: 'Skapa och publicera en rapport så hamnar den här.',
      empty_reports_title: 'Inga rapporter... ännu',
      empty_widgets_body:
        'Forma din rapportmall genom att börja lägga till widgets.',
      empty_widgets_cta: 'Lägg till widget',
      empty_widgets_title: (
        <>
          Inga widgets... ännu <Emoji name="seedling" />
        </>
      ),
      empty_editions_body: 'Skapa en utgåva från den aktuella rapportmallen.',
      empty_editions_title: (
        <>
          Inga utgåvor... ännu <Emoji name="seedling" />
        </>
      ),
      go_to_template: 'Gå till mall',
      reports: 'Rapporter'
    },

    report_edition: {
      configure_data: 'Konfigurera data',
      content_edited: 'Innehåll redigerat',
      data_locked: 'Data låst',
      edit_content: 'Redigera innehåll',
      lock_data: 'Lås data',
      lock_data_and_edit: 'Lås data och redigera innehåll',
      set_period_and_filters:
        'Ange tidsperiod och filter för databilden. Lås sedan datan för att kunna börja redigera innehåll.',
      set_numbers_and_content: (
        <>
          Klicka på element i diagrammen för att ändra dess värde, eller
          redigera textblocken direkt. Kom tillbaka hit när du är klar för att
          fortsätta till nästa steg.
        </>
      ),
      unlock: 'Lås upp',
      you_can_now_edit: 'Scrolla ned för att redigera diagram och text',
      title_helper_text: (
        <>
          Ge utgåvan en beskrivande titel, t.ex. &quot;Q1 2026 (Norr)&quot;.
          Publicera för att göra den tillgänglig för andra användare.
        </>
      ),
      previously_used_text_field: 'Tidigare använt textfältet',
      generate_text_from_ai: 'Generera text från AI',
      insert_text_from_placeholder: 'Infoga text från...',
      insert_text_from_previous_edition:
        'Välj en utgåva och kopiera in dess text som startpunkt.',
      lock_dialog_body:
        'Vald period och filter låses. Det här går inte att ångra.',
      locking_data: 'Låser data',
      edit_columns_locked: 'Kan inte redigera kolumner när utgåvan är låst',
      publishing: 'Publicerar',
      publish_dialog_body:
        'Den här utgåvan blir synlig för alla användare i din organisation.'
    },

    export_tables: {
      table: 'Tabell',
      tables: 'Tabeller',
      all_tables: 'Alla tabeller',
      choose_metric: 'Välj mätetal',
      // API sharing
      api_access_title: 'API-åtkomst',
      api_access_helper:
        'Gör tabellen tillgänglig som ett API-anrop för externa system och integrationer.',
      available_via_api: 'Tillgänglig via API',
      available_via_api_body:
        'Externa system med en giltig API-nyckel kan hämta tabellens data i JSON-format.',
      endpoint_title: 'Endpoint',
      endpoint_helper:
        'Den fullständiga URL:en som används för att hämta data.',
      endpoint_auth_helper:
        'Inkludera din API-nyckel i Authorization-headern vid anrop.',
      copy_endpoint: 'Kopiera endpoint',
      edit_slug: 'Ändra slug',
      authorized_api_keys_title: 'Behöriga API-nycklar',
      authorized_api_keys_helper:
        'Endast valda API-nycklar har behörighet att hämta data från denna tabell.',
      add_api_key: 'Lägg till API-nyckel',
      create_api_key: 'Skapa ny API-nyckel',
      remove_api_key: 'Ta bort åtkomst',
      // API key dialog (reverse)
      authorized_export_tables_title: 'Behöriga tabeller',
      authorized_export_tables_helper:
        'Endast valda tabeller kan hämtas med denna API-nyckel.',
      add_export_table: 'Lägg till tabell',
      remove_export_table: 'Ta bort åtkomst',
      // Slug dialog
      activate_api: 'Aktivera API',
      slug_change_warning:
        'Att ändra slug innebär att befintliga integrationer som använder den nuvarande endpoint-URL:en slutar fungera.',
      slug_helper:
        'Slug är den unika identifieraren i URL:en. Använd endast små bokstäver (a-z) och bindestreck (-).',
      choose_slug: 'Välj slug',
      new_slug: 'Ny slug',
      slug_empty_error:
        'Slug kan inte vara tom. Använd endast a-z och bindestreck (-).',
      slug_taken_error: 'Denna slug används redan. Välj en annan.',
      slug_invalid_error: 'Slug får endast innehålla a-z och bindestreck (-).',
      preview_title: 'Förhandsvisning',
      preview_helper: 'Så här kommer den fullständiga URL:en att se ut.',
      no_access_body:
        'Du har inte behörighet att använda Tabeller. Kontakta din administratör för att få åtkomst.'
    },

    groups: {
      notify_users_title: 'Notifiera användarna',
      notify_users_body:
        'Användarna kommer att meddelas via e-post om att de har blivit inbjudna till gruppen.',
      delete_group: 'Radera grupp',
      access_helper_text:
        'Ange ifall gruppens innehåll ska vara privat och dolt för organisationen.',
      access_requested: 'Åtkomst begärd',
      all_groups: 'Alla grupper',
      create_group: 'Skapa grupp',
      delete_group_helper_text:
        'Radera din grupp permanent från organisationen. Det här kan inte ångras.',
      duplicate_group_name_error: 'En grupp med det namnet finns redan.',
      edit_group: 'Redigera grupp',
      empty_group_name_error: 'En grupp måste ha en titel.',
      my_groups_title: 'Mina grupper',
      name_group_input_placeholder: 'Ex. Uthyrare',
      name_helper_text:
        'Ge din grupp ett namn som är tydligt och som skiljer sig åt från mängden.',
      name_error_text:
        'Din dashboard måste ha ett namn, och inte heta "Namnlös" eller innehålla "Kopia".',
      no_dashboards_body:
        'Gå till en dashboard och bjud in den här gruppen så hamnar dashboarden här.',
      no_dashboards_title: 'Inga dashboards... ännu',
      no_groups_title: 'Du är inte en medlem av någon grupp ännu.',
      no_other_groups_title: 'Det finns inte några fler grupper.',
      no_content_body:
        'Lägg till nyckeltal eller resurser för en grupp så syns de här.',
      no_content_title: 'Inget innehåll... ännu',
      no_key_metrics_body:
        'Gå till organisationens nyckeltal och lägg till gruppen i ett nyckeltal, så visas det här.',
      no_key_metrics_title: 'Inga nyckeltal... ännu',
      no_metrics_body:
        'Redigera gruppen för att lägga till ett eller flera mätetal här.',
      no_metrics_title: 'Inga mätetal... ännu',
      other_groups_title: 'Andra grupper',
      color_title: 'Profil',
      color_helper_text:
        'Ge gruppens profil en färg så att den enkelt känns igen.',
      group_owner_helper_text:
        'Välj en ansvarig ägare som hanterar gruppen och agerar kontaktperson.',
      private_group_title: 'Privat grupp',
      private_group_helper_text:
        'Endast ansvarig och tillagda användare kan se gruppens innehåll.',
      visibility_title: 'Visning',
      visibility_helper_text:
        'Ange ifall gruppens innehåll ska synas på användarnas hemskärm.',
      show_on_home_title: 'Visa på hemskärm',
      show_on_home_helper_text:
        'Tillagda användare ser gruppens innehåll på sin hemskärm.',
      no_owner_error: (
        <>
          En grupp måste ha <u>minst en</u> ansvarig.
        </>
      ),
      private: 'Privat',
      visible_on_home: 'Visas på hemskärm',
      no_members: 'Inga medlemmar',
      no_requests: 'Ingen förfrågningar... ännu',
      requests: 'Förfrågningar',
      members: 'Medlemmar',
      make_owner: 'Gör till ansvarig',
      remove_from_group: 'Ta bort från grupp',
      make_member: 'Gör till vanlig medlem',
      accept_request: 'Acceptera förfrågan',
      decline_request: 'Avböj förfrågan',
      no_owner_infotip: 'Du måste ha minst en ansvarig kvar i gruppen',
      request_access: 'Begär åtkomst',
      one_owner_required_tooltip: 'Det går ej att lämna som ensam ansvarig',
      invite_members: 'Bjud in medlemmar',
      expand_group: 'Utöka din grupp',
      by_inviting_more_members: 'genom att bjuda in fler medlemmar.',
      group: 'Grupp',
      to_group: 'Gå till grupp',
      key_metrics_helper_text:
        'Strategiska och operativa nyckeltal från organisationen som den här gruppen arbetar mot.',
      metrics_helper_text:
        'Kompletterande mätetal som den här gruppen följer utöver organisationens utvalda nyckeltal.',
      resources_helper_text:
        'Resurser som delas med den här gruppen för att stödja arbetet mot att förbättra nyckeltalen.',
      no_resources_title: 'Inga resurser... ännu',
      no_resources_body:
        'Gå till en dashboard och bjud in den här gruppen så hamnar dashboarden här.',
      no_resources_cta: 'Gå till dashboards'
    },

    activity_overview: {
      activity_overview: 'Aktivitetsöversikt',
      drafts_have_no_activity: 'Utkast har ingen aktivitet',
      ranking: 'Ranking',
      views_helper_text: 'Totalt antal visningar i dashboarden',
      users_helper_text:
        'Unika användare som någon gång har öppnat dashboarden',
      ranking_helper_text:
        'Baserat på antal visningar jämfört med andra dashboards',
      basic_checklist: 'Grundläggande checklista',
      basic_checklist_description:
        'Ge din dashboard förutsättningar att lyckas genom att checka av de mest grundläggande sakerna.',
      valid_dashboard_title: 'Dashboarden har en riktig titel',
      valid_dashboard_title_helper: (
        <>
          Se till att din dashboard inte heter &quot;Namnlös&quot; eller
          innehåller ord så som &quot;Test&quot; och &quot;Kopia&quot;.
        </>
      ),
      valid_tab_titles: 'Alla flikar har riktiga titlar',
      valid_tab_titles_helper: (
        <>
          Se till att dina flikar inte heter &quot;Namnlös&quot; eller
          innehåller ord så som &quot;Test&quot; och &quot;Kopia&quot;.
        </>
      ),
      max_tabs: 'Max 3 flikar',
      max_tabs_helper: (
        <>
          Vi rekommenderar att undvika flikar{' '}
          <u>om målet är att öka användaraktiviteten</u>. Skapa istället
          relevanta användarfilter för att ge varje sin specifika vy. Om du ändå
          vill använda flikar, försök att hålla antalet till 2-3 stycken.
        </>
      ),
      max_widgets: 'Max 10 widgets',
      max_widgets_helper: (
        <>
          Om du har många widgets har du troligen inte fokuserat på det mest
          väsentliga. Det kan då bli svårt för användaren att veta vad de ska
          fokusera på.
        </>
      ),
      recommendations_title: '10 rekommendationer',
      recommendations_description:
        'Att bygga en användarvänlig dashboard är inte så lätt. Nedan har vi listat några saker att tänka på.',
      clarity_title: 'Var tydlig med vad du vill uppnå',
      clarity_body:
        'Syftet med din dashboard styr dess design. Se till att du har ett fokus och ett syfte innan du faktiskt börjar bygga.',
      focus_title: 'Inkludera endast det som är viktigt',
      focus_body:
        'Allt ska stödja dashboardens avsikt. Skala hellre bort saker så att det som är viktigt framhävs.',
      data_ink_title: 'Tänk på "data-bläck"-förhållandet',
      data_ink_body:
        'Undvik dekorativa element och för mycket text som inte förmedlar data. Ögat ska dras till mäte- och nyckeltalen.',
      rounding_title: 'Avrunda dina siffror',
      rounding_body: 'Att vara alltför exakt kan skymma viktiga förändringar.',
      grouping_title: 'Gruppera relaterade mått',
      grouping_body: 'Gör dina mätetal lätta att hitta.',
      consistency_title: 'Var konsekvent',
      consistency_body:
        'Använd samma visualiseringar och layout för att underlätta jämförelse.',
      hierarchy_title: 'Använd storlek och position för att visa hierarki',
      hierarchy_body: 'Gör det tydligt för tittaren vad som är viktigast.',
      context_title: 'Ge dina siffror sammanhang',
      context_body:
        'Hjälp tittarna att avgöra om ett tal är bra, dåligt, normalt eller ovanligt.',
      labels_title: 'Använd tydliga etiketter för din målgrupp',
      labels_body: 'Håll dem korta och självförklarande.',
      human_title: 'Kom ihåg att det är för människor',
      human_body: 'Det är okej att bryta regler om det ökar engagemanget.',
      over_time_per_day: 'Över tid per dag',
      total_per_tab: 'Totalt per flik',
      views_per_tab: 'Visningar per flik',
      no_activity: 'Ingen aktivitet',
      latest_activity: 'Senaste aktivitet'
    },

    home: {
      good_morning: 'Godmorgon',
      good_afternoon: 'God eftermiddag',
      good_evening: 'Godkväll',
      good_night: 'Godnatt',
      help: 'Hjälp',
      knowledge_center: 'Kunskapscenter',
      live_chat_body:
        'Du har väl inte missat vår livechatt nere i högra hörnet?',
      live_chat_title: 'Livechatt',
      recently_visited: 'Senaste besökta',
      updated_stats_for: 'Här är din uppdaterade statistik för',
      quick_links: 'Snabblänkar för att hjälpa dig hitta'
    },

    entities: {
      error_not_found_body:
        'Entiteten du letar efter finns inte eller har tagits bort.',
      exit_editing_to_view: 'Avsluta redigeringsläge för att visa...',
      slice: 'Skärning',
      use_slice: 'Använd skärning',
      slice_helper_text:
        'Välj en eller flera skärningar ifall du endast vill använda en viss del av mätetalet.',
      multiple_slices_warning_body: (
        <>
          Vid val av flera skärningar måste alla skärningar uppfyllas{' '}
          <u>samtidigt</u>. Använd bara flera skärningar om du vet att
          kombinationen fungerar så att de inte motarbetar varandra.
        </>
      ),
      use_predefined_calculation: 'Använd fördefinierad beräkning',
      predefined_calculation_helper_text:
        'Välj en fördefinierad beräkning för att få fram ett jämförelsetal för mätetalet. Det här går att göra på ekonomiska mätetal.',
      all_entities: 'Alla entiteter',
      entity: 'Entitet',
      entities: 'Entiteter',
      slices: 'Skärningar',
      filter_in_use: 'används i flera mätetal',
      slice_in_use: 'används i flera mätetal och kan ej tas bort',
      no_slices_yet: 'Det finns inga skärningar ännu.',
      slice_not_supported_by_metric:
        'Mätetalet stödjer inte den här skärningen.',
      metric_slice_helper_text:
        'Använd en färdig skärning för att endast fokusera på en specifik del av mätetalet. Skärningar definieras globalt av administratörer så att effekten blir densamma överallt.',
      properties: 'Egenskaper',
      properties_column_description:
        'Välj vilka egenskaper som ska visas i form av kolumner då poster av entiteten öppnas upp i en tabell.',
      slices_definition_description:
        'Definiera skärningar för att snabbt och enkelt kunna fokusera på en specifik del poster av entiteten.',
      terminology_description: (
        <>
          Anpassa terminologi så att det matchar de benämningar som används i er
          organisation.
          <br />
          <i>Om inget annat anges så används Homepals standard.</i>
        </>
      ),
      no_terms_to_customize: 'Det finns inga benämningar att ändra ännu.',
      dim_only_notice:
        'Entiteten stödjer ej anpassning av kolumner eller skärningar',
      metric_dependency_description:
        'Håll reda på vilka mätetal som använder sig av entiteten när deras innehåll visas i tabellform.',
      default_columns_description: (
        <>
          Välj vilka kolumner som ska vara standard då en användare öppnar upp
          ett mätetal för att visa dess innehåll.
          <br />
          En användare kan alltid lägga till fler kolumner när innehåll visas.
        </>
      ),
      add_column: 'Lägg till kolumn',
      locked_columns_info:
        'En del kolumner är väsentliga för vissa mätetal och kommer därför alltid visas (oavsett val ovan) för de mätetal det rör.',
      no_locked_columns: 'Det finns inga låsta kolumner ännu.',
      standard_slices_required_info: (
        <>
          För att kunna aktivera färdiga exempel från våra kataloger behöver
          standardskärningar vara konfigurerade.
          <br />
          <i>
            Det krävs även för att kunna använda vissa standardjämförelser på
            mätetal.
          </i>
        </>
      ),
      no_standard_slices: 'Det finns inga standard skärningar ännu.',
      custom_slices_info:
        'Det går att skapa egna anpassade skärningar för att underlätta filtreringar i verktyget och skapa en global samsyn.',
      custom_financial_slices_info:
        'Det går att skapa egna ekonomiska skärningar för att underlätta filtreringar i verktyget och skapa en global samsyn.',
      add_slice: 'Lägg till skärning',
      create_slice: 'Skapa skärning',
      configure_slices: 'Konfigurera skärningar',
      edit_slices: 'Redigera skärningar',
      duplicate_slice_error: 'En skärning med det namnet finns redan',
      no_custom_slices: 'Det finns inga anpassade skärningar ännu.',
      not_configured: 'Inte konfigurerad',
      not_ready: 'Ej klar',
      terminology: 'Terminologi',
      available_slices: 'Tillgängliga skärningar',
      used_not_configured: 'Använda, ej konfigurerade',
      used_not_configured_helper_text:
        'Dessa skärningar används av widgeten men är inte konfigurerade. Ta bort dem eller konfigurera dem för att widgeten ska fungera korrekt.'
    },

    date_filters: {
      point_in_time: 'Tidpunkt',
      time_period: 'Tidsperiod',
      financial_year: 'Verksamhetsår',
      long_forecast_not_applicable:
        'Extra långa prognoser beräknas endast för ett fåtal mätetal. Inget mätetal som används i visualiseringen beräknar extra lång prognos.',
      long_forecast_includes: 'Extra lång prognos innefattar:',
      long_forecast_use_other:
        'För en mer tillförlitligt analys bör du använda en annan prognos.',
      long_forecast_missing: 'Extra lång prognos saknas för mätetal',
      latest_day_in: 'Senaste dagen i',
      until_latest_closed_accounting_period:
        't.o.m. senaste stängda bokslutsperiod'
    },

    filters: {
      choose_filter_first: 'Välj vad du vill filtrera på först',
      condition: 'Villkor',
      duplicate_filter_name_error:
        'Det finns redan ett sparat filter med det här namnet.',
      save_filter: 'Spara filter',
      no_filters: 'Inga filter',
      add_filter: 'Lägg till filter',
      add_to_filters: 'Lägg till i filter',
      filter: 'Filter',
      filters: 'Filter',
      edit_filters: 'Redigera filter',
      no_saved_filters: 'Du har inga sparade filter.',
      unavailable_filters_title: 'Ej tillgängliga',
      unavailable_filters_description:
        'De sparade filtren som visas här kan inte användas eftersom de innehåller filter som inte är tillgängliga på just den här dashboarden.',
      unavailable_filters_reason_title: 'Det kan bero på att:',
      unavailable_filters_reason_description: (
        <ul className="ul">
          <li className="li">Filtret skapades på en annan dashboard.</li>
          <li className="li">
            Ägaren har tagit bort det filteralternativ som användes.
          </li>
        </ul>
      ),
      unavailable_filters_instruction:
        'För att använda ett giltigt filter, skapa ett nytt eller välj ett som är tillgängligt för den här dashboarden.',
      filter_group: 'Filtergrupp',
      or: 'eller',
      no_active_filters: 'Det finns inga aktiva filter.',
      new_filter: 'Nytt filter',
      add_filter_group: 'Lägg till en filtergrupp',
      all_criteria_met_prefix: 'Visar data där',
      all: 'alla',
      criteria_met_suffix: 'av ovanstående kriterier uppfylls.',
      want_any_criteria_prefix: 'Vill du visa data där endast',
      one_of: 'ett av',
      criteria_question_suffix: 'kriterierna uppfylls?',
      filter_on: 'Filtrera på',
      is_empty: 'Är tom',
      select_condition: 'Välj villkor',
      value: 'Värde',
      select_x: 'Välj {{name}}',
      filter_group_edit_helper_text:
        'Du kan redigera värdena för filter i en filtergrupp. Ifall du däremot vill ändra strukturen på filtergruppen behöver du radera den och skapa en ny.',
      filter_edit_helper_text:
        'Du kan redigera värdena för ett filter. Ifall du däremot vill ändra attribut eller villkor behöver du radera filtret och skapa ett nytt.',
      group_dialog_content:
        'De filter du lägger till här kommer bilda en filtergrupp där endast ett av kriterierna behöver uppfyllas.'
    },

    metrics: {
      select_metric: 'Välj mätetal',
      metric_in_use: 'Mätetalet används och går därför inte att ta bort',
      remove_definition: 'Ta bort definition',
      remove_definition_title: 'Ta bort definition?',
      remove_definition_body:
        'Formeln tas bort och mätetalet blir okonfigurerat igen. Widgets som använder mätetalet, och andra ekonomiska mätetal som räknar med det, kan inte visa data förrän en ny formel är definierad.',
      standard_metric_locked:
        'Mätetalet är en del av Homepals standard och går inte att ta bort eller ändra',
      metric_combination_filter_description:
        'Visar endast de mätetal som går att kombinera med det primära mätetalet i din widget.',
      metric_variant_option_filter_description:
        'Widgeten visar jämförelsetal, så bara anpassade ekonomiska mätetal går att lägga till. Ta bort jämförelsetalen för att lägga till andra mätetal.',
      add_metric: 'Lägg till mätetal',
      edit_metric: 'Redigera mätetal',
      edit_mode_disabled_no_data:
        'Redigeringsläge är inaktiverat eftersom organisationen saknar data',
      visible_to_users: 'Mätetalet kan visas och användas av användare.',
      activated_metric: 'Aktiverat mätetal',
      activate_metric: 'Aktivera mätetal',
      deactivate_metric: 'Inaktivera mätetal',
      delete_metric: 'Radera mätetal',
      all_metrics: 'Alla mätetal',
      metric: 'Mätetal',
      metrics: 'Mätetal',
      no_metrics_match: 'Hittade inga mätetal som matchade',
      no_metrics_available: 'Inga mätetal går att lägga till just nu.',
      rolling_sum: 'Rullande summa',
      rolling_sum_helper_text:
        'Bestäm hur långt bak i tiden värdet för varje punkt ska summeras. En rullande summa gör det lättare att följa utvecklingen långsiktigt.',
      rolling_sums: 'Rullande summor',
      rolling_sums_empty_title: 'Det finns inga rullande summor',
      calculation: 'Uträkning',
      calculation_helper_text:
        'Välj en fördefinierad beräkning för att få fram ett jämförelsetal för mätetalet. Gäller endast ekonomiska mätetal.',
      variant: 'Jämförelsetal',
      variant_helper_text:
        'Välj vilket jämförelsetal för mätetalet du vill visa, till exempel utfall, budget eller avvikelse mot budget.',
      distribution: 'Fördelning',
      distribution_helper_text:
        'Fördela värdet per vald enhet för att göra det enklare att jämföra, eller följa ett bestånd som förändras, på ett rättvist sätt.',
      distributions: 'Fördelningar',
      no_comparison_variants_yet: 'Det finns inga fördelningar ännu.',
      custom_economy_metric_info:
        'Det här är ett anpassat ekonomiskt mätetal. Entitet, skärningar, rullande summor och fördelningar kan variera beroende på valt jämförelsetal.',
      custom_economy_availability_tooltip:
        'Ekonomiska mätetals tillgänglighet styrs av er systemadministratör via inställningar > ekonomi.',
      missing_slices_tooltip:
        'Mätetalet kan aktiveras när dessa skärningar är konfigurerade',
      definition_slices_title: 'Skärningar i definitionen',
      definition_slices_helper:
        'Mätetalet räknas ut över dessa skärningar och kan inte beräknas utan dem.',
      missing_slices_dialog_helper:
        'Mätetalet är definierat över dessa skärningar. Ange villkoren här för att kunna använda mätetalet.',
      missing_slices_dialog_helper_reader:
        'Mätetalet är definierat över dessa skärningar. Kontakta er systemadministratör för att få dem konfigurerade.',
      missing_slices_action: 'Konfigurera skärningar',
      missing_definition_body:
        'Mätetalet kan användas när formeln är definierad.',
      missing_definition_body_reader:
        'Er organisation har inte definierat formeln för mätetalet. Kontakta er systemadministratör för att få den definierad.',
      missing_definition_action: 'Definiera mätetalet',
      availability_title: 'Tillgänglighet',
      availability_description:
        'Ange ifall mätetalet ska vara aktiverat och tillgängligt för organisationen.',
      not_visible_to_users:
        'Mätetalet kan inte visas eller användas av användare.',
      inactive_metric: 'Inaktivt mätetal',
      inactive_metric_description:
        'Mätetalet kommer inte att synas i organisationens mätetalskatalog.',
      inactive_widgets_warning:
        'Alla widgets som använder mätetalet kommer tillfälligt markeras som inaktiva till dess att det tas bort från widgeten.',
      active_metric_description:
        'Mätetalet kommer att synas i organisationens mätetalskatalog.',
      access_description:
        'Ange ifall mätetalet ska vara privat och dolt för organisationen.',
      private_metric_description:
        'Endast ansvarig och tillagda grupper eller användare kan använda mätetalet.',
      private_metric: 'Privat mätetal',
      add_user_or_group: 'Lägg till användare eller grupp',
      filters_title: 'Filter',
      filters_description:
        'Lägg till filter för att få en korrekt bild av ditt mätetal. De filter som läggs till här appliceras automatiskt i hela verktyget.',
      new_metrics_info_text:
        'Vi har släppt nya mätetal. Som administratör kan du aktivera dem för er organisation så att alla får tillgång. Se listan nedan och välj vilka ni vill slå på.',
      new_metrics_title: 'Nya mätetal att aktivera',
      show_all_x_metrics: 'Visa alla {{count}} mätetal',
      no_access: 'Du saknar åtkomst till detta mätetal',
      is_private: 'Det här mätetalet är privat',
      requires_configuration: 'Det här mätetalet kräver konfiguration',
      unit_mismatch:
        'Mätetalets basenhet är inte den samma som det primära mätetalets.',
      unit_warning:
        'För vald visualiseringstyp är det inte rekommenderat att kombinera olika enheter.',
      no_data_title: (
        <>
          Ingen data... ännu <Emoji name="seedling" />
        </>
      ),
      no_data_body: (
        <>Kontakta oss för att koppla på rätt data för det här mätetalet.</>
      ),
      locked_body:
        'För att se innehållet i ett privat mätetal behöver du eller en av dina grupper vara inbjuden.',
      slices_helper_text:
        'Visa endast en specifik och fördefinierad del av värdet för att fokusera på det som är mest relevant.',
      skip_and_add_default: 'Hoppa över alla steg och lägg till direkt'
    },

    key_metrics: {
      add_title: 'Lägg till nyckeltal',
      add_operational_title: 'Lägg till relaterat nyckeltal',
      add_operational_body:
        'Välj ett relaterat nyckeltal som bidrar till ditt strategiska nyckeltal.',
      add_strategic_title: 'Lägg till strategiskt nyckeltal',
      add_strategic_body:
        'Välj ett mätetal som ledningsgrupp och styrelse kan använda för att följa upp målet.',
      edit_title:
        'Redigera för att välja nyckeltal som organisationen kan följa och som grupper kan arbeta mot.',
      key_metric: 'Nyckeltal',
      key_metrics: 'Nyckeltal',
      key_metrics_helper_text:
        'Lägg till nyckeltal för att kunna följa upp och arbeta mot organisationens mål.',
      to_key_metrics: 'Gå till alla nyckeltal',
      delete_key_metric: 'Radera nyckeltal',
      delete_key_metric_note:
        'Alla relaterade nyckeltal kommer också att raderas.',
      metric_unavailable: 'Mätetalet är ej tillgängligt längre',
      updated_stats_for: 'Här är organisationens uppdaterade nyckeltal för',
      no_groups_title: (
        <>
          Inga grupper... ännu <Emoji name="seedling" />
        </>
      ),
      no_groups_body: 'Lägg till grupper som bidrar till det här nyckeltalet.',
      no_resources_title: (
        <>
          Inga resurser... ännu <Emoji name="seedling" />
        </>
      ),
      no_resources_body:
        'Lägg till resurser som är länkade till det här nyckeltalet.',
      groups_title: 'Grupper som bidrar',
      groups_helper_text:
        'Se vilka grupper som medverkar och bidrar till det här nyckeltalet i sitt operativa arbete.',
      change_to_synchronized_metric: 'Ändra till synkroniserat mätetal',
      connection_title: 'Strategisk koppling',
      connection_helper_text:
        'Se vad du påverkar genom att arbeta med det här nyckeltalet.',
      use_synchronized_metric: 'Vill du använda ett synkroniserat mätetal?',
      pin_comment_placeholder: 'Lägg till en kommentar...',
      target: 'Mål',
      budget: 'Budget',
      budget_target_title: 'Mål baserat på budget.',
      budget_target_body:
        'Målet för det här nyckeltalet kommer att vara det synkroniserade budgetvärdet.',
      no_comments_title: (
        <>
          Inga kommentarer... ännu <Emoji name="seedling" />
        </>
      ),
      no_comments_body:
        'Klicka på ett segment i tidslinjen för att lägga till en kommentar.'
    },

    tasks: {
      add_subtask: 'Lägg till delaktivitet',
      completed: 'Avslutad',
      deadline: 'Deadline',
      edit_subtask: 'Redigera delaktivitet',
      no_deadline: 'Ingen deadline',
      not_completed: 'Ej avslutad',
      not_started: 'Ej påbörjad',
      remove_deadline: 'Ta bort deadline',
      started: 'Påbörjad',
      subtask: 'Delaktivitet',
      subtasks: 'Delaktiviteter',
      the_subtask: 'Delaktiviteten',
      the_task: 'Aktiviteten',
      tasks: 'Aktiviteter',
      open_tasks: 'Öppna aktiviteter',
      empty_title: (
        <>
          Inga aktiviteter... ännu <Emoji name="seedling" />
        </>
      ),
      empty_body: 'Skapa en aktivitet för att börja följa upp ditt arbete.',
      linked_key_metric: 'Länkat nyckeltal',
      linked_key_metric_helper_text:
        'Länka ett nyckeltal till aktiviteten för att följa upp resultatet.',
      followed_up_metric: 'Mätetal',
      followed_up_metric_helper_text:
        'Mätetalet följs upp för den valda fastigheten och är förvalt utifrån ' +
        'analysen.',
      task: 'Aktivitet',
      no_groups: 'Inga grupper',
      add_date: 'Lägg till datum',
      movement_title: 'Förflyttning',
      start_value: 'Startvärde',
      target_value: 'Målvärde',
      estimated_result: 'Uppskattat resultat',
      estimated_result_helper:
        'Förändring av Driftnetto (kr) baserat på ovan angivet målvärde.',
      key_metric_timeline_note:
        'Aktiviteten visas på nyckeltalets tidslinje först när den markerats som klar.',
      write_description_placeholder: 'Skriv en beskrivning...',
      title_placeholder: 'Sammanfatta din aktivitet...',
      create_task: 'Skapa aktivitet',
      edit_task: 'Redigera aktivitet',
      status: 'Status',
      properties: 'Egenskaper',
      create_from_analysis_title: 'Skapa aktiviteter',
      subtask_placeholder: 'Beskriv din delaktivitet...',
      view_all_tasks: 'Se alla aktiviteter'
    },

    analysis_types: {
      analysis_type: 'Analyspaket',
      analysis_types: 'Analyspaket',
      search_placeholder: 'Sök efter analyspaket',
      no_runs: 'Inga körningar',
      no_follow_up: 'Uppföljning saknas',
      run_analysis: 'Kör analys',
      availability_title: 'Tillgänglighet',
      availability_description:
        'Ange ifall analyspaketet ska vara aktiverad för organisationen.',
      activated_analysis_type: 'Aktiverat analyspaket',
      activated_analysis_type_body:
        'Visa paketet i översikten och låt alla med tillgång köra analysen när de vill.',
      activate_analysis_type: 'Aktivera analyspaket',
      deactivate_analysis_type: 'Inaktivera analyspaket',
      activate_analysis_type_confirm:
        'Analyspaketet syns i Översikten och kan köras. Är du säker?',
      deactivate_analysis_type_confirm:
        'Analyspaketet försvinner från Översikten och kan inte köras. ' +
        'Analyser och aktiviteter finns kvar. Är du säker?',
      last_run: 'Körd {{date}}',
      promo_title: 'Öka driftnettot med fler analyspaket',
      promo_body:
        'Det finns ytterligare {{count}} analyspaket i vårt sortiment för att driva ' +
        'arbetet mot ett ökat driftnetto framåt.',
      details: 'Detaljer',
      analysis_type_uses_title: 'Vad analyspaketet använder',
      analyzed_by_label: 'Analyseras av',
      homepal_ai_title: 'Homepal AI',
      tracked_with_label: 'Följs upp med',
      estimated_in_label: 'Resultat uppskattas i',
      increased_noi_value: 'Ökat driftnetto',
      avg_run_time_label: 'Genomsnittlig körtid',
      run_time_unavailable: 'Ingen information',
      last_run_label: 'Senaste körning',
      latest_analyses: 'Senaste analyser',
      required_metrics_title: 'Obligatoriska mätetal',
      required_slices_title: 'Obligatoriska skärningar',
      configured_by_admin_tooltip: 'Konfigureras av er systemadministratör.',
      investigation_dashboard_title: 'Utreds i',
      investigation_dashboard_description:
        'Öppnas från analysen, filtrerad på de fastigheter som är valda.',
      investigation_dashboard_label: 'Välj dashboard',
      investigation_dashboard_no_access: 'Dashboard du saknar åtkomst till',
      investigation_dashboard_draft_warning:
        'Dashboarden är ett utkast. Användare som inte är inbjudna ser ingen länk.',
      investigation_dashboard_restricted_info:
        'Endast användare med behörighet till dashboarden kan se den.',
      required_slices_dialog_helper:
        'Analysen kräver att skärningen är konfigurerad. Ange villkoren här för att kunna köra analysen.',
      no_requirements_title: 'Analyspaketet har inga datakrav',
      required_period_title: 'Obligatorisk bokslutsperiod',
      required_period_tooltip_body:
        'används för att låsa analysen till er senast stängda period.',
      closed_period_name: 'Senaste stängda bokslutsperiod',
      error_load_title: 'Analyspaketen kunde inte hämtas',
      error_load_body: 'Ladda om sidan eller försök igen om en stund.',
      error_not_found_body:
        'Vi kunde inte hitta analyspaketet du letade efter.',
      no_analysis_types_title: 'Inga analyspaket tillgängliga',
      view_all_analysis_types: 'Se alla analyspaket',
      available_analysis_types: 'Tillgängliga analyspaket',
      required_tooltip_body:
        'används för att kunna utföra analysen och skapa ett urval utifrån ' +
        'avvikelserna.',
      run_loading_title: 'Analys körs',
      cancel_run: 'Avbryt körning',
      done_title: 'Analysen är klar!',
      run_failed_title: 'Analysen kunde inte köras',
      run_failed_body: 'Försök igen om en stund.',
      run_aborted_title: 'Analysen avbröts',
      run_aborted_body: 'Analysen avbröts. Inget underlag skapades.',
      run_cancelled: 'Körningen avbröts.',
      run_error_403: 'Analyser är inte aktiverade för er.',
      run_error_422:
        'Data som analysen kräver saknas. Kontakta kundansvarig för att ' +
        'komplettera den.',
      run_error_502:
        'Analysen gav inget giltigt resultat. Försök igen om en stund.',
      run_error_503:
        'Analysmotorn är tillfälligt otillgänglig. Försök igen om en stund.',
      run_error_504:
        'Analysen tog för lång tid och avbröts. Försök igen om en stund.',
      run_error_default: 'Något gick fel. Försök igen om en stund.',
      disabled_title: 'Saknar data för analys',
      disabled_body:
        'Kontakta kundansvarig för att ansluta eller konfigurera den data ' +
        'som behövs till den här analyspaketet.',
      ai_step_1: 'Identifierar avvikelser i din data',
      ai_step_2: 'Jämför med portföljens norm',
      ai_step_3: 'Utvärderar berörda fastigheter',
      ai_step_4: 'Beräknar potential i driftnetto',
      running_minutes_left: 'Ca {{minutes}} min kvar',
      running_less_than_minute_left: 'Mindre än en minut kvar',
      running_overdue: 'Tar lite längre tid än vanligt',
      running_can_close_title: 'Du kan stänga dialogen',
      running_can_close_body:
        'Analysen fortsätter i bakgrunden och vi meddelar dig när ' +
        'analysen är klar.',
      field_noi_impact: 'Hur påverkar det driftnettot?',
      save: 'Spara',
      field_noi_impact_helper:
        'Vet du inte — fråga kunden medan hen fortfarande är kvar.',
      mark_deliverable: 'Markera levererbar',
      section_content: 'Innehåll',
      section_files: 'Filer',
      section_variants: 'Varianter',
      variant_errand: 'Ärenden',
      variant_errand_helper:
        'Gäller kunder som registrerar felanmälningar som ärenden.',
      variant_work_order: 'Arbetsordrar',
      variant_work_order_helper:
        'Gäller kunder som registrerar felanmälningar som arbetsordrar.',
      variant_dashboard: 'Dashboard ID',
      variant_requires_period: 'Kräver senaste stängda bokslutsperiod',
      structured_report: 'Ny generation av underlag',
      structured_report_body:
        'Analyspaketet levererar ett strukturerat underlag som renderas i portalen, i stället för en ifylld template.html. Kräver ingen template.html. Redan genererade underlag påverkas inte.',
      variant_metrics: 'Mätetal som krävs',
      variant_slices: 'Skärningar som krävs',
      file_upload: 'Ladda upp fil',
      file_missing: 'saknas',
      column_status: 'Status',
      status_idea: 'Idé',
      status_idea_body: 'Syns bara för oss. Kan inte köras åt kunder.',
      status_deliverable: 'Levererbar',
      status_deliverable_body:
        'Ligger i kundernas katalog och går att generera analyser ur.',
      new_analysis_type: 'Nytt analyspaket',
      new_helper_short: 'Namnet räcker för att börja. Resten fylls i sedan.',
      edit_field: 'Ändra {{field}}',
      section_tasks: 'Aktiviteter',
      section_requirements: 'Nödvändiga inställningar',
      variant_section_config: 'Konfigurering',
      variant_section_metrics: 'Mätetal och datakrav',
      requires_period_body:
        'Analyspaketet räknar på bokslutssiffror och kan inte köras förrän kunden satt sin senaste stängda period.',
      variant_dashboard_helper:
        'Klistra in dashboardens uuid. Den måste ligga på Homepals mallkund.',
      unpublish_title: 'Avpublicera analyspaketet',
      unpublish_body:
        'analyspaketet försvinner ur kundernas katalog. Inga nya analyser kan genereras och paketet går inte att ladda ner. Redan levererade analyser ligger kvar.',
      unpublish_analyses:
        '{{count}} analyser har redan levererats från den här analyspaketet.',
      source_variants_title:
        'Analyspaketet kan baseras på arbetsordrar eller ärenden',
      source_variants_body:
        'Om en analyspaket kan baseras på både arbetsordrar och ärenden behöver två varianter sättas upp.',
      source_locked:
        'Går bara att ändra på en analyspaket som ännu inte har publicerats.',
      file_uploaded: 'Uppladdat {{date}}',
      delivery_status: 'Leveransstatus',
      requirements_left: '{{count}} krav återstår.',
      requirement_variant_dashboard: 'Dashboard ID på varje variant',
      requirement_instructions_file: 'instructions.md uppladdad',
      requirement_template_file: 'template.html uppladdad',
      requirement_investigate_metric: 'Undersöks-mätetal på varje variant',
      requirement_analysis_definition: 'Analysdefinition vald',
      analysis_definition: 'Analysdefinition',
      analysis_definition_body:
        'Vilken definition i koden analyspaketet kör. Den bär logiken, kalkylen och texten kunden läser.',
      analysis_definition_none: 'Ingen vald',
      about_analysis_type: 'Om analyspaketet',
      about_created: 'Skapad',
      about_published: 'Levererbar sedan',
      about_variants: 'Varianter',
      variant_no_dashboard: 'Ingen mall vald',
      none: 'Ingen',
      excluded_label: 'Exkluderade fastigheter',
      excluded_edit: 'Lägg till eller ta bort exkluderade',
      excluded_more: '+{{count}} till',
      excluded_help_dialog:
        'sparas på analyspaketet och lämnas utanför den här och alla kommande körningar. De syns inte i resultatet och räknas inte med i målvärdet.',
      excluded_help_page:
        'sparas på analyspaketet och lämnas utanför alla kommande körningar. De syns inte i resultatet och räknas inte med i målvärdet. Listan gäller hela beståndet och påverkas inte av Globalt filter.',
      excluded_picker_intro_dialog:
        'Valda fastigheter exkluderas från den här och alla kommande körningar av paketet.',
      excluded_picker_intro_page:
        'Valda fastigheter exkluderas från alla kommande körningar av paketet.',
      excluded_search_placeholder: 'Sök fastighet'
    },

    results: {
      results: 'Resultat',
      retired_packages: 'Analyspaket som tagits ur bruk',
      retired_packages_tooltip:
        'Analyserna och aktiviteterna kommer från analyspaket som vi har tagit ur bruk. Du kan fortsätta arbeta med dem som vanligt.',
      progress: 'Uppföljning',
      no_metrics_body: 'Aktivera ett analyspaket så följs det upp här.',
      no_metrics_title: (
        <>
          Inga mätetal... ännu <Emoji name="seedling" />
        </>
      ),
      col_metric: 'Mätetal',
      col_trend: 'Trend',
      col_current_value: 'Nuläge',
      follow_up_metric_missing: 'Uppföljningsmätetal saknas',
      col_active_potential: 'Öppna aktiviteter',
      active_potential_tooltip:
        'är den uppskattade besparing eller intäktsökning (per år) som de ' +
        'nuvarande aktiviteterna syftar till.',
      col_discovered_potential: 'Ej hanterade analyser',
      unhandled_potential_tooltip:
        'är den uppskattade besparing eller intäktsökning (per år) som de ' +
        'senaste, ohanterade analyserna syftar till.',
      col_total: 'Totalt',
      error_load_title: 'Uppföljningen kunde inte hämtas',
      error_load_body: 'Ladda om sidan eller försök igen om en stund.',
      error_slice_not_activated:
        'En skärning som analysen behöver är inte konfigurerad'
    },

    analyses: {
      analyses: 'Analyser',
      analysis: 'Analys',
      properties: 'Egenskaper',
      write_comment: 'Lämna en kommentar…',
      search_placeholder: 'Sök efter analys',
      status_column: 'Status',
      error_not_found_body: 'Vi kunde inte hitta analysen du letade efter.',
      empty_feed_title: 'Inga ohanterade analyser',
      empty_feed_body: 'Nya analyser dyker upp här när de har körts.',
      empty_title: (
        <>
          Inga analyser... ännu <Emoji name="seedling" />
        </>
      ),
      empty_body:
        'Kör ett analyspaket för att generera analyser som hamnar här.',
      unhandled_analyses: 'Ej hanterade analyser',
      view_all_analyses: 'Se alla analyser',
      published: 'Publicerad',
      unpublished: 'Opublicerad',
      restore: 'Återställ',
      auto: 'Auto',
      add_comment: 'Lägg till kommentar',
      no_comments_body: 'Lägg till en kommentar för att starta diskussionen.',
      investigate_selection: 'Utforska urval',
      view_evidence: 'Visa hela underlaget',
      investigate_disabled_tooltip: 'Analysen går inte att undersöka',
      investigate_no_selection_tooltip:
        'Välj minst ett mätobjekt för att undersöka',
      edit: 'Redigera',
      edit_title: 'Redigera analys',
      selection: 'Urval',
      selection_locked_tooltip:
        'Urvalet går inte att ändra i status "{{status}}"',
      create_activities_title: 'Skapa aktiviteter',
      create_activities_empty_title: 'Inga valda fastigheter',
      create_activities_empty:
        'Analysen har inga valda fastigheter att skapa aktiviteter för.',
      create_activities_submit: 'Skapa aktiviteter',
      create_activities_info_title: 'En aktivitet per fastighet',
      create_activities_info_body:
        'Varje fastighet i ditt urval får en egen aktivitet. Vill du ta med ' +
        'andra fastigheter? Ändra urvalet i analysen innan du fortsätter.',
      col_current_value: 'Nuläge',
      potential: 'Potential',
      recommended_selection: 'har rekommenderat ett urval:',
      no_recommended_selection:
        'har inte hittat några fastigheter som behöver åtgärdas.',
      reasoning: 'Argument',
      no_preselection: 'har inte gjort något förval:',
      no_selection_above_noise: 'har inte rekommenderat några fastigheter:',
      recommendation_below_noise:
        'Ingen fastighet överskred brusfiltret. Avvikelserna är alltså så små att de bedöms som tillfälliga.',
      recommendation_noise_excluded:
        '{{count}} fastigheter under brusfiltret, värda sammanlagt {{total}} per år, har inte ingått i bedömningen.',
      recommendation_noise_excluded_one:
        '1 fastighet under brusfiltret, värd {{total}} per år, har inte ingått i bedömningen.',
      recommendation_gap:
        'Vi rekommenderar de {{count}} fastigheter där en åtgärd är mest ' +
        'värd, sammanlagt {{total}} per år. Efter den sista rekommenderade ' +
        'faller potentialen tydligt, från {{last}} till {{next}} per ' +
        'fastighet. Övriga {{rest}} fastigheter är värda {{restTotal}} per ' +
        'år tillsammans.',
      recommendation_gap_one:
        '{{name}} sticker ut. Att åtgärda den är värt {{total}} per år, ' +
        'jämfört med {{next}} per år för nästa fastighet i listan. Därför ' +
        'rekommenderar vi att ni börjar där.',
      recommendation_anchor:
        'Vi rekommenderar de {{count}} fastigheter där en åtgärd är mest ' +
        'värd, sammanlagt {{total}} per år. Fastigheterna därefter ligger ' +
        'klart lägre, högst {{next}} per år jämfört med {{top}} för den ' +
        'främsta. Övriga {{rest}} fastigheter är värda {{restTotal}} per år ' +
        'tillsammans.',
      recommendation_anchor_one:
        '{{name}} är den fastighet där en åtgärd är mest värd, {{total}} per ' +
        'år. Nästa fastighet i listan är värd högst {{next}} per år. Därför ' +
        'rekommenderar vi att ni börjar där.',
      recommendation_flat:
        'Potentialen är jämnt fördelad, med {{count}} fastigheter mellan ' +
        '{{min}} och {{max}} per år. Ingen sticker ut, så vi har inte gjort ' +
        'något förval. Välj de fastigheter som passar er bäst att börja med.',
      recommendation_single:
        'En fastighet har förbättringspotential: {{name}}, värd {{total}} ' +
        'per år. Övriga fastigheter ligger på en nivå som inte motiverar ' +
        'någon åtgärd.',
      add_to_selection: 'Lägg till i urval',
      remove_from_selection: 'Ta bort från urval',
      selection_helper_text:
        'Undersök och välj ut det urval som du vill ha med i analysen.',
      trend_current_period: 'Urval (nuvarande period)',
      trend_previous_period: 'Urval (föregående period)',
      selection_locked: 'Urvalet är låst',
      selection_locked_accepted:
        'Analysen har tagits vidare. Urvalet av fastigheter kan därför inte ändras.',
      selection_locked_rejected:
        'Analysen har avvisats. Urvalet av fastigheter kan därför inte ändras.',
      ambiguous_title: 'Fastigheter som inte kan särskiljas',
      ambiguous_body:
        '{{names}} är exkluderade eftersom flera fastigheter har samma beteckning och inte kan särskiljas.',
      ambiguous_body_one:
        '{{names}} är exkluderad eftersom flera fastigheter har samma beteckning och inte kan särskiljas.',
      ambiguous_dialog_body:
        'Flera fastigheter har samma beteckning och kan inte särskiljas. De exkluderas därför automatiskt och går inte att välja tillbaka.',

      // The version 2 report: trend, selection and calculation.
      report_improvement: 'Förbättring',
      report_start_value: 'Startvärde',
      report_target_value: 'Målvärde',
      noise: 'Brusfilter',
      recommendation_limit: 'Rekommendationsgräns',
      classification: 'Klassificering',
      classification_recommended: 'Rekommenderad',
      classification_recommended_tooltip:
        'Tydliga förändringar med hög potential som vi bedömer är värda att titta närmare på.',
      classification_potential: 'Potentiell',
      classification_potential_tooltip:
        'Förändringar som kan vara intressanta, men potentialen märkbart lägre än de rekommenderade.',
      classification_not_prioritized: 'Ej prioriterad',
      classification_not_prioritized_tooltip:
        'Förändringar under vårt brusfilter, alltså små avvikelser eller sådana vi bedömer som tillfälliga.',
      deviation_from_target: 'Avvikelse från målvärde (%)',
      report_potential_result: 'Potentiellt resultat',
      potential_rounding_note:
        'Talen ovan är avrundade. Resultatet räknas på exakta tal.',
      show_calculation: 'Visa uträkning',
      report_selection_title: 'Urval',
      report_col_potential: 'Potential',
      reject_confirm_title: 'avvisning',
      reject_submit: 'Avvisa',
      reject_confirm_description:
        'Analysen blir inaktiv. Du kan när som helst aktivera den igen.',
      undo_confirm_description:
        'Analysen blir aktiv igen. Fortsätt arbetet och driv aktiviteter framåt.',
      generated_from: 'Genererad från',
      investigated_in: 'Utreds i',
      retired: 'Analyspaketet har tagits ur bruk',
      retired_description:
        'Analysen är genererad från ett paket som tagits ur bruk. Du kan fortsatt arbeta med analysen som vanligt.',
      explore_body: 'Öppna underlaget för fastigheten.',
      selection_body: 'Gäller bara den här analysen.',
      exclude_and_rerun: 'Exkludera och kör om analysen',
      exclude_and_rerun_body:
        'Fastigheten tas bort ur alla kommande körningar och den här analysen körs igen.',
      rerun_title: 'Exkludera och kör om analysen?',
      rerun_description:
        '{{name}} exkluderas från alla kommande körningar och den här analysen körs igen utan fastigheten. När körningen är klar uppdateras resultatet.',
      rerun_excluded_now: 'Exkluderas nu',
      rerun_already_excluded: 'Redan exkluderade',
      rerun_note:
        'Exkluderade fastigheter syns inte i den nya analysen och räknas inte med i målvärdet. Du hanterar listan på analyspaketets sida.',
      rerun_submit: 'Exkludera och kör om',
      excluded_label: 'Exkluderade',
      excluded_count: '{{count}} fastigheter',
      excluded_count_one: '1 fastighet',
      excluded_dialog_title: 'Exkluderade i den här körningen',
      excluded_dialog_body:
        'Så såg listan ut när analysen kördes {{date}}. Ändringar efter det gäller bara kommande körningar.',
      rerun_leave_title: 'Du kan lämna sidan',
      rerun_leave_body:
        'Analysen körs om i bakgrunden och vi meddelar dig när den är klar.',
      rerun_disabled_tooltip: 'Det går inte medan analysen körs om.',
      rerun_comment_placeholder: 'Du kan kommentera när analysen är klar'
    },

    comments: {
      activity: 'Händelser',
      comments: 'Kommentarer'
    },

    search: {
      no_results_match: 'Hittade inga resultat som matchade',
      global_search_instructions: 'Minst 3 tecken',
      global_search_placeholder: 'Sök och gå till',
      search_for: 'Sök efter',
      results_found: 'Resultat hittade'
    },

    // widgets namespace (general)
    widgets: {
      chart_data_table_caption: 'Data för diagrammet {{title}}',
      chart_data_table_label_column: 'Kategori',
      login_required:
        'Logga in i Homepal för att få tillgång till den här funktionaliteten',
      no_further_breakdown:
        'Det går inte att dela upp det här segmentet ytterligare',
      open_in_source_system: 'Öppna i källsystem',
      missing_source_system: 'Saknar koppling till källsystem',
      breakdown_by_placeholder: 'Dela upp efter...',
      broken_error: 'Widgeten har gått sönder, testa att ladda om sidan.',
      date_range_out_of_bounds_error: 'Ogiltig kombination av tidsfilter',
      date_range_out_of_bounds_description:
        'Tidsperioden du valt ligger utanför verksamhetsåret. Vänligen justera verksamhetsår eller tidsperiod.',
      inactive_metrics_error:
        'Din organisation har inte aktiverat alla mätetal i denna widget.',
      no_data_title:
        'Det finns inte några värden att visa utifrån din valda period eller dina valda filter.',
      no_data_subtitle: 'Oroa dig inte! Allting fungerar som det ska 👍',
      no_data_description:
        'Att det inte finns några värden att visa beror på någonting (eller en kombination) av följande:',
      no_data_reason_metric_filter:
        'Det finns ingen data att visa utifrån mätetalets filter som är uppsatt.',
      no_data_reason_time_period:
        'Det finns ingen data under den tidsperiod eller tidpunkt som är vald.',
      no_data_reason_dashboard_filter:
        'Det finns ingen data att visa utifrån ditt aktiva dashboardfilter.',
      widget_missing_metrics_error:
        'Din organisation har inte konfigurerat alla mätetal i denna widget.',
      widget_missing_slices_error:
        'Din organisation har inte konfigurerat nödvändiga skärningar för samtliga mätetal i denna widget.',
      configure_slice: 'Konfigurera skärning',
      widget_missing_definition_error:
        'Din organisation har inte definierat formeln för samtliga ekonomiska mätetal i denna widget.',
      configure_definition: 'Definiera mätetal',
      request_data: 'Begär data',
      widget_missing_data_error:
        'Din organisation har inte kopplat på datan som krävs för samtliga mätetal i denna widget.',
      recommend_contact:
        'Vi rekommenderar att du kontaktar en av era systemadminstratörer',
      to_enable_data: '...för att koppla på den data som krävs! 👍',
      in_your_organization: 'I din organisation',
      show_horizontal: 'Visa horisontellt',
      show_segments_horizontal: 'Visa horisontellt',
      disabled_segments_horizontal_if_breakdown:
        'Det går inte att visa segment horisontellt när "dela upp efter" är aktiverad på ett av mätetalen.',
      add_widget: 'Lägg till widget',
      widget: 'Widget',
      widgets: 'Widgets',
      custom_segment_by: 'Anpassad uppdelning',
      custom_segment_by_description:
        'Du har lagt på en anpassad uppdelning som skiljer sig åt från den ursprungliga visualiseringen.',
      custom_segment_by_headers_hidden:
        'Rubriker är tillfälligt dolda eftersom de kanske inte längre beskriver det som visas.',
      invert: 'Invertera',
      lower_bound: 'Undre gräns',
      upper_bound: 'Övre gräns',
      area: 'Yta',
      hide_benchmark_filters: 'Dölj benchmarkfilter',
      show_benchmark_filters_with_count: 'Visa benchmarkfilter ({{count}})',
      metric: 'Mätetal',
      slice: 'Skärning',
      slice_helper_text:
        'Använd en färdig skärning för att endast fokusera på en specifik del av mätetalet. Skärningar definieras globalt av administratörer så att effekten blir densamma överallt.',
      primary_metric_tooltip: (
        <>
          <Text fontWeight="bold" variant="body2" gutterBottom>
            Det här är ditt primära mätetal.
          </Text>
          <Text variant="body2" gutterBottom>
            Om du lägger till fler mätetal så påverkas en del av deras
            egenskaper (till exempel <code>enhet</code>) av ditt primära
            mätetal.
          </Text>
          <Text variant="body2" gutterBottom>
            Primära mätetal går inte att radera eller flytta.
          </Text>
        </>
      ),
      attribute: 'Attribut',
      column_is_hidden: 'Kolumnen är dold',
      status_priority_helper_text:
        'Om flera indikationer med överlappande villkor finns, kommer den översta indikationens villkor att prioriteras. Säkerställ att prioritetsordningen är korrekt genom att placera den viktigaste indikationen högst upp.',
      new_indication: 'Ny indikation',
      set_condition_helper_text: 'Ange ett villkor som ska uppfyllas.',
      select_indicator_helper_text:
        'Välj vilken indikator som ska användas då ett villkor är uppfyllt.',
      select_value_to_add: 'Du måste välja ett värde för att kunna lägga till.',
      edit_indicator: 'Redigera indikator',
      change_title: 'Förändring',
      days: 'dagar',
      add_y_axis: 'Lägg till Y-axel',
      add_radius: 'Lägg till radie',
      add_line: 'Lägg till linje',
      add_points: 'Lägg till punkter',
      add_metric: 'Lägg till mätetal',
      add_attribute: 'Lägg till attribut',
      no_attributes_available_for_segmentation:
        'Det finns inga attribut tillgängliga för vald segmentering.',
      cannot_delete_primary_metric:
        'Det går inte att radera det primära mätetalet.',
      units_title: 'Enheter',
      units_and_rounding_title: 'Enheter och avrundning',
      auto_format: 'Automatisk formatering',
      auto_format_helper:
        'Väljer enhet och antal värdesiffror utifrån värdets storlek.',
      disabled_by_auto_format: 'Styrs av automatisk formatering.',
      decimals_title: 'Avrundning',
      equivalent_title: 'Ekvivalent',
      factor: 'Faktor',
      number_of_decimals: 'Antal decimaler',
      new_unit: 'Ny enhet',
      equivalent_helper_intro: (
        <>
          Multiplicerar dina värden med en faktor och/eller byter ut den
          nyvarande enheten mot en ny. På så sätt kan du skapa en
          <i> ekvivalent</i>.
        </>
      ),
      equivalent_preview_both:
        '1{{current}} kommer motsvara {{factor}}{{new}}.',
      equivalent_preview_factor_only:
        '1{{current}} kommer motsvara {{factor}}{{current}}.',
      equivalent_preview_unit_only: '1{{current}} kommer motsvara 1{{new}}.',
      breakdown_title: 'Uppdelning',
      visualization_title: 'Visualisering',
      bars: 'Staplar',
      bubbles: 'Bubblor',
      rows: 'Rader',
      bars_and_lines: 'Staplar och linjer',
      steps: 'Steg',
      linking_unavailable_for_segmentation:
        'Länkning är inte tillgänglig för din valda segmentering',
      link_to_source_system: 'Länka till källsystem',
      label_chars_title: 'Max antal tecken',
      limit_selection_to_primary_kpi_title:
        'Begränsa urval till det primära mätetalet',
      segment_by_title: 'Segmentering',
      segment_alias: 'Alias',
      amount_of: 'Antal {{name}}',
      sorting_title: 'Sortering',
      sort_by_title: 'Sortera efter',
      visualization_constraint_title: 'Sortera enligt',
      display_name: 'Visningsnamn',
      then_label: 'Sedan',
      additional_segmentation_title: 'Ytterligare dimensioner',
      additional_segmentation_helper:
        'När du visar data i en tabell kan du dela upp din segmentering vidare. Du kan lägga till upp till 3 ytterligare dimensioner.',
      variant_options_title: 'Segment',
      variant_options_helper:
        'Varje segment visar ett jämförelsetal för mätetalen — till exempel utfall, budget och avvikelse.',
      variant_option_variant_title: 'Jämförelsetal',
      variant_options_mode_attribute: 'Attribut',
      variant_options_dialog_info:
        'Tabellen visar då ett segment per jämförelsetal — till exempel utfall, budget och avvikelse — i stället för värden per attribut.',
      variant_options_dialog_start:
        'När du sparar skapas ett segment för utfall. Därefter lägger du till och ändrar segmenten under Segment i panelen.',
      variant_options_mode_variants: 'Jämförelsetal',
      expanded_segment_levels_title: 'Utfällt till och med',
      expanded_segment_levels_helper_text:
        'Styr vilka nivåer tabellen visar när den öppnas. Rader kan fortfarande fällas ut och ihop.',
      expanded_segment_levels_all_collapsed: '{{name}} (allt hopfällt)',
      expanded_segment_levels_all_expanded: '{{name}} (allt utfällt)',
      variant_options_mode_helper:
        'Tabellens segment kan visa värden per attribut eller jämförelsetal för mätetalen — till exempel utfall, budget och avvikelse.',
      variant_options_disable_body:
        'Dina jämförelsetal tas bort och tabellen visar segmenteringen igen.',
      linking_unavailable_for_variant_options:
        'Länkning till källsystem är inte tillgänglig med jämförelsetal.',
      disabled_show_total_variant_options:
        'Total är inte tillgängligt med jämförelsetal.',
      cannot_add_attribute_with_variant_options:
        'Attributkolumner går inte att lägga till när widgeten har jämförelsetal.',
      setting_controlled_by_variant_option:
        'Inställningen styrs per jämförelsetal. Ändra den under Segment i panelen.',
      variant_options_row_header: 'Jämförelsetal',
      cannot_delete_last_variant_option:
        'Det sista jämförelsetalet kan inte tas bort. Byt segment till ett attribut för att lämna jämförelsetalen.',
      disabled_additional_segmentation_horizontal:
        'Ytterligare dimensioner är inaktiverade när widgeten visar segment horisontellt.',
      disabled_additional_segmentation_preview:
        'Ytterligare dimensioner är inaktiverade när widgeten är inkluderad i förhandsvisning.',
      label_chars_helper_text:
        'Ibland kan det vara bra att sätta en begränsning på antal tecken för din segmentering för att ge utrymme åt datavisualiseringen.',
      top_n_helper_text:
        'Detta är särskilt användbart om du vill fokusera på de största eller minsta värdena.',
      limit_selection_to_primary_kpi_helper:
        'Genom att aktivera "Begränsa urval till det primära mätetalet" visas endast de segment som faller inom perioden för det primära mätetalet. Det här är användbart när du har mätetal baserade på olika perioder, men vill fokusera på data som innehåller det primära mätetalet.',
      breakdown_by: 'Dela upp efter',
      breakdown_disabled_due_to_comparative:
        'Uppdelning går inte att använda då det finns en jämförelse',
      breakdown_disabled_due_to_variant_options:
        'Uppdelning går inte att använda då widgeten har jämförelsetal',
      breakdown_disabled_due_to_horizontal_segments:
        'Uppdelning går inte att använda då widgeten visar segment horisontellt',
      expandable_metric_rows_helper:
        'Varje mätetal kan fällas ut i de ytterligare segmenteringarna, med mätetalets egna värden. Segmenteringen visas som kolumner.',
      disabled_for_financial_year: 'Verksamhetsår stödjer ej',
      rolling_disabled_for_financial_year:
        'Verksamhetsår stödjer ej rullande beräkning',
      share_title: 'Andel',
      share_helper_text: (
        <>
          Genom att visa andel av det här mätetal presenteras en procentsats på
          hur mycket av det ursprungliga resultatet som uppfyller de kriterier
          du lägger till i den här sektionen.{' '}
          <IconTip
            title={
              <>
                <Text variant="body2" color="inherit" gutterBottom>
                  <b>Mer detaljer</b>
                </Text>
                <Text variant="body2" color="inherit">
                  <b>Resultatet av angivna filter i den här sektionen</b> /{' '}
                  <b>Totala resultatet i mätetalet</b>
                  <Divider />
                  Visas i procent
                </Text>
              </>
            }
            variant="info"
            size={'small'}
          />
        </>
      ),
      show_share: 'Visa andel',
      indication_title: 'Indikation',
      increase_is: 'Ökning är',
      positive: 'Positivt',
      negative: 'Negativt',
      status: 'Status',
      bound: 'Gräns',
      add_intermediate_mode_helper_text:
        'Lägg till mellanläge för att ge din data en status som ligger mellan positiv och negativ.',
      add_intermediate_mode: 'Lägg till mellanläge',
      remove_intermediate_mode: 'Ta bort mellanläge',
      latest_closed_financial_period: 'Senaste stängda bokslutsperiod',
      lock_date_filter_helper_text:
        'Om du låser tidsperioden kommer användarens egna tidsperiodfilter inte kunna påverka widgeten.',
      restrict_to_closed_period_helper_text:
        'Om du begränsar tidsperioden till senaste stängda bokslutsperiod kommer din widget aldrig att visa data senare än det, oavsett vad som ställs in.',
      forecast_available_with_intro:
        'Det går endast att visa prognos tillsammans med:',
      historical_periods: 'Historiska tidsperioder',
      comparisons: 'Jämförelser',
      missing_financial_period_setting:
        'Saknar inställning för bokslutsperioder',
      missing_period_setting_error:
        'Widgeten är begränsad t.o.m. senaste stängda bokslutsperiod, men ingen bokslutsperiod är inställd.',
      configure_accounting_periods: 'Ställ in bokslutsperioder',
      cannot_compare_with_breakdown:
        'Det går inte att jämföra när ett mätetal har delats upp.',
      cannot_compare_for_metric_or_period:
        'Det går inte att jämföra det här mätetalet eller den valda tidsperioden.',
      cannot_restrict_period_intro:
        'Tidsperioden kan inte begränsas till den senaste stängda bokslutsperioden eftersom den inte omfattar hela perioden. Bokslutsperioden är inställd på',
      adjust_interval_instruction:
        '. Justera tidsintervallet för att inkludera en fullständig bokslutsperiod.',
      camera: 'Kamera',
      longitude: 'Longitud',
      latitude: 'Latitud',
      zoom: 'Zoom',
      viewport_helper_text:
        'Flytta och zooma kartan till önskat läge. Klicka sedan på Spara ovan för att uppdatera kartans startposition.',
      pie_segments: 'Tårtbitar',
      disabled_show_total_if_preview:
        'Det går inte att visa total i widgets som är inkluderade i förhandsvisning.',
      show_headers: 'Visa rubriker',
      show_total: 'Visa total',
      total_column: 'Totalt',
      show_vertical_lines: 'Visa vertikala linjer',
      use_like_for_like_real_estates: 'Jämförbar portfölj (Like-for-like)',
      use_like_for_like_real_estates_helper_text:
        'När den här inställningen är aktiverad visas endast de fastigheter som funnits under hela den valda perioden. ' +
        'Nya förvärv och sålda fastigheter exkluderas automatiskt, vilket ger en rättvis och stabil jämförelse över tid.',
      use_start_of_period: 'Utgå från periodens start',
      use_start_of_period_helper_text:
        'För punktmätetal (t.ex. vakansgrad) används normalt slutet på perioden ' +
        'eller sista datumet i segmentet som utgångspunkt. ' +
        'Med den här inställningen kan du istället välja att utgå från periodens början.',
      horizontal_text_alignment: 'Horisontell textjustering',
      vertical_text_alignment: 'Vertikal textjustering',
      latest_exchange_rate_warning:
        'Senaste växelkurs för ackumulerade mätetal',
      latest_exchange_rate_tooltip:
        'Ackumulerade mätetal beräknas med den senaste tillgängliga ' +
        'växelkursen och inte på periodens faktiska växelkurser som för ' +
        'övriga mätetal.',
      weighted_average_warning: 'Viktat medelvärde',
      weighted_average_tooltip:
        'Värdet baseras på ett viktat medelvärde beräknat utifrån de valda fastigheterna.'
    },

    users: {
      admin_data_access_tooltip:
        'Systemadministratörer har alltid tillgång till all data.',
      'logged_in_via_{{name}}': 'Inloggad via {{name}}',
      cant_find_user: 'Hittar du inte användaren?',
      contact_system_admin:
        'Kontakta en systemadministratör för att bjuda in personen till Homepal.',
      no_system_admin: 'Ingen systemadministratör finns angiven.',
      colleague: 'Kollega',
      company_group_user: 'Kundanvändare',
      system_owner: 'Systemägare',
      invite_non_users_title:
        'Här bjuder du in personer till Homepal som inte redan är användare.',
      already_a_user_question: 'Är personen redan en användare?',
      go_back_and_add_user: 'Gå tillbaka och lägg till användare',
      company_group_data_access_tooltip:
        'Kundanvändare ser endast data för kunden de tillhör.',
      company_group_missing_error: 'Du måste välja en kund.',
      company_group_not_support_for_group_tooltip:
        'Kundanvändare har ej stöd för grupper',
      company_group_removed_title: 'Kund borttagen',
      economy_description:
        'Ger användaren åtkomst att visa och ändra ekonomiska inställningar.',
      analyses_description: 'Ger användaren åtkomst till analystjänsten.',
      edit_user: 'Redigera användare',
      email: 'Email',
      email_error: 'Du måste ange en giltig email. Exempel: hej@homepal.se',
      first_name: 'Förnamn',
      first_name_missing_error: 'Användare måste ha ett förnamn.',
      last_name: 'Efternamn',
      last_name_missing_error: 'Användare måste ha ett efternamn.',
      message: 'Meddelande',
      message_information: (
        <>
          <Text fontSize="inherit" color="inherit" gutterBottom={true}>
            <b>Tänk på!</b> Personen har nog aldrig använt Homepal innan.
          </Text>
          <Text fontSize="inherit" color="inherit">
            Det kan hjälpa mycket att bifoga ett kort meddelande i din inbjudan
            för att förklara <i>varför</i> personen har blivit inbjuden och{' '}
            <i>vad</i> den ska göra.
          </Text>
        </>
      ),
      not_activated_title: 'Inte aktiverad',
      not_activated_tooltip: 'Användaren har inte aktiverat sitt konto än',
      role: 'Roll',
      sso_create_error:
        'Eftersom er organisation använder er av SSO, så kan ni endast bjuda in användare via er IDP-tjänst. Kontakta er systemadministratör.',
      sso_delete_error:
        'Eftersom ni har en IDP-integration aktiverad så måste användaren tas bort från er IDP-lösning, så att tillgången till Homepal försvinner.',
      sso_title: 'SSO',
      unique_user: 'Unik användare',
      unique_users: 'Unika användare',
      email_change_disabled_tooltip:
        'Det går inte att ändra email efter att ett konto har skapats',
      mfa_title: 'Tvåfaktorsautentisering (2FA)',
      mfa_description:
        'Lägg till ett extra lager av säkerhet till ditt konto genom att kräva en verifieringskod från din mobiltelefon när du loggar in.',
      mfa_enabled: 'Aktiverad',
      mfa_disabled: 'Inaktiverad',
      mfa_enable: 'Aktivera',
      mfa_disable: 'Inaktivera',
      mfa_status_load_error: 'Kunde inte hämta MFA-status',
      mfa_disabled_success: 'Tvåfaktorsautentisering har inaktiverats',
      mfa_disable_error: 'Kunde inte inaktivera tvåfaktorsautentisering',
      mfa_enabled_success: 'Tvåfaktorsautentisering har aktiverats!',
      mfa_note:
        'Du behöver en autentiseringsapp som Google Authenticator, Authy eller Microsoft Authenticator för att använda tvåfaktorsautentisering.',
      mfa_note_label: 'Obs!',
      mfa_setup_title: 'Aktivera tvåfaktorsautentisering',
      mfa_setup_step1:
        '1. Skanna QR-koden med din autentiseringsapp (Google Authenticator, Authy, etc.)',
      mfa_setup_manual: 'Eller ange denna kod manuellt:',
      mfa_setup_step2: '2. Ange verifieringskoden från din app:',
      mfa_verification_code: 'Verifieringskod',
      mfa_cancel: 'Avbryt',
      mfa_verify_and_enable: 'Verifiera och aktivera',
      mfa_qr_generation_error: 'Kunde inte generera QR-kod. Försök igen.',
      mfa_code_length_error: 'Ange en 6-siffrig verifieringskod',
      mfa_invalid_code_error: 'Ogiltig verifieringskod. Försök igen.',
      search_placeholder: 'Sök efter användare genom namn eller email',
      page_title: 'Hantera användare',
      page_body: 'Skapa användare och hantera deras åtkomst och behörigheter.'
    },

    org_units: {
      unit: 'Fastighet',
      units: 'Fastigheter',
      all: 'Alla fastigheter',
      custom: 'Anpassade fastigheter',
      standard: 'Mina fastigheter',
      helper_text: 'Välj de fastigheter som du vill spara i ditt standardval.',
      unit_company: 'Bolag',
      units_company: 'Bolag',
      all_company: 'Alla bolag',
      custom_company: 'Anpassade bolag',
      standard_company: 'Mina bolag',
      helper_text_company:
        'Välj de bolag som du vill spara i ditt standardval.',
      global_filter: 'Globalt filter'
    },

    data_access: {
      data_access: 'Dataåtkomst',
      tooltip:
        'Datatillgång sätts upp och delas ut av organisationens systemadministratör.',
      page_title: 'Hantera dataåtkomst',
      page_body: 'Skapa dataåtkomster som senare kan tilldelas användare.',
      helper_text:
        'Lägg till fastigheter till en dataåtkomst som senare kan tilldelas användare.',
      helper_text_company:
        'Lägg till bolag till en dataåtkomst som senare kan tilldelas användare.',
      title_placeholder: 'Ex. Region Norr',
      description_placeholder:
        'Ex. Endast åtkomst till data tillhörande Region Norr',
      users_using_access:
        'Det finns {{numberOfUsers}} användare som är kopplade till denna dataåtkomst.',
      missing_data_access_title: 'Saknar dataåtkomst',
      missing_data_access_body:
        'Du har ingen dataåtkomst, kontakta en av nedanstående systemadministratörer.'
    },

    nps: {
      reason_question:
        'Vad är det viktigaste som skulle göra din upplevelse ännu bättre?',
      score_question:
        'Hur troligt är det att du skulle rekommendera Homepal till en vän eller kollega?',
      skip: 'Hoppa över',
      skip_loading: 'Hoppar över...',
      submit: 'Skicka',
      submit_loading: 'Skickar...',
      thank_you_text:
        'Tack för att du svarade på denna enkät. Din feedback är mycket uppskattad!'
    },

    currency_converter: {
      currency: 'Valuta',
      select_currency: 'Välj valuta'
    },

    mcp_tokens: {
      landing_name: 'MCP',
      landing_title: 'MCP-anslutningar',
      landing_body:
        'Anslut Claude, ChatGPT, Microsoft Copilot eller Lovable till Homepal via MCP.',
      page_title: 'MCP-anslutningar',
      page_intro:
        'Anslut Claude, ChatGPT, Microsoft Copilot eller Lovable till Homepal. Varje knapp guidar dig steg för steg: MCP-URL:en kopieras och rätt inställningssida öppnas, sedan loggar du in och godkänner. Microsoft Copilot ansluts av er Microsoft 365-administratör.',
      localhost_warning:
        'Du kör mot localhost. Externa klienter accepterar inte HTTP MCP-URLs — starta en devtunnel och sätt MCP_OAUTH_ISSUER_URL (se compose-filen).',
      tunnel_active:
        'Publik HTTPS-tunnel upptäckt — externa klienter (Claude web, ChatGPT, Copilot) ansluts via:',
      connect_claude_web: 'Anslut till Claude (web)',
      connect_chatgpt: 'Anslut till ChatGPT',
      connect_copilot: 'Anslut till Microsoft Copilot',
      connect_lovable: 'Anslut till Lovable',
      lovable_dialog_title: 'Anslut Lovable',
      lovable_dialog_intro:
        'Lägg till Homepal som MCP-server i Lovable. Då kan Lovable hämta er data medan du bygger. Varje användare ansluter med sitt eget Homepal-konto.',
      lovable_not_enabled_warning:
        'Lovable är inte tillåtet för er organisation ännu. En administratör slår på det under "Lovable (admin)" på den här sidan.',
      lovable_step_1: 'Kopiera Homepals MCP-URL',
      lovable_step_2: 'Lägg till MCP-servern i Lovable',
      lovable_step_2_item_1:
        'Klicka på "Öppna Lovable" nedan. MCP-URL:en kopieras automatiskt.',
      lovable_step_2_item_2: 'I Lovable: Connectors → + → MCP server.',
      lovable_step_2_item_3:
        'Server name: "Homepal". Server URL: klistra in URL:en.',
      lovable_step_2_item_4:
        'Låt Authentication stå på OAuth (default) och klicka på "Add & authorize".',
      lovable_open: 'Öppna Lovable',
      lovable_step_3: 'Godkänn anslutningen',
      lovable_step_3_item_1:
        'Lovable startar inloggningen. Logga in med ditt Homepal-konto och godkänn på vår consent-sida.',
      lovable_step_3_note:
        'Anslutningen är personlig. Kollegor som vill använda Homepal i Lovable ansluter med sina egna konton.',
      lovable_step_4: 'Så använder du den',
      lovable_step_4_item_1:
        'Be Lovable i projektchatten, t.ex. "Hämta vakansgraden per fastighet från Homepal och bygg en översikt".',
      lovable_step_4_note:
        'Homepal används bara medan du bygger. Den publicerade appen får ingen åtkomst till Homepal-data.',
      lovable_section_title: 'Lovable (admin)',
      lovable_section_intro:
        'Lovable ansluter utan klientuppgifter, så organisationen måste tillåta det här. Varje användare loggar fortfarande in och godkänner själv. Stänger du av det återkallas alla befintliga Lovable-anslutningar direkt.',
      lovable_enabled: 'Lovable är tillåtet',
      lovable_disabled: 'Lovable är inte tillåtet',
      lovable_disable_dialog_title: 'Stäng av Lovable?',
      lovable_disable_dialog_intro:
        'Alla Lovable-anslutningar i organisationen slutar fungera direkt. Användarna måste ansluta igen om Lovable slås på senare.',
      hub_systems_section_title: 'Hub Systems (admin)',
      hub_systems_section_intro:
        'Hub Systems ansluter utan klientuppgifter, så organisationen måste tillåta det här. Varje användare loggar fortfarande in och godkänner själv. Stänger du av det återkallas alla befintliga Hub Systems-anslutningar direkt.',
      hub_systems_enabled: 'Hub Systems är tillåtet',
      hub_systems_disabled: 'Hub Systems är inte tillåtet',
      hub_systems_disable_dialog_title: 'Stäng av Hub Systems?',
      hub_systems_disable_dialog_intro:
        'Alla Hub Systems-anslutningar i organisationen slutar fungera direkt. Användarna måste ansluta igen om Hub Systems slås på senare.',
      platform_disable: 'Stäng av',
      claude_web_dialog_title: 'Anslut Claude (web)',
      claude_web_dialog_intro:
        'Anslut Homepal som custom connector i Claudes inställningar. Det tar under en minut.',
      claude_web_step_1: 'Kopiera Homepals MCP-URL',
      claude_web_step_2: 'Lägg till som custom connector i Claude',
      claude_web_step_2_item_1:
        'Klicka på "Öppna claude.ai" nedan — MCP-URL:en kopieras automatiskt.',
      claude_web_step_2_item_2:
        'I Claude: Add → Add custom connector → klistra in URL:en.',
      claude_web_step_2_item_3:
        'Öppna Advanced settings och fyll i organisationens Client ID och client secret enligt nedan.',
      claude_web_step_3: 'Godkänn anslutningen',
      claude_web_step_3_item_1:
        'Claude startar inloggningen — logga in med ditt Homepal-konto.',
      claude_web_step_3_item_2: 'Godkänn åtkomsten på vår consent-sida.',
      claude_web_step_3_note:
        'På Claude Team/Enterprise måste connectorn istället läggas till av er organisations ägare under Organization settings → Connectors.',
      claude_web_step_4: 'Tillåt verktygen',
      claude_web_step_4_item_1:
        'När connectorn är ansluten visas Homepals verktyg under "Tool permissions".',
      claude_web_step_4_item_2:
        'Sätt dem till "Always allow" (kugghjulet uppe till höger, eller per verktyg) så slipper du godkänna varje enskilt anrop i chatten.',
      claude_web_step_4_note:
        'Alla verktyg är läsbara — de hämtar bara data, ändrar aldrig något.',
      claude_web_step_5: 'Så använder du den i chatten',
      claude_web_step_5_item_1:
        'Öppna en ny chatt, klicka på +-knappen → Connectors och slå på Homepal.',
      claude_web_step_5_item_2:
        'Ställ frågor på vanlig svenska, t.ex. "Vad är vakansgraden per fastighet?" eller "Hur har driftnettot utvecklats i år?".',
      claude_web_step_5_note:
        'Claude väljer själv rätt verktyg, hämtar datan från Homepal och svarar — allt med din egen behörighet.',
      claude_web_open_settings: 'Öppna claude.ai',
      chatgpt_dialog_title: 'Anslut ChatGPT',
      chatgpt_dialog_intro:
        'Custom connectors i ChatGPT kräver Developer mode och läggs till manuellt i inställningarna. Fungerar på Pro, Plus, Business, Enterprise och Edu (webbappen).',
      chatgpt_step_1: 'Kopiera Homepals MCP-URL',
      chatgpt_step_2: 'Aktivera Developer mode',
      chatgpt_step_2_item_1:
        'Klicka på "Öppna ChatGPT" nedan — MCP-URL:en kopieras automatiskt.',
      chatgpt_step_2_item_2:
        'I ChatGPT: Settings → Apps → Advanced settings → slå på Developer mode.',
      chatgpt_step_2_note:
        'På Business/Enterprise måste en workspace-admin först tillåta det under Workspace Settings → Permissions & Roles → Connected Data → Create custom MCP connectors.',
      chatgpt_step_3: 'Skapa connectorn',
      chatgpt_step_3_item_1: 'Gå till Settings → Connectors → Create.',
      chatgpt_step_3_item_2:
        'Namn: "Homepal". Beskrivning: t.ex. "Homepals analysplattform för fastighetsdata — mätvärden, vakans, energi, ekonomi".',
      chatgpt_step_3_item_3: 'Klistra in MCP-URL:en och välj OAuth.',
      chatgpt_step_3_item_4:
        'Under Klientregistrering: välj "Användardefinierad OAuth-klient" och fyll i organisationens Client ID och client secret enligt nedan.',
      chatgpt_step_3_item_5:
        'Sätt "Autentiseringsmetod för token-slutpunkt" till client_secret_post — med "none" skickas aldrig er secret och anslutningen nekas.',
      chatgpt_step_4: 'Godkänn anslutningen',
      chatgpt_step_4_item_1:
        'ChatGPT startar inloggningen — logga in med ditt Homepal-konto och godkänn på vår consent-sida.',
      chatgpt_step_4_item_2: 'Aktivera sedan connectorn i chatten.',
      chatgpt_step_4_note:
        'I standardläge används search/fetch; i Developer mode nås alla verktyg.',
      chatgpt_open_settings: 'Öppna ChatGPT',
      copilot_dialog_title: 'Anslut Microsoft 365 Copilot',
      copilot_dialog_intro:
        'Microsoft 365 Copilot ansluts via en custom federated connector. Den sätts upp av en Microsoft 365-administratör (Global Administrator eller AI Administrator) i två steg: en OAuth-registrering i Teams Developer Portal och en connector i Microsoft 365 admin center. Räkna med cirka 10 minuter. Varje användare ansluter sedan källan med sitt eget Homepal-konto.',
      copilot_materialization_disclaimer:
        '⚠️ Viktigt om väntetid: Även när connectorn syns som ansluten i Copilot kan det ta upp till 24–48 timmar innan Microsoft har materialiserat den så att Copilot faktiskt använder den. Under tiden kan Copilot svara att den inte hittar källans verktyg — det är förväntat och betyder inte att något är fel. Konfigurera klart EN gång och låt den vara: varje omkonfiguration eller återskapande nollställer Microsofts klocka och förlänger väntan.',
      copilot_step_1: 'Registrera en OAuth-klient i Teams Developer Portal',
      copilot_step_1_item_1:
        'Klicka på "Öppna Teams Developer Portal" nedan (eller gå till Tools → OAuth client registration).',
      copilot_step_1_item_2: 'Välj "+ New OAuth connection".',
      copilot_step_1_item_3:
        'Fyll i fälten enligt tabellen nedan — använd kopieringsknapparna. Client secret används inte av Homepal men fältet är obligatoriskt, klistra in värdet från tabellen.',
      copilot_step_1_item_4:
        'OBS: skapa ingen app under "Apps" — endast OAuth-registreringen under Tools behövs.',
      copilot_step_1_footnote_intro: 'Viktigt innan du sparar:',
      copilot_step_1_footnote_item_1:
        'Slå PÅ "Enable Proof Key for Code Exchange (PKCE)".',
      copilot_step_1_footnote_item_2:
        'Låt "Client password authentication method" stå kvar på "Request body parameters (default)".',
      copilot_step_1_footnote_item_3:
        'Välj "My organization only" + "Any Teams app" under Restrict usage.',
      copilot_step_1_footnote_item_4:
        'Spara och kopiera registrerings-ID:t (OAuth client registration ID) — du behöver det i steg 2.',
      copilot_step_2: 'Skapa connectorn i Microsoft 365 admin center',
      copilot_step_2_item_1:
        'Klicka på "Öppna Microsoft 365 admin center" nedan — du landar direkt i "Lägg till connector"-vyn (annars: Copilot → Connectors → Gallery → "Create a new connector").',
      copilot_step_2_item_2: 'Under "Connect to MCP server", välj Add.',
      copilot_step_2_item_3:
        'Fyll i Display name och MCP endpoint URL enligt nedan (URL:en måste sluta på /mcp).',
      copilot_step_2_item_4:
        'Välj Authentication type "OAuth 2.0" och klistra in registrerings-ID:t från steg 1 som Reference ID.',
      copilot_step_2_item_5:
        'Klicka Authorize — logga in med ditt Homepal-konto och godkänn.',
      copilot_step_2_item_6: 'Bocka i Notice-rutan och spara.',
      copilot_step_3: 'Rulla ut connectorn till användarna',
      copilot_step_3_item_1: 'Under fliken Your Connections, öppna connectorn.',
      copilot_step_3_item_2:
        'Sätt Staged rollout till "Deploy to all users" (eller välj specifika grupper).',
      copilot_step_3_item_3:
        'Kontrollera att "Enable/disable this source for users" är På.',
      copilot_step_3_item_4:
        'Verifiera genom att Tools-sektionen i connector-panelen listar Homepals verktyg.',
      copilot_step_3_note: 'Ändringar tar upp till 15 minuter att slå igenom.',
      copilot_step_4: 'Aktivera källan i chatten (görs av varje användare)',
      copilot_step_4_item_1:
        'I Microsoft 365 Copilot: öppna Inställningar (…-menyn) → Källor.',
      copilot_step_4_item_2:
        'Hitta "Homepal", klicka Anslut, logga in med ditt Homepal-konto och godkänn.',
      copilot_step_4_item_3:
        'Starta en ny chatt och testa, t.ex. "Vad är vakansgraden just nu per fastighet?".',
      copilot_step_4_note_1:
        'Källan fungerar i Copilot Chat, Researcher-agenten och Copilot i Excel — Copilot hämtar alltid data med din egen Homepal-behörighet.',
      copilot_step_4_note_2:
        'OBS: Microsofts registrering av en ny connector sker i flera steg och tar tid. Det kan ta 15–30 minuter innan källan dyker upp under Källor — och även när den syns och är ansluten kan det dröja upp till 24–48 timmar innan Copilot faktiskt börjar använda den (se varningen högst upp). Ha tålamod, testa igen i en ny chatt — ingen omkonfiguration behövs (omkonfiguration nollställer tvärtom Microsofts klocka).',
      copilot_open_chat: 'Öppna Microsoft 365 Copilot',
      copilot_open_tdp: 'Öppna Teams Developer Portal',
      copilot_secret_from_generation:
        'er client secret (visades när uppgifterna genererades)',
      no_client_credentials_warning:
        'Organisationen har inga klientuppgifter ännu — anslutningen kräver dem. Be en administratör generera under "Klientuppgifter" på den här sidan först.',
      copilot_reference_id_hint:
        'Reference ID = OAuth client registration ID:t du kopierade från Teams Developer Portal i steg 1.',
      client_section_title: 'Klientuppgifter (admin)',
      client_section_intro:
        'Er organisations OAuth-uppgifter (client ID + client secret) — används i alla anslutningsguider nedan. Client secret visas bara en gång, vid genereringen. Rotera skapar nya uppgifter och gör de gamla ogiltiga direkt; återkalla stänger av alla anslutningar som använder dem.',
      client_created_at: 'Skapade',
      client_secret_shown_once:
        'client secret visades vid genereringen och kan inte visas igen.',
      client_generate: 'Generera klientuppgifter',
      client_rotate: 'Rotera',
      client_revoke: 'Återkalla',
      client_rotate_dialog_title: 'Rotera klientuppgifter?',
      client_rotate_dialog_intro:
        'Nya uppgifter genereras och de nuvarande slutar fungera omedelbart. Alla anslutningar (Copilot, Claude, ChatGPT) som använder de gamla uppgifterna måste uppdateras med de nya.',
      client_created_dialog_title: 'Klientuppgifter skapade',
      client_created_dialog_intro:
        'Kopiera client secret nu — av säkerhetsskäl visas den bara en gång. Tappar ni bort den roterar ni uppgifterna och uppdaterar era anslutningar.',
      client_delete_type: 'klientuppgifter',
      copilot_open_admin_center: 'Öppna Microsoft 365 admin center',
      copilot_localhost_hint:
        'Du kör mot localhost. Copilot kräver en publikt nåbar HTTPS-URL — starta en devtunnel, sätt MCP_OAUTH_ISSUER_URL (se compose-filen) och använd tunnel-URL:en istället.',
      not_available:
        'MCP-integrationen är inte aktiverad för den här kunden i nuvarande miljö.'
    },

    mcp_consent: {
      title: 'Godkänn anslutning',
      subtitle_with_client: '{{client}} vill ansluta till ditt Homepal-konto.',
      subtitle_generic: 'En MCP-klient vill ansluta till ditt Homepal-konto.',
      platform_warning:
        'Godkänn bara om du själv precis klickade på "Add & authorize" i din egen {{client}}-arbetsyta. Har du fått den här länken av någon annan, klicka på Avbryt.',
      access_heading: 'Klienten får läsa följande data:',
      access_metrics: 'Mätvärden, dashboards och nyckeltal',
      access_entities: 'Fastigheter, hyresobjekt och ärenden',
      access_reports: 'Rapporter och analyser tillgängliga för ditt konto',
      logged_in_as: 'Inloggad som',
      customer: 'Kund',
      error_invalid_redirect:
        'Länken innehåller en återadress som inte är registrerad för klienten. Anslutningen kan inte godkännas.',
      cancel: 'Avbryt',
      approve: 'Godkänn',
      approving: 'Godkänner',
      revoke_hint:
        'Du kan när som helst återkalla åtkomsten under Inställningar → MCP-klienter.',
      error_missing_params:
        'OAuth-parametrarna saknas. Starta integrationen från Claude / ChatGPT igen.',
      error_load_client:
        'Kunde inte ladda klientinformation. Försök igen senare.',
      error_generic: 'Något gick fel vid godkännande.',
      not_available:
        'MCP-integrationen är inte aktiverad för den här kunden i nuvarande miljö.'
    },

    resources: {
      all_resources: 'Alla resurser',
      restore_dashboard_title: 'Återställ dashboard',
      restore_dashboard_body: 'Vill du återställa den här dashboarden?',
      search_placeholder: 'Sök efter resurs'
    }
  },
  en: {
    chat: {
      homepal_ai_title: 'Homepal AI',
      greeting: 'I am the Homepal AI. How can I help you today?',
      analyzing: 'Analyzing…',
      reasoning: 'Reasoning',
      reasoning_streaming: 'Thinking…',
      tool_loaded_schema: 'Read the data model',
      tool_fetched_data: 'Fetched data',
      tool_aggregated: 'Aggregated by dimension',
      tool_loading_schema: 'Reading the data model…',
      tool_fetching_data: 'Fetching data…',
      tool_aggregating: 'Aggregating by dimension…',
      tool_found_values: 'Looked up values in the data',
      thought_for_seconds: 'Thought for {{seconds}} s · {{count}} steps',
      thought_for_seconds_one: 'Thought for {{seconds}} s · {{count}} step',
      steps_short: '{{count}} steps',
      steps_short_one: '{{count}} step',
      follow_up: 'Anything else? I am ready!',
      generated_from: 'Generated from {{count}} rows in {{title}}.',
      input_placeholder: 'Ask a question about the data…',
      send: 'Send',
      beta: 'Beta',
      beta_tooltip:
        'The AI chat is in beta and keeps improving based on your feedback. Rate the answers with the thumbs below them.',
      disclaimer: 'AI can make mistakes. Verify important information.',
      empty_disclaimer:
        'By asking a question you give the AI model access to the table. GDPR-sensitive columns are always excluded.',
      starter_deviations: 'Summarize and highlight deviations',
      starter_concentration: 'Where is this concentrated?',
      toggle_panel: 'Show or hide AI chat',
      feedback_helpful: 'Good answer',
      feedback_not_helpful: 'Bad answer',
      feedback_title: 'What was the problem?',
      feedback_reason_wrong_numbers: 'Wrong numbers',
      feedback_reason_not_answered: 'Did not answer my question',
      feedback_reason_cannot_help: 'Could not answer my question',
      feedback_reason_wrong_proposal: 'Wrong change on the board',
      feedback_reason_board_unchanged: 'Did not change the board',
      feedback_reason_misunderstood: 'Did not understand what I meant',
      feedback_reason_other: 'Other',
      feedback_comment_placeholder: 'Tell us more (optional)',
      feedback_submit: 'Send',
      nudge_text:
        'Did the last answer help you? A quick rating teaches me what works for you, so the next answer gets better.',
      nudge_thanks:
        'Thanks! This helps me give you better answers going forward.',
      stream_interrupted:
        'The reply was cut off before it finished. Please try again.',
      history_title: 'Earlier chats',
      history_open_failed: 'Could not open the chat. Please try again.',
      history_today: 'Today',
      history_yesterday: 'Yesterday',
      history_earlier: 'Earlier',
      history_search_placeholder: 'Search earlier chats',
      history_scope_note:
        'Your own chats from here. Each chat answers from the data that was shown when it started.',
      history_no_matches: 'No chat matches your search.',
      history_empty: 'You have no earlier chats here yet.',
      history_row_count: '{{count}} rows',
      history_other_view: 'Other selection',
      resumed_chat_other_view:
        'This chat started from a different selection than the table.',
      resumed_chat_missing_filters: 'Struck-through filters were not applied.',
      history_stale: 'The data has been updated since this chat started',
      resumed_chat_stale:
        'This chat answers from the data as it was when it started. The data has been updated since, so you can read the chat but not continue it.',
      resumed_chat_ask_again: 'Ask again against today\'s data',
      input_placeholder_stale: 'This chat cannot be continued'
    },
    global: {
      filter: 'Filter',
      unhandled: 'Unhandled',
      active: 'Active',
      reject: 'Reject',
      undo: 'Undo',
      priority: 'Priority',
      hi: 'Hi',
      copy: 'Copy',
      copied: 'Copied',
      ai_generated: 'Generated with the help of our AI categorization.',
      advanced: 'Advanced',
      data_updated: 'Live data',
      data_locked: 'Locked data',
      total: 'Total',
      total_rows: 'Total {{count}} rows',
      showing_rows: 'Showing {{count}} of {{total}} rows',
      first_rows_only:
        'Showing the first {{count}} rows. Add a filter to see the others.',
      showing_rows_of_first:
        'Showing {{count}} of the first {{total}} rows. Add a filter to see the others.',
      rows_failed_to_load:
        'The rows could not be loaded. Try again or narrow the selection with a filter.',
      rows_failed_to_refresh:
        'The search or sort could not be run over all rows. Showing the rows already fetched.',
      export_first_rows_only:
        'The export holds the {{count}} rows shown, not all that match the selection. Add a filter to include the others.',
      export_all_rows:
        'The export holds every row that matches the selection, with the columns, search and sort of the table. Large selections take a while.',
      exporting_all_rows: 'Exporting all rows…',
      export_truncated:
        'The selection had more rows than Excel holds. The export has the first {{count}}.',
      searching_all_rows: 'Searching all rows…',
      sorting_all_rows: 'Sorting all rows…',
      sorted_among_fetched_rows:
        'This column is sorted among the fetched rows only.',
      matching_rows: '{{count}} rows match the search',
      first_matching_rows_only:
        'Showing the first {{count}} rows that match the search. Refine the search or add a filter to see the others.',
      search_in_column: 'Search in column',
      search_in_column_placeholder: 'Search in {{column}}',
      formula: 'Formula',
      formula_missing: 'Formula missing',
      upload: 'Upload',
      file_not_supported: 'File not supported',
      file_too_large: 'File is too large',
      no_file_selected: 'No file selected',
      drop_here: 'Drop here',
      drag_and_drop_here: 'Drag and drop here',
      browse: 'Browse',
      location: 'Location',
      supported_formats: 'Supported formats',
      max_size: 'Maximum size',
      missing: 'Missing',
      published: 'Published',
      unpublished: 'Unpublished',
      draft: 'Draft',
      drafts: 'Drafts',
      internal: 'Internal',
      external: 'External',
      views: 'Views',
      view: 'View',
      date: 'Date',
      accept: 'Accept',
      deny: 'Deny',
      feed: 'Feed',
      pcs: 'pcs',
      company_type: 'Company type',
      all: 'All',
      my: 'My',
      tags: 'Tags',
      profile: 'Profile',
      language: 'Language',
      id: 'ID',
      edit_order: 'Edit order',
      last_changed_ago: 'Changed {{time}} ago',
      last_visited: 'Last visited',
      last_visited_ago: 'Visited {{time}} ago',
      time_ago: '{{time}} ago',
      second: 'Second',
      seconds: 'Seconds',
      minute: 'Minute',
      minutes: 'Minutes',
      hour: 'Hour',
      hours: 'Hours',
      day: 'Day',
      days: 'Days',
      week: 'Week',
      weeks: 'Weeks',
      month: 'Month',
      months: 'Months',
      year: 'Year',
      years: 'Years',
      open: 'Open',
      identifier: 'Identifier',
      for: 'For',
      suggestion: 'Suggestion',
      more_information: 'More information',
      and: 'And',
      or: 'Or',
      send_request: 'Send request',
      request_sent: 'Request sent',
      misc_label: 'Miscellaneous',
      text: 'Text',
      title: 'Title',
      subtitle: 'Subtitle',
      nothing_selected_yet: 'Nothing selected yet',
      tools: 'Tools',
      from: 'From',
      by: 'By',
      created_by: 'Created by',
      to: 'To',
      go_to: 'Go to',
      custom: 'Custom',
      apply: 'Apply',
      quick_select: 'Quick select',
      select: 'Select',
      selected: 'Selected',
      select_all: 'Select all',
      show_selected: 'Show only selected',
      update: 'Update',
      save_as: 'Save as',
      saved: 'Saved',
      reset: 'Reset',
      show_all: 'Show all',
      show_more: 'Show more',
      show_less: 'Show less',
      read_more: 'Read more',
      share: 'Share',
      share_name: 'Share {{name}}',
      code: 'Code',
      link: 'Link',
      unlink: 'Unlink',
      will_be_unlinked_from: 'will be unlinked from',
      loading: 'Loading',
      mobile: 'Mobile',
      missing_configuration: 'Missing configuration',
      deactivate: 'Deactivate',
      activated: 'Activated',
      not_activated: 'Not activated',
      missing_data: 'Missing data',
      access: 'Access',
      account: 'Account',
      accounts: 'Accounts',
      account_levels: 'Account levels',
      activate: 'Activate',
      add: 'Add',
      allocation_keys: 'Allocation keys',
      api: 'API',
      api_key: 'API key',
      api_keys: 'API keys',
      authentication: 'Authentication',
      auto: 'Auto',
      back: 'Back',
      cancel: 'Cancel',
      confirm: 'Confirm',
      change_name: 'Change name',
      chart_of_accounts: 'Chart of accounts',
      close: 'Close',
      continue_in_background: 'Continue in background',
      close_side_panel: 'Close side panel',
      try_again: 'Try again',
      columns: 'Columns',
      coming_soon: 'Coming soon',
      companies: 'Companies',
      company_group: 'Customer',
      company_groups: 'Customers',
      preview_company_group: 'Preview customer',
      add_comment: 'Comment',
      original_value: 'Original value',
      edited_value: 'Edited value',
      comment_and_create_thread: 'Comment and create thread...',
      reply_to_thread: 'Leave a reply...',
      delete_comment_thread: 'Delete comment thread?',
      delete_comment: 'Delete comment?',
      continue: 'Continue',
      config: 'Configuration',
      integrations: 'Integrations',
      copy_link: 'Copy link',
      copy_to: 'Copy to',
      create: 'Create',
      created: 'Created',
      generated: 'Generated',
      handled: 'Handled',
      reviewed: 'Reviewed',
      unreviewed: 'Not reviewed',
      customization: 'Customization',
      dashboard: 'Dashboard',
      dashboards: 'Dashboards',
      delete: 'Delete',
      to_delete: 'to delete',
      description: 'Description',
      duplicate: 'Duplicate',
      economy: 'Financial metrics',
      edit: 'Edit',
      edit_columns: 'Edit columns',
      edit_title: 'Edit title',
      embed: 'Embed',
      export_to_excel: 'Export to .xlsx',
      export_to_excel_body:
        'Do you want to use or analyze the data in an external tool? Export it!',
      exporting_to_excel: 'Exporting to .xlsx',
      fallback_label: 'Unknown label',
      unknown: 'Unknown',
      missing_value: 'Missing value',
      home: 'Home',
      homepal_admin: 'Admin',
      member: 'Member',
      members: 'Members',
      groups: 'Groups',
      invite: 'Invite',
      invite_to_name: 'Invite to {{name}}',
      join: 'Join',
      leave: 'Leave',
      locked: 'Locked',
      move: 'Move',
      move_to: 'Move to',
      name: 'Name',
      next: 'Next',
      new: 'New',
      no_options_found: 'No options found',
      none: 'None',
      of: 'Of',
      open_side_panel: 'Open side panel',
      optional: 'Optional',
      overview: 'Overview',
      owner: 'Owner',
      owners: 'Owners',
      no_owner: 'No owner',
      no_owners: 'No owners',
      previous: 'Previous',
      publish: 'Publish',
      recommended: 'Recommended',
      reset_all: 'Reset all',
      report: 'Report',
      reports: 'Reports',
      resource: 'Resource',
      resources: 'Resources',
      required: 'Required',
      results: 'Results',
      save: 'Save',
      search: 'Search',
      settings: 'Settings',
      size: 'Size',
      step: 'Step',
      unpublish: 'Unpublish',
      unnamed: 'Unnamed',
      updated: 'Updated',
      user: 'User',
      users: 'Users',
      unit: 'Unit',
      value: 'Value',
      category: 'Category',
      status: 'Status',
      responsible: 'Responsible',
      subcategory: 'Subcategory',
      clear: 'Clear',
      clear_all: 'Clear all',
      clear_search: 'Clear search',
      set_name: 'Set name',
      shows: 'Shows',
      edit_mode: 'Edit mode',
      exit_editing: 'Exit editing',
      read_more_on_homepal_se: 'Read more on our website',
      about: 'About',
      preview: 'Preview',
      show: 'Show',
      hide: 'Hide',
      standard: 'Standard',
      custom_plural: 'Custom',
      done: 'Done',
      get_started: 'Get started',
      sign_out: 'Sign out',
      export: 'Export',
      exporting: 'Exporting',
      exported: 'Exported',
      options: 'Options',
      welcome: 'Welcome',
      image: 'Image',
      variant: 'Variant',
      transparent: 'Transparent',
      background: 'Background',
      restrict: 'Restrict',
      format: 'Format',
      quality: 'Quality',
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      resolution: 'Resolution',
      pixels: 'pixels',
      pixels_short: 'px',
      file_exported: 'The file has been exported',
      login_required: 'Log in to Homepal to use this functionality',
      help_text: 'Help text',
      lock: 'Lock',
      compare_with: 'Compare with',
      compare_with_short: 'Vs.',
      historical: 'Historical',
      forecast: 'Forecast',
      type: 'Type',
      types: 'Types',
      all_types: 'All types',
      all_company_types: 'All company types',
      shared_with: 'Shared with',
      last_changed: 'Last changed',
      trend: 'Trend',
      private: 'Private',
      public: 'Public',
      inactive: 'Inactive',
      move_left: 'Move left',
      move_up: 'Move up',
      move_right: 'Move right',
      move_down: 'Move down',
      now: 'Now',
      type_write: 'Type',
      will_be_deleted_are_you_sure:
        'will be deleted permanently and can not be recovered.',
      economical_calculation: 'Economical calculation',
      economical_calculations: 'Economical calculations',
      note: 'Note!',
      default: 'default',
      page: 'Page',
      pages: 'Sidor',
      locked_title: (
        <>
          Nothing to see here... <Emoji name="lock" />
        </>
      ),
      error: 'Error',
      error_500_title: 'Unable to load',
      error_500_helper_text:
        'Something went wrong while fetching this data. Please try again or refresh the page.',
      data_access: 'Data access',
      actions: 'Actions',
      manage: 'Manage',
      joined: 'Joined',
      duplicate_name_error: 'A name with that name already exists',
      unsaved_changes: 'Unsaved changes',
      sso: 'SSO',
      not_in_license: 'Not in your license',
      no_access: 'No access',
      pin: 'Pin',
      unpin: 'Unpin',
      linked_resources: 'Linked resources',
      not_found: 'Not found',
      something_went_wrong: 'Something went wrong',
      error_401_body: 'You do not seem to have permission to view this.',
      error_404_body: 'We could not find the page you were looking for.',
      error_500_body: 'Something seems to have gone wrong on our end.',
      reply: 'Reply',
      export_as_xlsx: (
        <>
          Export as <b>.xlsx</b>
        </>
      ),
      favorite: 'Favorite',
      favorites: 'Favorites',
      folder: 'Folder',
      trash: 'Trash',
      restore: 'Restore',
      grid: 'Grid',
      list: 'List',
      edition: 'Edition',
      editions: 'Editions',
      chart: 'Chart',
      untitled: 'Untitled',
      explore: 'Explore',
      templates: 'Templates',
      more: 'More'
    },

    accounting: {
      accounting_periods: 'Accounting periods',
      accounting_periods_helper_text:
        'Define when your accounting periods close. You can also set this to manual handling.',
      latest_closed_period: 'Latest closed accounting period',
      latest_closed_period_error_text:
        'Needs to be set when handling accounting periods manually.',
      no_chart_of_accounts: 'There are no chart of accounts yet.',
      select_predefined_calculation_helper_text:
        'Select a predefined calculation to create a comparison figure for the metric. This can be done for financial metrics.',
      edit_account_references: 'Edit account references',
      'and_{{count}}_others': 'and {{count}} others',
      edit_account_level: 'Edit account level',
      calculation_block: 'Calculation block',
      constant: 'Constant',
      select_account_level: 'Select account level',
      accounts: 'Accounts',
      account_references: 'Account references',
      account_references_helper_text:
        'Select which accounts should belong to each account level',
      account_level_in_use:
        'The account level is used in a metric and therefore cannot be deleted',
      standard_account_level_locked:
        'The account level is part of Homepal\'s standard and cannot be deleted or modified',
      account_level_name_exists_error:
        'An account level with that name already exists.',
      add_account_level: 'Add account level',
      account_level: 'Account level',
      account_levels: 'Account levels',
      account_levels_description:
        'The order is used to sort visualizations in a natural and logical sequence for financial accounts.',
      account_levels_helper_text:
        'Define account levels as a tree structure and link accounts to the right level.',
      '{{count}}_unused_accounts_warning':
        '{{count}} account(s) in the chart of accounts are not used in any account level.',
      unused_accounts: 'Unused accounts',
      unused_accounts_helper_text:
        'The following accounts in the chart of accounts are not used in any account level.'
    },

    company_groups: {
      all_company_groups_have_access: 'All customers have access',
      add_company: 'Add company',
      edit_company_group: 'Edit customer',
      delete_from_company_group: 'Delete from customer',
      delete_user_title: 'Delete user?',
      delete_company_from_company_group_title: 'Delete company from customer?',
      'delete_company_from_company_group_body_{{companyGroupName}}_{{companyName}}':
        'Users belonging to the customer {{companyGroupName}} will no longer be able to access data related to the company {{companyName}}. Are you sure?',
      no_companies_without_company_group:
        'No companies are missing customer affiliation. Remove a company from a customer to add it to this one.',
      no_company_groups_without_chart_of_accounts:
        'No customers are missing a chart of accounts. Remove a customer from a chart of accounts to add it to this one.',
      missing_companies: '(Missing companies)',
      'rename_{{name}}': 'Rename "{{name}}"',
      'invite_to_{{name}}': 'Invite to {{name}}',
      show_id: 'Show id',
      '{{count}}_missing_company_group': '{{count}} companies missing customer',
      add_company_group: 'Add customer',
      add_to_new_company_group: 'Add to new customer',
      structure_changed_warning:
        'The customer and company structure has changed. Your data is not up to date yet — run a data update for the changes to take effect.',
      rerun_ontology: 'Update data',
      rerun_ontology_running: 'Updating data',
      rerun_in_progress:
        'Data update in progress — the changes will be visible once it finishes.',
      'takes_about_{{minutes}}_min': 'This takes about {{minutes}} min.',
      delete_company_group_warning: (
        <>
          Associated users will be deleted. Associated companies will be placed
          under <i>No customer</i>.
        </>
      ),
      helper_text: (
        <>
          <b>
            Here you control which customers have access to data under which
            companies.
          </b>{' '}
          Updates will take effect in your dashboards at the next data load.
        </>
      )
    },

    chart_of_accounts: {
      delete_chart_of_accounts_title: 'Delete chart of accounts',
      delete_chart_of_accounts_body:
        'The chart of accounts will be permanently deleted. Groups currently using it will be moved under "missing chart of accounts". Are you sure?',
      delete_account: 'Delete account',
      edit_account: 'Edit account',
      account_number_exists_error:
        'The account number is already used in the chart of accounts',
      account_number_invalid_error:
        'The account number must be a number between 1000-9999',
      add_account: 'Add account',
      account_number: 'Account number',
      edit_chart_of_accounts: 'Edit chart of accounts',
      edit_accounts: 'Edit accounts',
      create_chart_of_accounts: 'Create a chart of accounts',
      duplicate_chart_of_accounts: 'Duplicate chart of accounts',
      duplicate_chart_of_accounts_body:
        'The accounts of the chart of accounts are copied to a new chart of accounts. The customers of the chart of accounts are not copied.',
      duplicate_account_references: 'Also duplicate account references',
      '{{name}}_copy': '{{name}} (copy)',
      upload_instructions:
        'The chart of accounts must be uploaded in CSV format. The first column should contain the 4-digit account number and the second column the account name.',
      '{{count}}_missing_chart_of_accounts':
        '{{count}} customer(s) are missing a chart of accounts',
      main_chart_of_accounts: 'Main chart of accounts',
      upload_file: 'Upload file',
      add_accounts_manually: 'Add manually',
      manual_instructions:
        'The chart of accounts is created empty. You then add accounts one at a time.',
      companies_required: 'At least one company is required.',
      '{{count}}_companies': '{{count}} companies',
      no_companies: 'No companies, not in use yet',
      companies_helper_text:
        'These companies use this chart of accounts instead of the main one. A company can only have one chart of accounts of its own.',
      company_specific_instructions:
        'The new chart of accounts applies to the companies you choose. Other companies use the main chart of accounts.',
      delete_company_specific_chart_of_accounts_body:
        'The chart of accounts will be permanently deleted. Its companies go back to the main chart of accounts. Are you sure?',
      helper_text:
        'Manage which accounts to use in the application. Typically updated by uploading a CSV file.'
    },

    economy: {
      page_title: 'Manage financial metrics',
      page_body:
        'View accounts, charts of accounts, and financial metrics for your organization.',
      metrics_helper_text:
        'Define calculations for financial metrics or create your own. Based on your accounts.'
    },

    configuration: {
      page_title: 'Configure organization specifics',
      page_body:
        'Configure mixed features and defaults across your organization.',
      all_included: 'All included',
      excluded_types: '{{types}} excluded',
      excluded_of: '{{excluded}} of {{total}} excluded',
      included_summary: '{{included}} included · {{excluded}} excluded',
      new_summary: '{{count}} new',
      new_summary_one: '{{count}} new',
      pending_data_run: 'Takes effect after the next data run',
      pending_data_run_tooltip:
        'Changed {{date}}. The figures in Homepal are updated when the next data run is done.',
      object_row_types_body:
        'Choose which charge types are included. Applies to the rent on objects. Charge types on leases are not affected. An excluded type is removed from every calculation that builds on the rent on objects, for example vacancy rent, yearly cost, rental loss, price level and standard rent. The setting applies to the whole organization. Types that appear after you have saved are marked as new.',
      new_since_last_save: 'New since you last saved',
      new_body: 'New types are included until you exclude them.',
      new_tag: 'New',
      in_data: 'In the data',
      missing_in_data: 'Missing in the data',
      missing_body:
        'These types are not in the latest data and stay excluded if they come back. Remove a type if you no longer want to exclude it.',
      remove: 'Remove',
      acknowledged_on_save: '{{types}} are marked as reviewed when you save.',
      acknowledged_on_save_one:
        '{{types}} is marked as reviewed when you save.',
      takes_effect_after_data_run:
        'The change takes effect after the next data run.',
      new_types_banner:
        'New charge types on objects: {{types}}. They are included until you exclude them.',
      new_types_banner_one:
        'New charge type on objects: {{types}}. It is included until you exclude it.'
    },

    api_keys: {
      description:
        'Here you can see your API keys. These keys can be shared with a third party that needs to embed dashboards on a website. With an API key, the third party can fetch information about your customers and generate unique links to dashboards. These links are valid for 1 hour. If you are unsure how this works, do not hesitate to contact us for help.',
      create_key: 'Create a key',
      page_title: 'Manage API keys',
      page_body: 'Create and revoke keys for secure system integrations.',
      key_type_label: 'Key type',
      name_helper:
        'Each integration or recipient should have its own key to track usage and easily revoke access when needed.'
    },

    sso: {
      page_title: 'Manage SSO',
      page_body: 'Setup your SSO and handle allowed email domains.',
      sso_not_in_license_title: 'SSO is not included in your license',
      sso_not_in_license_body:
        'This feature is not included in your current license. Contact hej@homepal.se if you want to enable SSO.',
      entra_id_title: 'Entra ID',
      entra_id_helper_text:
        'Enable Entra ID authentication to allow users to sign in to Homepal using their Entra ID account.',
      specifications_title: 'Specifications',
      specifications_helper_text:
        'Set up SAML SSO in Entra ID using the following details:',
      details_title: 'Details',
      details_helper_text:
        'Enter details from your SSO service in the fields below.',
      app_federation_metadata_url_label: 'App Federation Metadata URL',
      from_microsoft_azure_ad_caption: 'from Microsoft Azure AD',
      group_id_label: 'Group ID',
      group_id_helper_text:
        'This is only needed if you have multiple Homepal setups in your organization.',
      mail_domains_title: 'Email domains',
      mail_domains_helper_text:
        'Enter which email domains should be allowed to sign in with Microsoft Azure AD. The domain should be written without \'@\' (e.g. fastigheter.se).',
      warning_note_title: 'Keep in mind!',
      warning_note_body:
        'You can’t specify public domains (such as gmail.com or outlook.com). Enter the domain without @.',
      idp_groups_title: 'Group mappings',
      idp_groups_helper_text:
        'Map IDP groups to Homepal system groups. Group memberships are synced automatically on login.',
      idp_group_id_label: 'IDP group ID',
      add_idp_group: 'Add group',
      need_help_caption: 'Need help?',
      show_detailed_instructions_link: 'Show detailed instructions'
    },

    settings: {
      page_title: 'Manage organization settings',
      page_body:
        'Adjust how the application and features works for your organization.'
    },

    status_banner: {
      read_more: 'Read more',
      collapse: 'Collapse',
      more_messages_one: '+{{count}} message',
      more_messages_other: '+{{count}} messages',
      system_messages: '{{count}} system messages',
      level_info: 'Info',
      level_important: 'Important'
    },

    loading: {
      collecting_data: 'Collecting data from your systems',
      syncing_processing: 'Synchronizing and processing your data',
      performing_calculations: 'Performing the required calculations',
      simplifying_data: 'Making your data simple and understandable',
      presenting_data: 'Trying to present your data',
      loading_metrics: 'Loading metrics',
      analyzing_metrics: 'Analyzing which metrics you can create'
    },

    guides: {
      how_homepal_works: 'How does Homepal work?',

      welcome_title: <>Welcome to Homepal! 🎉</>,
      welcome_body: (
        <Text paragraph variant="inherit">
          Homepal is a tool that helps automate your reporting and follow-up
          using ready-made metrics and available data.
        </Text>
      ),
      welcome_hint: (
        <>
          This guide takes <b>less than 2 minutes</b> and shows you how to
          easily find the information you&#39;re looking for.
        </>
      ),

      dashboards_title: <>Dashboards</>,
      dashboards_body: (
        <>
          <Text paragraph variant="inherit">
            A <code>dashboard</code> is a canvas where KPIs, metrics, and data
            are visualized to give you a clear overview.
          </Text>
          <Text paragraph variant="inherit">
            Dashboards you have access to are shown on your start screen or
            organized in folders. You can also reach them via the sidebar to the
            left.
          </Text>
          <Text paragraph variant="inherit">
            <b>If you don&#39;t see any dashboards</b>, contact your
            administrator to get access.
          </Text>
        </>
      ),
      dashboards_hint: (
        <>For quicker access to your key dashboards, mark them as favorites!</>
      ),

      tabs_title: <>Tabs</>,
      tabs_body: (
        <Text paragraph variant="inherit">
          Each dashboard can contain several <code>tabs</code>. Use them to
          navigate between different pages in a dashboard.
        </Text>
      ),
      tabs_hint: (
        <>
          A dashboard <u>does not need</u> multiple tabs. If you don&#39;t see
          any, there likely aren&#39;t any.
        </>
      ),

      filters_title: <>Filters</>,
      filters_body: (
        <>
          <Text paragraph variant="inherit">
            Use available <code>filters</code> in the sidebar on the right to
            display only what you&#39;re interested in.
          </Text>
          <Text paragraph variant="inherit">
            You can also adjust the time period. Choose a preset like{' '}
            <code>Year to date</code>, <code>Last 90 days</code>, or{' '}
            <code>Yesterday</code> — or enter custom dates.
          </Text>
        </>
      ),
      filters_hint: (
        <>
          Missing a specific filter? Contact your administrator - they can add
          it easily.
        </>
      ),

      widgets_title: <>Widgets</>,
      widgets_body: (
        <>
          <Text paragraph variant="inherit">
            Dashboards are built with <code>widgets</code> (small rectangles)
            that contain different data visualizations. In the top right corner
            you can:
          </Text>
          <Text paragraph variant="inherit">
            <ul className="ul">
              <li className="li">
                <b>Enlarge</b> the visualization
              </li>
              <li className="li">
                <b>View info</b> about the data
              </li>
              <li className="li">
                <b>Open table view</b>
              </li>
              <li className="li">
                <b>Export to .xlsx</b>
              </li>
            </ul>
          </Text>
        </>
      ),
      widgets_hint: (
        <>
          Want to work with the widget&#39;s data in another tool? Just export
          it to .xlsx!
        </>
      ),

      charts_title: <>Charts</>,
      charts_body: (
        <>
          <Text paragraph variant="inherit">
            Most widgets use <code>charts</code> to show data. Click a segment
            (bar, number, pie slice) to:
          </Text>
          <Text paragraph variant="inherit">
            <ul className="ul">
              <li className="li">
                <b>Add filter</b> based on segment
              </li>
              <li className="li">
                <b>View underlying data</b> in table
              </li>
              <li className="li">
                <b>Drill down</b> for deeper insights
              </li>
            </ul>
          </Text>
        </>
      ),
      charts_hint: (
        <>Click segments to quickly analyze specific parts of your data.</>
      ),

      templates_title: <>Explore</>,
      templates_body: (
        <>
          <Text paragraph variant="inherit">
            In the left-hand menu (under <code>Explore</code>) you&#39;ll find a
            catalog of the most common dashboards in the industry, curated from
            our customers&#39; insights.
          </Text>
          <Text paragraph variant="inherit">
            <b>As an administrator</b>, you can activate a dashboard directly
            into your Homepal environment with a single click.
          </Text>
        </>
      ),
      templates_hint: (
        <>
          Found an interesting dashboard but don&#39;t have access to activate
          it? Contact your admin!
        </>
      ),
      delete_confirmation_suffix: 'will be permanently deleted. Are you sure?'
    },

    allocation_keys: {
      about: (
        <>
          <strong>
            Allocation keys can be used to distribute central costs across
            properties based on specific criteria
          </strong>
          , such as leasable area or other percentage-based splits. By using
          allocation keys, you get a more accurate view of cost distribution and
          can more easily monitor finances at the property level.{' '}
          <strong>
            Updates to allocation keys will take effect at the next data load
            from the source system.
          </strong>
        </>
      ),
      distributes: 'Distributes',
      empty_accounts_tooltip:
        'At least one account must be selected for allocation.',
      empty_name_tooltip: 'The name cannot be left empty.',
      name_key_subtitle:
        'Give your allocation key a name so you can distinguish it from others.',
      name_key_title: 'Name your allocation key',
      select_accounts_subtitle:
        'Select the accounts to be distributed using this key. You can choose all accounts that should be allocated in the same way.',
      select_accounts_title: 'Select accounts',
      select_allocation_subtitle:
        'Choose how account balances not already distributed by cost centers should be allocated across properties.',
      share: 'Share (%)',
      select_allocation_title: 'Select allocation',
      total_allocation_zero_error: 'Total allocation cannot be 0%.',
      total_allocation_above_100_error: 'Total allocation cannot exceed 100%.',
      total_allocation: 'Total allocation'
    },

    companies: {
      activation_status_helper_text: (
        <>
          <b>Select which companies to include in the data synchronization.</b>{' '}
          Data linked to excluded companies will not be available in the
          organization&#39;s dashboards. This can be used, for example, to
          exclude test companies or inactive entities. Updates will take effect
          in your dashboards at the next data load.
        </>
      ),
      page_title: 'Manage companies',
      page_body: 'Add, edit, and link companies in your portfolio.'
    },

    integrations: {
      page_title: 'Manage integrations',
      page_body:
        'Configure and monitor your integrations and their connections.',
      fortnox_page_title: 'Fortnox',
      fortnox_page_body:
        'View the connection status of your Fortnox tenants and reconnect when needed.',
      tenant_name: 'Tenant',
      organization_number: 'Organization number',
      status: 'Status',
      message: 'Message',
      last_successful_run: 'Last successful run',
      last_checked_at: 'Last checked',
      status_ok: 'Connected',
      status_needs_reauth: 'Needs reauthorization',
      status_missing_license: 'License missing',
      reconnect: 'Reconnect',
      authenticate_new_tenant: 'Authenticate new tenant',
      remove_tenant: 'Remove tenant',
      home_warning:
        'Fortnox: {{count}} tenants have lost their connection and need attention.',
      home_warning_action: 'View',
      no_tenants: 'No tenants found.'
    },

    customization: {
      contrast_warning:
        'The contrast between the {{text}} text colour and the widget background is {{ratio}}:1. WCAG 2.1 AA requires at least 4.5:1 for text.',
      background_colors_helper_text:
        ' custom background colors for dashboards and widgets. Note that the application\'s automatic color mode is disabled when custom selection is made.',
      text_colors_helper_text:
        'Select custom text colors for dashboards and widgets. Note that the application\'s automatic color mode is disabled when custom selection is made.',
      background_colors_title: 'Background',
      colors_helper_text:
        'Adjust the color scheme to match the organization\'s visual identity and branding.',
      colors_title: 'Colors',
      dashboard_color: 'Dashboard',
      negative_color: 'Negative color',
      positive_color: 'Positive color',
      primary_color: 'Primary',
      profile_colors_title: 'Profile',
      secondary_color: 'Secondary',
      status_colors_helper_text: (
        <>
          <strong>Note!</strong> You should avoid using green, yellow, or red in
          your custom chart or text colors above. These are already used to
          indicate positive or negative trends in KPIs, and in some cases also
          as status indicators.
        </>
      ),
      status_colors_title: 'Status',
      tertiary_color: 'Tertiary',
      text_colors_title: 'Text',
      warning_color: 'Warning color',
      widget_color: 'Widget',
      page_title: 'Customize the application',
      page_body: 'Manage colors and logotype to match your brand.',
      logotype: 'Logotype',
      logotype_helper_text:
        'Add your logo in order to make the application feel like yours.'
    },

    dashboards: {
      error_not_found_body:
        'The dashboard you are looking for does not exist or has been removed.',
      error_server_body:
        'Something went wrong when loading the dashboard. Try again or go back.',
      error_no_access_body:
        'You do not have permission to view this dashboard. Contact your administrator to get access.',
      error_public_dashboard_body:
        'The dashboard could not be loaded. Check that the link is correct or contact the person who shared it with you.',
      error_public_widget_body:
        'The widget could not be loaded. Check that the link is correct or contact the person who shared it with you.',
      dashboard_not_visible: 'This dashboard is not visible to users.',
      add_tag: 'Add tag',
      tags_helper_text:
        'Tags are used to add extra information about the tab when embedding in third-party solutions, e.g. sorting or other metadata. The tags are saved as a list in the tab\'s custom fields.',
      disabled_preview_widget_tooltip:
        'You cannot include widgets that have additional dimensions or show the total.',
      editing_mode_active: (
        <>
          <b>You are in editing mode.</b> All changes are updated immediately
          and saved automatically.
        </>
      ),
      editing_mode_limitations: (
        <>
          <b>Limited functionality in editing mode</b>
          <br />
          In editing mode, we have limited some features that are intended for
          view mode, such as click interactions in widgets, to make editing
          smoother.
        </>
      ),
      select_dashboard_to_copy_tab:
        'Select the dashboard you want to copy your tab to.',
      select_dashboard_to_move_tab:
        'Select the dashboard you want to move your tab to.',
      move_tab_warning: (
        <>
          <b>Note!</b> If you move the tab, it will be removed from the current
          dashboard. Any user statistics will also move along to the new
          dashboard.
        </>
      ),
      copying_to_dashboard: 'Copying to dashboard',
      moving_to_dashboard: 'Moving to dashboard',
      tab_name_required_error: 'Your tab must have a name.',
      no_access_to_tab: 'You do not have access to this tab.',
      external_access_public: 'External access via public link',
      external_access_protected: 'External access via protected link',
      add_tab: 'Add tab',
      tab_not_public: 'The tab is not public',
      copy_tab_public_link: 'Copy the tab\'s public link',
      cannot_share_draft: 'Drafts cannot be shared',
      tab: 'Tab',
      widget: 'Widget',
      show_info: 'Show information',
      show_content: 'Show content',
      dashboard_full: 'The dashboard is full',
      all_dashboards: 'All dashboards',
      empty_dashboards_title: (
        <>
          No dashboards... yet <Emoji name="seedling" />
        </>
      ),
      empty_folder_body:
        'Move a dashboard to this folder and it will appear here.',
      empty_dashboards_body:
        'Create and publish a dashboard and it will appear here.',
      empty_drafts_body:
        'Dashboards that have not been published will appear here.',
      empty_favorites_body:
        'Mark a dashboard as favorite and it will appear here',
      empty_favorites_title: (
        <>
          No favorites... yet <Emoji name="seedling" />
        </>
      ),
      empty_visits_body: 'Visit a dashboard and it will appear here',
      empty_drafts_title: (
        <>
          No drafts... yet <Emoji name="seedling" />
        </>
      ),
      empty_visits_title: (
        <>
          No visits... yet <Emoji name="seedling" />
        </>
      ),
      favorites: 'Favorites',
      folders: 'Folders',
      to_dashboards: 'Go to all dashboards',
      search_for_dashboard: 'Search for dashboard',
      create_dashboard: 'Create dashboard',
      create_folder: 'Create folder',
      folder_in_folder_tooltip:
        'It is not possible to create a folder inside another folder.',
      dashboard_limit_reached_tooltip:
        'Your organization is using all dashboards included in your license. Remove a dashboard or contact us to upgrade your license.',
      delete_folder_question_title: 'Delete folder?',
      delete_folder_body_1: 'Your folder',
      delete_folder_body_2: (
        <>
          will be permanently deleted. Dashboards in the folder will be moved to{' '}
          <code>Unassigned</code>. Are you sure?
        </>
      ),
      sort_by_latest_visit_tooltip: (
        <>
          Sort by <b>Most recently visited</b>
        </>
      ),
      sort_by_alphabetical_tooltip: (
        <>
          Sort by <b>A-Z</b>
        </>
      ),
      sort_by_latest_edit_tooltip: (
        <>
          Sort by <b>Most recently edited</b>
        </>
      ),
      remove_from_group: 'Remove from group',
      select_folder: 'Select folder',
      delete_dashboard_title: 'Delete dashboard?',
      duplicate_tag: 'A tag with that name already exists.',
      favorite_unpublished_tooltip: 'Drafts cannot be marked as favorite',
      remove_favorite_tooltip: 'Remove from favorites',
      add_favorite_tooltip: 'Add to favorites',
      templates_dashboards_title_1: (
        <>
          Explore dashboards
          <br />
          from
        </>
      ),
      templates_dashboards_title_2: 'real estate companies',
      templates_dashboards_body: (
        <>
          Browse real dashboards and see how your industry peers are tracking
          their operations. Get inspiration, discover new ideas and take the
          next step towards more data-driven management with the help of our
          community.
        </>
      ),
      views: 'Views',
      view: 'View',
      view_in_fullscreen: 'View in fullscreen',
      copied_to_clipboard: 'Copied to clipboard',
      activate_dashboard: 'Activate dashboard',
      activate_dashboard_info:
        'The dashboard will be placed under "Drafts" and will only be accessible to you until you choose to publish it.',
      activate_disabled_no_permission:
        'You do not have permission to create a new dashboard. Contact your administrator if you need help or want to request access.',
      activate_disabled_limit_reached:
        'Your organization has reached the dashboard limit for your license. Remove an existing dashboard or contact us to upgrade your license.',
      activate_disabled_no_access_metrics:
        'You cannot activate this dashboard because it contains metrics you do not have access to. Contact an administrator if you need access.',
      activating_dashboard_loading_1: 'Setting up the dashboard',
      activating_dashboard_loading_2: 'Adjusting data',
      activate_restricted_period_info:
        'This dashboard contains widgets with the setting "until latest closed accounting period". For them to display the correct data, your latest closed accounting period needs to be set.',
      activate_restricted_period_link: 'Set up accounting periods',
      activate_restricted_period_no_access:
        'Ask an administrator or economy manager to set up accounting periods.',
      created_by_homepal: 'Created by Homepal',
      created_by_homepal_body:
        'This dashboard was created and customized by us at Homepal using our fictional demo data. The concept and idea came from one of our customers.',
      created_by_customer_body:
        'This dashboard was created by one of our users and submitted to be shared with industry peers. Homepal has reviewed and published it with demo data.',
      get_help_activating_dashboard_title: 'Get help building',
      get_help_activating_dashboard_body:
        'Want to activate this dashboard in your organization but don\'t know how to build it? Send us a request and we\'ll help you!',
      suggest_a_dashboard_title: 'Suggest a dashboard',
      suggest_a_dashboard_short_title: 'Suggest',
      submit_a_dashboard_short_title: 'Submit',
      suggest_a_dashboard_body:
        'Missing an example of a certain type of dashboard? Or do you have an idea for visualized data that you think you and your industry peers could benefit from?',
      suggest_a_dashboard_name_placeholder:
        'E.g. Benchmarking of maintenance requests across our properties',
      suggest_a_dashboard_description_placeholder:
        'E.g. It would be interesting to get inspiration on how to set up a dashboard to visualize maintenance requests in our properties — and especially to compare them with each other. Which KPIs and visualizations are relevant?',
      submit_a_dashboard_title: 'Submit a dashboard',
      submit_a_dashboard_body:
        'Do you have an example of a dashboard you\'d like to share with your industry peers? We\'ll anonymize it for you and publish it here in our catalog.',
      submit_a_dashboard_motivation_placeholder:
        'E.g. I believe the tab called "Maintenance Requests" could be very interesting for other companies as well. Feel free to publish it here using your fictional data!',
      motivation: 'Motivation',
      why_you_should_use_dashboard_title: 'Why should you use this dashboard?',
      tips: 'Tips!',
      systems_in_use_title: 'Which systems can be used?',
      property_management_systems_title:
        'Examples of property management systems',
      other_systems_title: 'Examples of complementary systems',
      about_dashboard: 'About the dashboard',
      about_dashboard_missing: 'Description is missing...',
      about_dashboard_helper_text:
        'Explain the purpose of the dashboard and how it should be used.',
      about_dashboard_placeholder:
        'E.g. This dashboard provides a clear overview of how much rental income is lost due to vacant commercial spaces or unrented apartments. By visualizing the actual impact of vacancies on revenue, you can quickly identify risk areas and opportunities for improvement.\n\nHow to use this dashboard:\n\t• Total rental loss: Start by reviewing the total amount of lost rental income.\n\t• This gives you a quick understanding of how vacancies affect your operations.\n\t• Vacancy rate per property/area: Identify which properties or areas...',
      name_placeholder: 'E.g. Overview of rental loss',
      name_helper_text:
        'Give your dashboard a clear name that stands out from the rest.',
      name_error_text:
        'Your dashboard must have a name and cannot be called "Untitled" or contain "Copy".',
      only_owners_and_added_can_use:
        'Only the owner and added groups or users can use the dashboard.',
      user_or_group: 'user or group',
      cannot_remove_owner: 'You cannot remove access for the dashboard owner',
      cannot_remove_admin: 'You cannot remove access for admins',
      remove_access: 'Remove access',
      private_dashboard: 'Private dashboard',
      access_helper_text:
        'Choose how the dashboard should be shared within the organization.',
      owner_helper_text:
        'Select an owner to manage the dashboard and act as a point of contact.',
      placement_title: 'Placement',
      placement_helper_text:
        'Place your dashboard in a folder to make it easy to find.',
      folder_selection_requires_publish_tooltip:
        'You need to publish your dashboard before placing it in a folder.',
      owner_change_requires_publish_tooltip:
        'You need to publish your dashboard before changing the owner.',
      edit_information: 'Edit information',
      publish_dashboard: 'Publish dashboard',
      initial_info_note: (
        <>
          <Text gutterBottom={true}>
            This information is shown the first time a user opens the dashboard.
            After that, it can be accessed via the info button next to the
            dashboard title.
          </Text>
          <Text>You can always edit this later.</Text>
        </>
      ),
      sensitive_metrics_note: (
        <Text>
          Some metrics may be sensitive. Keep in mind that everyone with access
          to the dashboard can see them.
        </Text>
      ),
      intro_text_part_1: (
        <>
          This dashboard provides insights and data that will hopefully support
          your work.
          <br />
          Read more about what the owner has to say about
        </>
      ),
      intro_text_part_2: <>below:</>,
      delete_widget_title: 'Delete widget?',
      enable_external_access: 'Enable external access',
      enable_external_access_helper_text:
        'To embed your {{component}}, you need to select an external access type.',
      embed_link_title: 'Copy and paste',
      embed_link_helper_text:
        'Use the code below in your third-party application (or open the link directly in your browser) to display your {{component}}. You can use the filter on the right or the settings below to modify your code (or link) based on your needs.',
      embed_settings_temporary_notice:
        'These settings are not saved permanently but are temporarily used to help you add them to your link or code block.',
      enable_external_access_to_embed:
        'Enable external access to start embedding.',
      confirm_change_access_type_title: 'Change access type',
      confirm_change_access_type_body:
        'Are you sure you want to change the access type? Your current link will stop working.',
      protected_link: 'Protected link',
      protected_link_description:
        'Actors with an API key can generate a protected and temporary link that grants access to the tab for up to one hour.',
      public_link: 'Public link',
      public_link_description:
        'Anyone with access to the public link can view the tab without being logged in.',
      auto_description:
        'The simplest option. The embed will take up the available width and height.',
      auto_label: 'Automatic',
      fixed_description:
        'Ensure the embed is always a specific size by setting the width and height.',
      fixed_label: 'Fixed size',
      responsive_mode_label: 'Responsive mode',
      responsive_mode_description:
        'Allows the embed to switch to mobile layout at a defined breakpoint.',
      breakpoint_description:
        'Specify the width at which the embed should switch to mobile mode.',
      breakpoint_requirement_note: (
        <>
          Requires <b>Mobile</b> to be enabled as a responsive mode.
        </>
      ),
      breakpoint_label: 'Breakpoint',
      functionality_label: 'Functionality',
      user_filter_description:
        'Allows the user to access user filters within the embed.',
      user_filter_label: 'User filter',
      image_export_description:
        'Allows the user to export the embed as an image.',
      image_export_label: 'Image export',
      hide_footer_description:
        'Gives you a minimal version of the embed without the footer.',
      hide_footer_label: 'Hide footer',
      auto_refresh_description:
        'Reloads the page automatically, intended for screens that stay up for long periods without anyone touching them.',
      auto_refresh_label: 'Auto refresh',
      auto_refresh_mode_label: 'Mode',
      auto_refresh_mode_description:
        'The underlying data is usually updated during the night, so a time in the morning gives you fresh numbers all day from a single reload.',
      auto_refresh_mode_clock: 'Time of day',
      auto_refresh_mode_interval: 'Interval',
      auto_refresh_clock_description:
        'The page reloads at this time every day, according to the clock on the screen itself.',
      auto_refresh_clock_label: 'Time',
      auto_refresh_interval_description:
        'How often the page reloads. Intervals shorter than ten minutes are not allowed.',
      auto_refresh_interval_label: 'Interval',
      auto_refresh_requirement_note: 'Requires auto refresh to be turned on.',
      auto_refresh_option_10_minutes: 'Every ten minutes',
      auto_refresh_option_30_minutes: 'Every thirty minutes',
      auto_refresh_option_hourly: 'Every hour',
      auto_refresh_option_2_hours: 'Every two hours',
      auto_refresh_option_4_hours: 'Every four hours',
      auto_refresh_option_12_hours: 'Every twelve hours',
      temporary_settings_notice:
        'These settings are not saved permanently but are temporarily used to help you add them to your link.',
      filter_parameters_intro:
        'Add parameters to your link to dynamically filter your embed.',
      can_i_filter_more_question: 'Can I filter by more things?',
      filter_limitations_info_1:
        'You only have access to the same filters available in the dashboard\'s right-hand side menu.',
      filter_limitations_info_2:
        'So you need to add a filter there in order to use it here.',
      private_embed_label: 'Private embed',
      token_instruction: (
        <>
          Replace <code>YOUR_TOKEN</code> with the token you received from the
          API request above.
        </>
      ),
      copy_embed_code: 'Copy embed code',
      copy_embed_link: 'Copy embed link',
      // API details
      generate_temporary_link: 'Generate temporary link',
      generate_temporary_link_helper:
        'Use the information below to generate a temporary link that provides access to the tab for up to one hour. The link is included in the response from your API request.',
      key: 'Key',
      required: 'Required',
      query_parameter: 'Query parameter',
      header: 'Header',
      create_manage_company_groups: 'Create and manage customers under',
      create_manage_api_keys: 'Create and manage API keys under',
      companies: 'Companies',
      api_keys: 'API keys',
      include_widgets: 'Include widgets',
      include_widgets_helper:
        'You can choose to include specific widgets in the response from the API request above. For example, to create a custom preview in a third-party application.'
    },

    reports: {
      all_reports: 'All reports',
      create_report: 'Create report',
      description_placeholder: 'This report focuses on...',
      empty_filters_body:
        'Add one or more filters that can be used when creating an edition.',
      empty_filters_cta: 'Add filter',
      empty_filters_title: (
        <>
          No filters... yet <Emoji name="seedling" />
        </>
      ),
      empty_reports_body:
        'Create and publish a report and it will appear here.',
      empty_reports_title: 'No reports... yet',
      empty_widgets_body: 'Shape your report template by start adding widgets.',
      empty_widgets_cta: 'Add widget',
      empty_widgets_title: (
        <>
          No widgets... yet <Emoji name="seedling" />
        </>
      ),
      empty_editions_body:
        'Create an edition from the current report template.',
      empty_editions_title: (
        <>
          No editions... yet <Emoji name="seedling" />
        </>
      ),
      go_to_template: 'Go to template',
      reports: 'Reports'
    },

    report_edition: {
      configure_data: 'Configure data',
      content_edited: 'Content edited',
      data_locked: 'Data locked',
      edit_content: 'Edit content',
      lock_data: 'Lock data',
      lock_data_and_edit: 'Lock data and edit content',
      set_period_and_filters:
        'Set the time period and filters for the data snapshot. Then lock the data to start editing content.',
      set_numbers_and_content: (
        <>
          Click on any chart element to change its value, or edit the text
          blocks directly. When you&apos;re done, come back here and continue
          with the next step.
        </>
      ),
      unlock: 'Unlock',
      you_can_now_edit: 'Scroll down to edit charts and text',
      title_helper_text: (
        <>
          Give your edition a descriptive title, e.g. &quot;Q1 2026
          (North)&quot;. Publish to make it available to other users.
        </>
      ),
      previously_used_text_field: 'Previously used text field',
      generate_text_from_ai: 'Generate text from AI',
      insert_text_from_placeholder: 'Insert text from...',
      insert_text_from_previous_edition:
        'Select an edition and copy its text as a starting point.',
      lock_dialog_body:
        'The selected period and filters will be locked. This can\'t be undone.',
      locking_data: 'Locking data',
      edit_columns_locked: 'Cannot edit columns when the edition is locked',
      publishing: 'Publishing',
      publish_dialog_body:
        'This edition will be visible to all users in your organization.'
    },

    export_tables: {
      table: 'Table',
      tables: 'Tables',
      all_tables: 'All tables',
      choose_metric: 'Choose metric',
      // API sharing
      api_access_title: 'API access',
      api_access_helper:
        'Make the table available as an API call for external systems and integrations.',
      available_via_api: 'Available via API',
      available_via_api_body:
        'External systems with a valid API key can retrieve the table data in JSON format.',
      endpoint_title: 'Endpoint',
      endpoint_helper: 'The full URL used to retrieve data.',
      endpoint_auth_helper:
        'Include your API key in the Authorization header when making requests.',
      copy_endpoint: 'Copy endpoint',
      edit_slug: 'Edit slug',
      authorized_api_keys_title: 'Authorized API keys',
      authorized_api_keys_helper:
        'Only selected API keys have permission to retrieve data from this table.',
      add_api_key: 'Add API key',
      create_api_key: 'Create new API key',
      remove_api_key: 'Remove access',
      // API key dialog (reverse)
      authorized_export_tables_title: 'Authorized tables',
      authorized_export_tables_helper:
        'Only selected tables can be retrieved with this API key.',
      add_export_table: 'Add table',
      remove_export_table: 'Remove access',
      // Slug dialog
      activate_api: 'Activate API',
      slug_change_warning:
        'Changing the slug will cause existing integrations using the current endpoint URL to stop working.',
      slug_helper:
        'The slug is the unique identifier in the URL. Use only lowercase letters (a-z) and hyphens (-).',
      choose_slug: 'Choose slug',
      new_slug: 'New slug',
      slug_empty_error: 'Slug cannot be empty. Use only a-z and hyphens (-).',
      slug_taken_error: 'This slug is already in use. Choose another.',
      slug_invalid_error: 'Slug can only contain a-z and hyphens (-).',
      preview_title: 'Preview',
      preview_helper: 'This is how the full URL will look.',
      no_access_body:
        'You do not have permission to use Tables. Contact your administrator to get access.'
    },

    groups: {
      notify_users_title: 'Notify users',
      notify_users_body:
        'Users will be notified by email that they’ve been invited to the group.',
      delete_group: 'Delete group',
      access_helper_text:
        'Specify whether the group\'s content should be private and hidden from the organization.',
      access_requested: 'Access requested',
      all_groups: 'All groups',
      create_group: 'Create group',
      delete_group_helper_text:
        'Permanently delete your group from the organization. This cannot be undone.',
      edit_group: 'Edit group',
      duplicate_group_name_error: 'A group with that name already exists.',
      empty_group_name_error: 'A group must have a title.',
      my_groups_title: 'My groups',
      name_group_input_placeholder: 'E.g. Leasing team',
      name_helper_text:
        'Give your group a clear name that stands out from the rest.',
      no_dashboards_body:
        'Go to a dashboard and invite this group to make it appear here.',
      no_dashboards_title: 'No dashboards... yet',
      no_groups_title: 'You are not a member of any group yet.',
      no_other_groups_title: 'There are no more groups available.',
      no_content_body:
        'Add key metrics or resources for a group and they will appear here.',
      no_content_title: 'No content... yet',
      no_key_metrics_body:
        'Go to the key metrics of the organization and add the group to a key metric, then it will appear here.',
      no_key_metrics_title: 'No key metrics... yet',
      no_metrics_body: 'Edit the group to add one or more metrics here.',
      no_metrics_title: 'No metrics... yet',
      other_groups_title: 'Other groups',
      color_title: 'Profile',
      color_helper_text:
        'Give the group profile a color so it can be easily recognized.',
      group_owner_helper_text:
        'Select an owner to manage the group and act as a point of contact.',
      private_group_title: 'Private group',
      private_group_helper_text:
        'Only the owner and added users can see the group\'s content.',
      to_group: 'Go to group',
      visibility_title: 'Visibility',
      visibility_helper_text:
        'Specify whether the group\'s content should appear on users\' home screens.',
      show_on_home_title: 'Show on home screen',
      show_on_home_helper_text:
        'Added users will see the group\'s content on their home screen.',
      no_owner_error: (
        <>
          A group must have <u>at least one</u> owner.
        </>
      ),
      private: 'Private',
      visible_on_home: 'Visible on home screen',
      no_members: 'No members',
      no_requests: 'No requests... yet',
      requests: 'Requests',
      members: 'Members',
      make_owner: 'Make owner',
      remove_from_group: 'Remove from group',
      make_member: 'Make regular member',
      accept_request: 'Accept request',
      decline_request: 'Decline request',
      no_owner_infotip:
        'You must have at least one owner remaining in the group',
      request_access: 'Request access',
      one_owner_required_tooltip: 'You cannot leave as the sole owner',
      invite_members: 'Invite members',
      expand_group: 'Expand your group',
      by_inviting_more_members: 'by inviting more members.',
      group: 'Group',
      key_metrics_helper_text:
        'Strategic and operational key metrics from the organisation that this group works towards.',
      metrics_helper_text:
        'Complementary metrics that this group follows in addition to the organaisation\'s selected key metrics.',
      resources_helper_text:
        'Resources shared with this group to support their work towards improving the key metrics.',
      no_resources_title: 'No resources... yet',
      no_resources_body:
        'Go to a dashboard and invite this group, and the dashboard will appear here.',
      no_resources_cta: 'Go to dashboards'
    },

    activity_overview: {
      activity_overview: 'Activity overview',
      drafts_have_no_activity: 'Drafts have no activity',
      ranking: 'Ranking',
      views_helper_text: 'Total number of views in the dashboard',
      users_helper_text:
        'Unique users who have opened the dashboard at least once',
      ranking_helper_text:
        'Based on the number of views compared to other dashboards',
      basic_checklist: 'Basic checklist',
      basic_checklist_description:
        'Set your dashboard up for success by checking off the most essential items.',
      valid_dashboard_title: 'The dashboard has a proper title',
      valid_dashboard_title_helper: (
        <>
          Make sure your dashboard is not named &quot;Unnamed&quot; or contains
          words like &quot;Test&quot; or &quot;Copy&quot;.
        </>
      ),
      valid_tab_titles: 'All tabs have proper titles',
      valid_tab_titles_helper: (
        <>
          Make sure your tabs are not named &quot;Unnamed&quot; or contain words
          like &quot;Test&quot; or &quot;Copy&quot;.
        </>
      ),
      max_tabs: 'Max 3 tabs',
      max_tabs_helper: (
        <>
          We recommend avoiding tabs{' '}
          <u>if the goal is to increase user engagement</u>. Instead, create
          relevant user filters to provide each their own specific view. If you
          still want to use tabs, try to keep the number to 2–3.
        </>
      ),
      max_widgets: 'Max 10 widgets',
      max_widgets_helper: (
        <>
          If you have many widgets, you probably have not focused on the most
          essential insights. This can make it difficult for users to know what
          to focus on.
        </>
      ),
      recommendations_title: '10 recommendations',
      recommendations_description:
        'Building a user-friendly dashboard is not that easy. Below we\'ve listed some things to keep in mind.',
      clarity_title: 'Be clear about what you want to achieve',
      clarity_body:
        'The purpose of your dashboard determines its design. Make sure you have a focus and purpose before you start building.',
      focus_title: 'Include only what matters',
      focus_body:
        'Everything should support the dashboard\'s intent. Remove unnecessary elements so that the important information stands out.',
      data_ink_title: 'Consider the "data-ink" ratio',
      data_ink_body:
        'Avoid decorative elements and too much text that does not convey data. The eye should be drawn to the metrics and key figures.',
      rounding_title: 'Round your numbers',
      rounding_body: 'Being overly precise can obscure important changes.',
      grouping_title: 'Group related measures',
      grouping_body: 'Make your metrics easy to find.',
      consistency_title: 'Be consistent',
      consistency_body:
        'Use the same visualizations and layout to make comparisons easier.',
      hierarchy_title: 'Use size and position to show hierarchy',
      hierarchy_body: 'Make it clear to the viewer what is most important.',
      context_title: 'Give your numbers context',
      context_body:
        'Help viewers determine if a number is good, bad, normal, or unusual.',
      labels_title: 'Use clear labels for your audience',
      labels_body: 'Keep them short and self-explanatory.',
      human_title: 'Remember it\'s for people',
      human_body: 'It\'s okay to break the rules if it increases engagement.',
      over_time_per_day: 'Over time per day',
      total_per_tab: 'Total per tab',
      views_per_tab: 'Views per tab',
      no_activity: 'No activity',
      latest_activity: 'Latest activity'
    },

    home: {
      good_morning: 'Good morning',
      good_afternoon: 'Good afternoon',
      good_evening: 'Good evening',
      good_night: 'Good night',
      help: 'Help',
      knowledge_center: 'Knowledge Center',
      live_chat_body:
        'Did you notice our live chat in the bottom right corner?',
      live_chat_title: 'Live chat',
      recently_visited: 'Recently visited',
      updated_stats_for: 'Here is your updated statistics for',
      quick_links: 'Quick links to help you find your way'
    },

    entities: {
      error_not_found_body:
        'The entity you are looking for does not exist or has been removed.',
      exit_editing_to_view: 'Exit edit mode to view...',
      slice: 'Slice',
      use_slice: 'Use slice',
      slice_helper_text:
        'Select one or more slices if you only want to use a specific part of the metric.',
      multiple_slices_warning_body: (
        <>
          When selecting multiple slices, all slices must be fulfilled{' '}
          <u>simultaneously</u>. Only add multiple slices if you know that the
          combination works and does not conflict.
        </>
      ),
      use_predefined_calculation: 'Use predefined calculation',
      predefined_calculation_helper_text:
        'Select a predefined calculation to create a comparison figure for the metric. This is available for financial metrics.',
      all_entities: 'All entities',
      entity: 'Entity',
      entities: 'Entities',
      slices: 'Slices',
      filter_in_use: 'is used in several metrics',
      slice_in_use: 'is used in several metrics and can\'t be removed',
      no_slices_yet: 'There are no slices yet.',
      slice_not_supported_by_metric: 'The metric does not support this slice.',
      metric_slice_helper_text:
        'Use a predefined slice to focus only on a specific part of the metric. Slices are defined globally by administrators to ensure the effect is consistent everywhere.',
      properties: 'Properties',
      properties_column_description:
        'Select which properties should be displayed as columns when records of the entity are opened in a table.',
      slices_definition_description:
        'Define slices to quickly and easily focus on a specific subset of the entity\'s records.',
      terminology_description: (
        <>
          Adjust terminology to match the naming conventions used in your
          organization.
          <br />
          <i>
            If nothing is specified, Homepal&#39;s standard terminology is used.
          </i>
        </>
      ),
      no_terms_to_customize: 'There are no terms to customize yet.',
      dim_only_notice:
        'This entity does not support customization of columns or slices.',
      metric_dependency_description:
        'Keep track of which metrics use the entity when their data is displayed in table form.',
      default_columns_description: (
        <>
          Select which columns should be shown by default when a user opens a
          metric to view its contents.
          <br />A user can always add more columns when content is displayed.
        </>
      ),
      add_column: 'Add column',
      locked_columns_info:
        'Some columns are essential for certain metrics and will always be shown (regardless of the selection above) for those specific metrics.',
      no_locked_columns: 'There are no locked columns yet.',
      standard_slices_required_info: (
        <>
          To activate ready-made examples from our catalogs, standard slices
          need to be configured.
          <br />
          <i>
            This is also required to use certain standard comparisons on
            metrics.
          </i>
        </>
      ),
      no_standard_slices: 'There are no standard slices yet.',
      custom_slices_info:
        'You can create custom slices to simplify filtering in the tool and build a shared understanding across the organization.',
      custom_financial_slices_info:
        'You can create custom financial slices to simplify filtering in the tool and build a shared understanding across the organization.',
      add_slice: 'Add slice',
      create_slice: 'Create slice',
      configure_slices: 'Configure slices',
      edit_slices: 'Edit slices',
      duplicate_slice_error: 'A slice with that name already exists',
      no_custom_slices: 'There are no custom slices yet.',
      not_configured: 'Not configured',
      not_ready: 'Not ready',
      terminology: 'Terminology',
      available_slices: 'Available slices',
      used_not_configured: 'Used, not configured',
      used_not_configured_helper_text:
        'These slices are used by the widget but are not configured. Remove them or configure them for the widget to work correctly.'
    },

    date_filters: {
      point_in_time: 'Point in time',
      time_period: 'Time period',
      financial_year: 'Financial year',
      long_forecast_not_applicable:
        'Extended forecasts are only calculated for a limited set of metrics. None of the metrics used in this visualization include an extended forecast.',
      long_forecast_includes: 'Extended forecast includes:',
      long_forecast_use_other:
        'For a more reliable analysis, you should use a different forecast.',
      long_forecast_missing:
        'Extended forecast is not available for this metric',
      latest_day_in: 'Latest day in',
      until_latest_closed_accounting_period:
        'until latest closed accounting period'
    },

    filters: {
      choose_filter_first: 'Choose what you want to filter by first',
      condition: 'Condition',
      duplicate_filter_name_error:
        'A saved filter with this name already exists.',
      save_filter: 'Save filter',
      no_filters: 'No filters',
      add_filter: 'Add filter',
      add_to_filters: 'Add to filters',
      filter: 'Filter',
      filters: 'Filters',
      edit_filters: 'Edit filters',
      no_saved_filters: 'You have no saved filters.',
      unavailable_filters_title: 'Unavailable',
      unavailable_filters_description:
        'The saved filters shown here cannot be used because they contain filters that are not available on this specific dashboard.',
      unavailable_filters_reason_title: 'This could be because:',
      unavailable_filters_reason_description: (
        <ul className="ul">
          <li className="li">
            The filter was created on a different dashboard.
          </li>
          <li className="li">
            The owner has removed the filter option that was used.
          </li>
        </ul>
      ),
      unavailable_filters_instruction:
        'To use a valid filter, create a new one or select one that is available for this dashboard.',
      filter_group: 'Filter group',
      or: 'or',
      no_active_filters: 'There are no active filters.',
      new_filter: 'New filter',
      add_filter_group: 'Add a filter group',
      all_criteria_met_prefix: 'Showing data where',
      all: 'all',
      criteria_met_suffix: 'of the above criteria are met.',
      want_any_criteria_prefix: 'Want to show data where only',
      one_of: 'one of',
      criteria_question_suffix: 'the criteria is met?',
      filter_on: 'Filter on',
      is_empty: 'Is empty',
      select_condition: 'Select condition',
      value: 'Value',
      select_x: 'Select {{name}}',
      filter_group_edit_helper_text:
        'You can edit values for filters in a filter group. To change the structure of the filter group, you need to delete it and create a new one.',
      filter_edit_helper_text:
        'You can edit the values for a filter. If you want to change the attribute or condition, delete the filter and create a new one.',
      group_dialog_content:
        'Filters you add here will form a filter group where only one of the criteria must be met.'
    },

    metrics: {
      select_metric: 'Select metric',
      metric_in_use: 'The metric is in use and therefore cannot be deleted',
      remove_definition: 'Remove definition',
      remove_definition_title: 'Remove definition?',
      remove_definition_body:
        'The formula is removed and the metric becomes unconfigured again. Widgets using the metric, and other financial metrics calculated from it, cannot show data until a new formula is defined.',
      standard_metric_locked:
        'The metric is part of Homepal\'s standard and cannot be deleted or modified',
      edit_metric: 'Edit metric',
      metric_combination_filter_description:
        'Only shows the metrics that are compatible with the primary metric in your widget.',
      metric_variant_option_filter_description:
        'The widget shows comparison figures, so only custom economy metrics can be added. Remove the comparison figures to add other metrics.',
      add_metric: 'Add metric',
      edit_mode_disabled_no_data:
        'Edit mode is disabled because the organization has no data',
      visible_to_users: 'The metric can be viewed and used by users.',
      activated_metric: 'Enabled metric',
      activate_metric: 'Enable metric',
      deactivate_metric: 'Disable metric',
      delete_metric: 'Radera mätetal',
      all_metrics: 'All metrics',
      metric: 'Metric',
      metrics: 'Metrics',
      rolling_sum: 'Rolling sum',
      rolling_sums: 'Rolling sums',
      rolling_sum_helper_text:
        'Determine how far back in time the value for each point should be summed. A rolling sum makes it easier to follow the development in the long term.',
      no_metrics_match: 'No metrics matched your search',
      no_metrics_available: 'No metrics are available to add right now.',
      calculation: 'Calculation',
      calculation_helper_text:
        'Select a predefined calculation to obtain a comparison figure for the metric. Applies only to economical metrics.',
      variant: 'Comparison figure',
      variant_helper_text:
        'Choose which comparison figure of the metric to display, for example actual, budget, or variance against budget.',
      accumulated: 'Accumulations',
      metric_accumulation_info:
        'This metric can be accumulated using the following variations:',
      no_accumulated_variants_yet: 'There are no accumulated variations yet.',
      distribution: 'Distribution',
      distribution_helper_text:
        'Distribute the value per selected unit to make it easier to compare, or follow a changing portfolio, in a fair way.',
      distributions: 'Distributions',
      no_comparison_variants_yet: 'There are no distributions yet.',
      custom_economy_metric_info:
        'This is a custom financial metric. Entity, slices, rolling sums, and distributions may vary depending on the selected comparison figure.',
      custom_economy_availability_tooltip:
        'The availability of financial metrics is managed by your system administrator via settings > finance.',
      missing_slices_tooltip:
        'The metric can be activated once these slices are configured',
      definition_slices_title: 'Slices in the definition',
      definition_slices_helper:
        'The metric is calculated over these slices and cannot be computed without them.',
      missing_slices_dialog_helper:
        'The metric is defined over these slices. Set their conditions here to be able to use the metric.',
      missing_slices_dialog_helper_reader:
        'The metric is defined over these slices. Contact your system administrator to have them configured.',
      missing_slices_action: 'Configure slices',
      missing_definition_body:
        'The metric can be used once its formula is defined.',
      missing_definition_body_reader:
        'Your organization has not defined the formula for this metric. Contact your system administrator to have it defined.',
      missing_definition_action: 'Define the metric',
      availability_title: 'Availability',
      availability_description:
        'Specify whether the metric should be active and available to the organization.',
      not_visible_to_users: 'The metric cannot be viewed or used by users.',
      inactive_metric: 'Inactive metric',
      inactive_metric_description:
        'The metric will not appear in the organization\'s metric catalog.',
      inactive_widgets_warning:
        'All widgets using the metric will be temporarily marked as inactive until it is removed from the widget.',
      active_metric_description:
        'The metric will appear in the organization\'s metric catalog.',
      access_description:
        'Specify whether the metric should be private and hidden from the organization.',
      private_metric_description:
        'Only the owner and added groups or users can use the metric.',
      private_metric: 'Private metric',
      add_user_or_group: 'Add user or group',
      filters_title: 'Filters',
      filters_description:
        'Add filters to get an accurate view of your metric. The filters added here will be applied automatically throughout the tool.',
      new_metrics_info_text:
        'We\'ve released new metrics. As an administrator, you can activate them for your organization so everyone gets access. See the list below and choose which ones you want to enable.',
      new_metrics_title: 'New metrics to activate',
      show_all_x_metrics: 'Show all {{count}} metrics',
      no_access: 'You do not have access to this metric',
      is_private: 'This metric is private',
      requires_configuration: 'This metric requires configuration',
      unit_mismatch:
        'The base unit of this metric is not the same as the primary metric.',
      unit_warning:
        'For the selected visualization type, it is not recommended to combine different units.',
      no_data_title: (
        <>
          No data... yet <Emoji name="seedling" />
        </>
      ),
      no_data_body: <>Contact us to connect the right data for this metric.</>,
      locked_body:
        'To see the contents of a private metric, you or one of your groups needs to be invited.',
      slices_helper_text:
        'Show only a specific and predefined part of the value to focus on what is most relevant.',
      skip_and_add_default: 'Skip all steps and add default'
    },

    key_metrics: {
      add_title: 'Add key metric',
      add_operational_title: 'Add related key metric',
      add_operational_body:
        'Select a related key metric that contributes to your strategic key metric.',
      add_strategic_title: 'Add strategic key metric',
      add_strategic_body:
        'Select a metric that the management and board can follow up on the goal.',
      edit_title:
        'Edit to chose a key metric that the organization can follow and groups can work towards.',
      key_metric: 'Key metric',
      key_metrics: 'Key metrics',
      key_metrics_helper_text:
        'Add key metrics in order to track and work towards your organization\'s goals.',
      to_key_metrics: 'Go to all key metrics',
      delete_key_metric: 'Delete key metric',
      delete_key_metric_note: 'All related key metrics will also be deleted.',
      metric_unavailable: 'The metric is no longer available',
      updated_stats_for:
        'Here are the updated key metrics of the organisation for',
      no_groups_title: (
        <>
          No groups... yet <Emoji name="seedling" />
        </>
      ),
      no_groups_body: 'Add groups that contribute to this key metric.',
      no_resources_title: (
        <>
          No resources... yet <Emoji name="seedling" />
        </>
      ),
      no_resources_body: 'Add resources that are linked to this key metric.',
      groups_title: 'Groups that contribute',
      groups_helper_text:
        'See which groups participate and contribute to this key metric in their operational work.',
      change_to_synchronized_metric: 'Change to synchronized metric',
      connection_title: 'Strategic connection',
      connection_helper_text:
        'See what impact you have by working on this key metric.',
      use_synchronized_metric: 'Do you want to use a synchronized metric?',
      pin_comment_placeholder: 'Add a comment...',
      target: 'Target',
      budget: 'Budget',
      budget_target_title: 'Target based on budget.',
      budget_target_body:
        'The target will automatically use the synchronized budget value for this key metric.',
      no_comments_title: (
        <>
          No comments... yet <Emoji name="seedling" />
        </>
      ),
      no_comments_body: 'Click on a segment in the timeline to add a comment.'
    },

    tasks: {
      add_subtask: 'Add subtask',
      completed: 'Completed',
      deadline: 'Deadline',
      edit_subtask: 'Edit subtask',
      no_deadline: 'No deadline',
      not_completed: 'Not completed',
      not_started: 'Not started',
      remove_deadline: 'Remove deadline',
      started: 'Started',
      subtask: 'Subtask',
      subtasks: 'Subtasks',
      the_subtask: 'The subtask',
      the_task: 'The task',
      tasks: 'Tasks',
      open_tasks: 'Open tasks',
      empty_title: (
        <>
          No tasks... yet <Emoji name="seedling" />
        </>
      ),
      empty_body: 'Create a task to start tracking your progress.',
      linked_key_metric: 'Linked key metric',
      linked_key_metric_helper_text:
        'Link a key metric to the task to track the result.',
      followed_up_metric: 'Metric',
      followed_up_metric_helper_text:
        'The metric is followed up for the selected property and is ' +
        'predetermined by the analysis.',
      task: 'Task',
      no_groups: 'No groups',
      add_date: 'Add date',
      movement_title: 'Movement',
      start_value: 'Start value',
      target_value: 'Target value',
      estimated_result: 'Estimated result',
      estimated_result_helper:
        'Change in Net Operating Income (kr) based on the target value above.',
      key_metric_timeline_note:
        'The task will appear on the key metric timeline only when it is marked as done.',
      write_description_placeholder: 'Write a description...',
      title_placeholder: 'Summarize your task...',
      create_task: 'Create task',
      edit_task: 'Edit task',
      status: 'Status',
      properties: 'Properties',
      create_from_analysis_title: 'Create activities',
      subtask_placeholder: 'Describe your subtask...',
      view_all_tasks: 'View all tasks'
    },

    analysis_types: {
      analysis_type: 'Analysis type',
      analysis_types: 'Analysis types',
      search_placeholder: 'Search for analysis type',
      no_runs: 'No runs',
      no_follow_up: 'Follow-up missing',
      run_analysis: 'Run analysis',
      availability_title: 'Availability',
      availability_description:
        'Choose whether the analysis type is activated for the organisation.',
      activated_analysis_type: 'Activated analysis type',
      activated_analysis_type_body:
        'Show the analysis type in the Overview and let everyone with access run the analysis on demand.',
      activate_analysis_type: 'Activate analysis type',
      deactivate_analysis_type: 'Deactivate analysis type',
      activate_analysis_type_confirm:
        'The analysis type shows in the Overview and can run. Are you sure?',
      deactivate_analysis_type_confirm:
        'The analysis type leaves the Overview and can no longer run. ' +
        'Analyses and activities stay. Are you sure?',
      last_run: 'Run {{date}}',
      promo_title:
        'Increase your net operating income with more analysis types',
      promo_body:
        'There are another {{count}} analysis types in our portfolio to drive the work ' +
        'towards increasing net operating income.',
      details: 'Details',
      analysis_type_uses_title: 'What the analysis type uses',
      analyzed_by_label: 'Analyzed by',
      homepal_ai_title: 'Homepal AI',
      tracked_with_label: 'Tracked with',
      estimated_in_label: 'Results estimated in',
      increased_noi_value: 'Increased net operating income',
      avg_run_time_label: 'Average run time',
      run_time_unavailable: 'No information',
      last_run_label: 'Last run',
      latest_analyses: 'Latest analyses',
      required_metrics_title: 'Required metrics',
      required_slices_title: 'Required slices',
      configured_by_admin_tooltip: 'Configured by your system administrator.',
      investigation_dashboard_title: 'Investigated in',
      investigation_dashboard_description:
        'Opened from the analysis, filtered on the selected properties.',
      investigation_dashboard_label: 'Select dashboard',
      investigation_dashboard_no_access: 'Dashboard you don\'t have access to',
      investigation_dashboard_draft_warning:
        'The dashboard is a draft. Users who aren\'t invited won\'t see the link.',
      investigation_dashboard_restricted_info:
        'Only users with access to the dashboard can see it.',
      required_slices_dialog_helper:
        'The analysis requires the slice to be configured. Set its conditions here to be able to run the analysis.',
      no_requirements_title: 'The analysis type has no data requirements',
      required_period_title: 'Required accounting period',
      required_period_tooltip_body:
        'is used to lock the analysis to your latest closed period.',
      closed_period_name: 'Latest closed accounting period',
      error_load_title: 'The analysis types could not be loaded',
      error_load_body: 'Reload the page or try again in a moment.',
      error_not_found_body:
        'We could not find the analysis type you were looking for.',
      no_analysis_types_title: 'No analysis types available',
      view_all_analysis_types: 'View all analysis types',
      available_analysis_types: 'Available analysis types',
      required_tooltip_body:
        'is used to be able to perform the analysis and create a selection ' +
        'based on the deviations.',
      run_loading_title: 'Analysis running',
      cancel_run: 'Cancel run',
      done_title: 'The analysis is complete!',
      run_failed_title: 'The analysis could not be run',
      run_failed_body: 'Try again in a moment.',
      run_aborted_title: 'The analysis was cancelled',
      run_aborted_body: 'The analysis was aborted. Nothing was created.',
      run_cancelled: 'The run was cancelled.',
      run_error_403: 'Analyses are not activated for your organization.',
      run_error_422:
        'Data the analysis requires is missing. Contact your account ' +
        'manager to complete it.',
      run_error_502:
        'The analysis did not produce a valid result. Try again in a moment.',
      run_error_503:
        'The analysis engine is temporarily unavailable. Try again in a ' +
        'moment.',
      run_error_504:
        'The analysis took too long and was stopped. Try again in a moment.',
      run_error_default: 'Something went wrong. Try again in a moment.',
      disabled_title: 'Missing data for analysis',
      disabled_body:
        'Contact your account manager to connect or configure the data ' +
        'needed for this analysis type.',
      ai_step_1: 'Identifying deviations in your data',
      ai_step_2: 'Comparing with the portfolio\'s norm',
      ai_step_3: 'Evaluating affected properties',
      ai_step_4: 'Calculating potential in net operating income',
      running_minutes_left: 'Approx. {{minutes}} min left',
      running_less_than_minute_left: 'Less than a minute left',
      running_overdue: 'Taking a bit longer than usual',
      running_can_close_title: 'You can close the dialog',
      running_can_close_body:
        'The analysis continues in the background and we\'ll notify you ' +
        'when the analysis is ready.',
      field_noi_impact: 'How does it move NOI?',
      save: 'Save',
      column_status: 'Status',
      status_idea: 'Idea',
      status_idea_body: 'Visible to us only. Cannot be run for customers.',
      status_deliverable: 'Deliverable',
      status_deliverable_body:
        'In the customers catalogue and ready to generate analyses from.',
      new_analysis_type: 'New analysis type',
      new_helper_short: 'The name is enough to start. The rest comes later.',
      edit_field: 'Edit {{field}}',
      section_tasks: 'Tasks',
      section_requirements: 'Required settings',
      variant_section_config: 'Configuration',
      variant_section_metrics: 'Metrics and data requirements',
      requires_period_body:
        'The analysis type works on closed-period figures and cannot run until the customer has set their latest closed period.',
      variant_dashboard_helper:
        'Paste the dashboard uuid. It has to live on the Homepal template customer.',
      unpublish_title: 'Unpublish the analysis type',
      unpublish_body:
        'The analysis type leaves the customers catalogue. No new analyses can be generated and the package cannot be downloaded. Analyses already delivered stay.',
      source_variants_title:
        'The analysis type can be based on work orders or errands',
      source_variants_body:
        'An analysis type that can be based on both work orders and errands needs two variants.',
      source_locked:
        'Can only be changed on an analysis type that has never been published.',
      file_uploaded: 'Uploaded {{date}}',
      delivery_status: 'Delivery status',
      requirements_left: '{{count}} requirements left.',
      requirement_variant_dashboard: 'Dashboard ID on every variant',
      requirement_instructions_file: 'instructions.md uploaded',
      requirement_template_file: 'template.html uploaded',
      requirement_investigate_metric: 'Investigate metric on every variant',
      requirement_analysis_definition: 'Analysis definition chosen',
      analysis_definition: 'Analysis definition',
      analysis_definition_body:
        'Which definition in the code the analysis type runs. It carries the logic, the calculation and the text the customer reads.',
      analysis_definition_none: 'None chosen',
      about_analysis_type: 'About',
      about_created: 'Created',
      about_published: 'Deliverable since',
      about_variants: 'Variants',
      variant_no_dashboard: 'No template selected',
      none: 'None',
      excluded_label: 'Excluded properties',
      excluded_edit: 'Add or remove excluded',
      excluded_more: '+{{count}} more',
      excluded_help_dialog:
        'are saved on the analysis package and left out of this and every coming run. They do not show in the result and are not counted in the target value.',
      excluded_help_page:
        'are saved on the analysis package and left out of every coming run. They do not show in the result and are not counted in the target value. The list applies to the whole portfolio and is not affected by the global filter.',
      excluded_picker_intro_dialog:
        'Selected properties are excluded from this and every coming run of the package.',
      excluded_picker_intro_page:
        'Selected properties are excluded from every coming run of the package.',
      excluded_search_placeholder: 'Search property'
    },

    results: {
      results: 'Results',
      retired_packages: 'Retired analysis packages',
      retired_packages_tooltip:
        'The analyses and activities come from analysis packages we have retired. You can keep working with them as usual.',
      progress: 'Progress',
      no_metrics_body: 'Activate an analysis type to follow it up here.',
      no_metrics_title: (
        <>
          No metrics... yet <Emoji name="seedling" />
        </>
      ),
      col_metric: 'Metric',
      col_trend: 'Trend',
      col_current_value: 'Current value',
      follow_up_metric_missing: 'Follow-up metric missing',
      col_active_potential: 'Tasks',
      active_potential_tooltip:
        'is the estimated saving or revenue increase (per year) that the ' +
        'current tasks aim for.',
      col_discovered_potential: 'Unhandled analyses',
      unhandled_potential_tooltip:
        'is the estimated saving or revenue increase (per year) that the ' +
        'latest unhandled analyses aim for.',
      col_total: 'Total',
      error_load_title: 'The follow-up could not be loaded',
      error_load_body: 'Reload the page or try again in a moment.',
      error_slice_not_activated: 'A slice the analysis needs is not configured'
    },

    analyses: {
      analyses: 'Analyses',
      analysis: 'Analysis',
      properties: 'Properties',
      write_comment: 'Leave a comment…',
      search_placeholder: 'Search for analysis',
      status_column: 'Status',
      error_not_found_body:
        'We could not find the analysis you were looking for.',
      empty_feed_title: 'No unhandled analyses',
      empty_feed_body:
        'New analyses will show up here once they have been run.',
      empty_title: (
        <>
          No analyses... yet <Emoji name="seedling" />
        </>
      ),
      empty_body: 'Run an analysis type to generate analyses that appear here.',
      unhandled_analyses: 'Unhandled analyses',
      view_all_analyses: 'View all analyses',
      published: 'Published',
      unpublished: 'Unpublished',
      restore: 'Restore',
      auto: 'Auto',
      add_comment: 'Add comment',
      no_comments_body: 'Add a comment to start the discussion.',
      investigate_selection: 'Explore selection',
      view_evidence: 'View the full evidence',
      investigate_disabled_tooltip: 'This analysis cannot be investigated',
      investigate_no_selection_tooltip:
        'Select at least one object to investigate',
      edit: 'Edit',
      edit_title: 'Edit analysis',
      selection: 'Selection',
      selection_locked_tooltip:
        'The selection cannot be changed in status "{{status}}"',
      create_activities_title: 'Create activities',
      create_activities_empty_title: 'No selected properties',
      create_activities_empty:
        'This analysis has no selected properties to create activities for.',
      create_activities_submit: 'Create activities',
      create_activities_info_title: 'One activity per property',
      create_activities_info_body:
        'Each property in your selection gets its own activity. Want to ' +
        'include other properties? Change the selection in the analysis before ' +
        'you continue.',
      col_current_value: 'Current',
      potential: 'Potential',
      recommended_selection: 'has recommended a selection:',
      no_recommended_selection:
        'has not found any properties that need action.',
      reasoning: 'Reasoning',
      no_preselection: 'has not preselected any properties:',
      no_selection_above_noise: 'has not recommended any properties:',
      recommendation_below_noise:
        'No property exceeded the noise filter. The deviations are so small that they are considered temporary.',
      recommendation_noise_excluded:
        '{{count}} properties below the noise filter, worth {{total}} per year in total, were not part of the assessment.',
      recommendation_noise_excluded_one:
        '1 property below the noise filter, worth {{total}} per year, was not part of the assessment.',
      recommendation_gap:
        'We recommend the {{count}} properties where action is worth the ' +
        'most, {{total}} per year in total. After the last recommended one ' +
        'the potential drops clearly, from {{last}} to {{next}} per ' +
        'property. The other {{rest}} properties are worth {{restTotal}} per ' +
        'year together.',
      recommendation_gap_one:
        '{{name}} stands out. Acting on it is worth {{total}} per year, ' +
        'against {{next}} per year for the next property in the list. So we ' +
        'recommend you start there.',
      recommendation_anchor:
        'We recommend the {{count}} properties where action is worth the ' +
        'most, {{total}} per year in total. The ones after them are clearly ' +
        'lower, at most {{next}} per year against {{top}} for the first. The ' +
        'other {{rest}} properties are worth {{restTotal}} per year together.',
      recommendation_anchor_one:
        '{{name}} is the property where action is worth the most, {{total}} ' +
        'per year. The next property in the list is worth at most {{next}} ' +
        'per year. So we recommend you start there.',
      recommendation_flat:
        'The potential is evenly spread, with {{count}} properties between ' +
        '{{min}} and {{max}} per year. None stands out, so nothing has been ' +
        'preselected. Pick the properties that suit you best to start with.',
      recommendation_single:
        'One property has potential for improvement: {{name}}, worth ' +
        '{{total}} per year. The others are at a level that does not ' +
        'call for action.',
      add_to_selection: 'Add to selection',
      remove_from_selection: 'Remove from selection',
      selection_helper_text:
        'Explore and pick the selection you want in the analysis.',
      trend_current_period: 'Selection (current period)',
      trend_previous_period: 'Selection (previous period)',
      selection_locked: 'The selection is locked',
      selection_locked_accepted:
        'The analysis has been taken further. The property selection can therefore not be changed.',
      selection_locked_rejected:
        'The analysis has been rejected. The property selection can therefore not be changed.',
      ambiguous_title: 'Properties that cannot be told apart',
      ambiguous_body:
        '{{names}} are excluded because several properties share the same designation and cannot be told apart.',
      ambiguous_body_one:
        '{{names}} is excluded because several properties share the same designation and cannot be told apart.',
      ambiguous_dialog_body:
        'Several properties share the same designation and cannot be told apart. They are therefore excluded automatically and cannot be selected again.',
      report_improvement: 'Improvement',
      report_start_value: 'Start value',
      report_target_value: 'Target value',
      noise: 'Noise filter',
      recommendation_limit: 'Recommendation limit',
      classification: 'Classification',
      classification_recommended: 'Recommended',
      classification_recommended_tooltip:
        'Clear changes with high potential that we consider worth a closer look.',
      classification_potential: 'Potential',
      classification_potential_tooltip:
        'Changes that may be of interest, but with noticeably lower potential than the recommended ones.',
      classification_not_prioritized: 'Not prioritized',
      classification_not_prioritized_tooltip:
        'Changes below our noise filter, meaning small deviations or ones we consider temporary.',
      deviation_from_target: 'Deviation from target (%)',
      report_potential_result: 'Potential result',
      potential_rounding_note:
        'The figures above are rounded. The result is calculated on exact figures.',
      show_calculation: 'Show calculation',
      report_selection_title: 'Selection',
      report_col_potential: 'Potential',
      reject_confirm_title: 'rejection',
      reject_submit: 'Reject',
      reject_confirm_description:
        'The analysis becomes inactive. You can activate it again at any time.',
      undo_confirm_description:
        'The analysis becomes active again. Continue the work and move activities forward.',
      generated_from: 'Generated from',
      investigated_in: 'Investigated in',
      retired: 'The analysis package has been retired',
      retired_description:
        'The analysis was generated from a package that has been retired. You can keep working with the analysis as usual.',
      explore_body: 'Open the underlying data for the property.',
      selection_body: 'Applies to this analysis only.',
      exclude_and_rerun: 'Exclude and rerun the analysis',
      exclude_and_rerun_body:
        'The property is left out of every coming run and this analysis is run again.',
      rerun_title: 'Exclude and rerun the analysis?',
      rerun_description:
        '{{name}} is excluded from every coming run and this analysis is run again without the property. The result is updated when the run is done.',
      rerun_excluded_now: 'Excluded now',
      rerun_already_excluded: 'Already excluded',
      rerun_note:
        'Excluded properties do not show in the new analysis and are not counted in the target value. You manage the list on the analysis package page.',
      rerun_submit: 'Exclude and rerun',
      excluded_label: 'Excluded',
      excluded_count: '{{count}} properties',
      excluded_count_one: '1 property',
      excluded_dialog_title: 'Excluded in this run',
      excluded_dialog_body:
        'This is how the list looked when the analysis was run {{date}}. Changes since then apply only to coming runs.',
      rerun_leave_title: 'You can leave the page',
      rerun_leave_body:
        'The analysis is rerun in the background and we will let you know when it is done.',
      rerun_disabled_tooltip: 'Not possible while the analysis is rerun.',
      rerun_comment_placeholder: 'You can comment when the analysis is done'
    },

    comments: {
      activity: 'Activity',
      comments: 'Comments'
    },

    search: {
      global_search_placeholder: 'Search and go to',
      global_search_instructions: 'At least 3 characters',
      no_results_match: 'No results matched your search',
      search_for: 'Search for',
      results_found: 'Results found'
    },

    widgets: {
      chart_data_table_caption: 'Data for the chart {{title}}',
      chart_data_table_label_column: 'Category',
      login_required: 'Log in to Homepal to access this functionality',
      no_further_breakdown: 'This segment cannot be broken down further',
      open_in_source_system: 'Open in source system',
      missing_source_system: 'Missing connection to source system',
      breakdown_by_placeholder: 'Break down by...',
      broken_error: 'The widget has broken, try reloading the page.',
      date_range_out_of_bounds_error: 'Invalid period filter combination',
      date_range_out_of_bounds_description:
        'The selected period is outside the fiscal year range. Please adjust the fiscal year or time period.',
      inactive_metrics_error:
        'Your organization has not activated all metrics in this widget.',
      no_data_title:
        'There are no values to display based on your selected period or filters.',
      no_data_subtitle: 'Don\'t worry! Everything is working as expected 👍',
      no_data_description:
        'The lack of values to display is due to one (or a combination) of the following:',
      no_data_reason_metric_filter:
        'There is no data available based on the metric\'s configured filter.',
      no_data_reason_time_period:
        'There is no data available for the selected time period or point in time.',
      no_data_reason_dashboard_filter:
        'There is no data available based on your active dashboard filter.',
      widget_missing_metrics_error:
        'Your organization has not configured all metrics in this widget.',
      widget_missing_slices_error:
        'Your organization has not configured the necessary slices for all metrics in this widget.',
      configure_slice: 'Configure slice',
      widget_missing_definition_error:
        'Your organization has not defined the formula for all financial metrics in this widget.',
      configure_definition: 'Define metrics',
      request_data: 'Request data',
      widget_missing_data_error:
        'Your organization has not connected the data required for all metrics in this widget.',
      recommend_contact:
        'We recommend that you contact one of your system admins.',
      to_enable_data: '...to enable the required data! 👍',
      in_your_organization: 'In your organization',
      show_horizontal: 'Show horizontally',
      show_segments_horizontal: 'Show horizontally',
      disabled_segments_horizontal_if_breakdown:
        'You can\'t show segments horizontally when "breakdown by" is enabled on one of the metrics.',
      add_widget: 'Add widget',
      widget: 'Widget',
      widgets: 'Widgets',
      custom_segment_by: 'Custom breakdown',
      custom_segment_by_description:
        'You have applied a custom breakdown that differs from the original visualization.',
      custom_segment_by_headers_hidden:
        'Headers are temporarily hidden as they may no longer describe what is displayed.',
      invert: 'Invert',
      lower_bound: 'Lower bound',
      upper_bound: 'Upper bound',
      area: 'Area',
      hide_benchmark_filters: 'Hide benchmark filters',
      show_benchmark_filters_with_count: 'Show benchmark filters ({{count}})',
      metric: 'Metric',
      slice: 'Slice',
      slice_helper_text:
        'Use a predefined slice to focus on a specific part of the metric. Slices are defined globally by administrators to ensure consistent effect across the app.',
      primary_metric_tooltip: (
        <>
          <Text fontWeight="bold" variant="body2" gutterBottom>
            This is your primary metric.
          </Text>
          <Text variant="body2" gutterBottom>
            If you add more metrics, some of their properties (for example, the{' '}
            <code>unit</code>) are affected by your primary metric.
          </Text>
          <Text variant="body2" gutterBottom>
            Primary metrics cannot be deleted or moved.
          </Text>
        </>
      ),
      attribute: 'Attribute',
      column_is_hidden: 'The column is hidden',
      status_priority_helper_text:
        'If several indications have overlapping conditions, the topmost indication takes precedence. Ensure the priority order is correct by placing the most important indication at the top.',
      new_indication: 'New indication',
      set_condition_helper_text: 'Specify a condition that must be met.',
      select_indicator_helper_text:
        'Choose which indicator to use when a condition is met.',
      select_value_to_add: 'You must select a value before adding.',
      edit_indicator: 'Edit indicator',
      change_title: 'Change',
      days: 'days',
      add_y_axis: 'Add Y-axis',
      add_radius: 'Add radius',
      add_line: 'Add line',
      add_points: 'Add points',
      add_metric: 'Add metric',
      add_attribute: 'Add attribute',
      no_attributes_available_for_segmentation:
        'There are no attributes available for the selected segmentation.',
      cannot_delete_primary_metric: 'The primary metric cannot be deleted.',
      units_title: 'Units',
      units_and_rounding_title: 'Units and rounding',
      auto_format: 'Automatic formatting',
      auto_format_helper:
        'Picks the unit and number of significant figures from the size of the value.',
      disabled_by_auto_format: 'Set by automatic formatting.',
      decimals_title: 'Rounding',
      equivalent_title: 'Equivalent',
      factor: 'Factor',
      number_of_decimals: 'Number of decimals',
      new_unit: 'New unit',
      equivalent_helper_intro: (
        <>
          Multiplies your values by a factor and/or replaces the current unit
          with a new one. This lets you create an <i>equivalent</i>.
        </>
      ),
      equivalent_preview_both: '1{{current}} will equal {{factor}}{{new}}.',
      equivalent_preview_factor_only:
        '1{{current}} will equal {{factor}}{{current}}.',
      equivalent_preview_unit_only: '1{{current}} will equal 1{{new}}.',
      breakdown_title: 'Breakdown',
      visualization_title: 'Visualization',
      bars: 'Bars',
      bubbles: 'Bubbles',
      rows: 'Rows',
      bars_and_lines: 'Bars and lines',
      steps: 'Steps',
      linking_unavailable_for_segmentation:
        'Linking is not available for your selected segmentation',
      link_to_source_system: 'Link to source system',
      label_chars_title: 'Max characters',
      limit_selection_to_primary_kpi_title:
        'Limit selection to the primary metric',
      segment_by_title: 'Segmentation',
      segment_alias: 'Alias',
      amount_of: 'Number of {{name}}',
      sorting_title: 'Sorting',
      sort_by_title: 'Sort by',
      visualization_constraint_title: 'Sort according to',
      display_name: 'Display name',
      then_label: 'Then',
      additional_segmentation_title: 'Additional dimensions',
      additional_segmentation_helper:
        'When viewing data in a table, you can break your segmentation down further. You can add up to 3 additional dimensions.',
      variant_options_title: 'Segments',
      variant_options_helper:
        'Each segment shows a comparison figure for the metrics — for example outcome, budget and deviation.',
      variant_option_variant_title: 'Comparison figure',
      variant_options_mode_attribute: 'Attribute',
      variant_options_dialog_info:
        'The table then shows one segment per comparison figure — for example outcome, budget and deviation — instead of values per attribute.',
      variant_options_dialog_start:
        'Saving creates a segment for the outcome. You then add and manage the segments under Segments in the panel.',
      variant_options_mode_variants: 'Comparison figures',
      expanded_segment_levels_title: 'Expanded down to',
      expanded_segment_levels_helper_text:
        'Sets which levels the table shows when it opens. Rows can still be expanded and collapsed.',
      expanded_segment_levels_all_collapsed: '{{name}} (all collapsed)',
      expanded_segment_levels_all_expanded: '{{name}} (all expanded)',
      variant_options_mode_helper:
        'The table segments can show values per attribute or comparison figures for the metrics — for example outcome, budget and deviation.',
      variant_options_disable_body:
        'Your comparison figures will be removed and the table will show the segmentation again.',
      linking_unavailable_for_variant_options:
        'Source system linking is not available with comparison figures.',
      disabled_show_total_variant_options:
        'Total is not available with comparison figures.',
      cannot_add_attribute_with_variant_options:
        'Attribute columns cannot be added while the widget has comparison figures.',
      setting_controlled_by_variant_option:
        'This setting is controlled per comparison figure. Change it under Segments in the panel.',
      variant_options_row_header: 'Comparison figures',
      cannot_delete_last_variant_option:
        'The last comparison figure cannot be removed. Switch the segments to an attribute to leave comparison figures.',
      disabled_additional_segmentation_horizontal:
        'Additional dimensions are disabled when the widget shows segments horizontally.',
      disabled_additional_segmentation_preview:
        'Additional dimensions are disabled when the widget is included in the preview.',
      label_chars_helper_text:
        'Sometimes it can be helpful to limit the label length to give the visualization more room.',
      top_n_helper_text:
        'This is especially useful if you want to focus on the largest or smallest values.',
      limit_selection_to_primary_kpi_helper:
        'By enabling "Limit selection to primary metric", only segments within the primary metric\'s period are shown. Useful when metrics have different periods but you want to focus on data containing the primary metric.',
      breakdown_by: 'Break down by',
      breakdown_disabled_due_to_comparative:
        'Breakdown cannot be used while a comparison is enabled',
      breakdown_disabled_due_to_variant_options:
        'Breakdown cannot be used while the widget has comparison figures',
      breakdown_disabled_due_to_horizontal_segments:
        'Breakdown cannot be used while segments are shown horizontally',
      expandable_metric_rows_helper:
        'Every metric can be expanded into the additional segmentations, with values from that metric. The segmentation is shown as columns.',
      disabled_for_financial_year: 'Financial year does not support',
      rolling_disabled_for_financial_year:
        'Financial year does not support rolling calculation',
      share_title: 'Share',
      share_helper_text: (
        <>
          Showing share of this metric presents the percentage that meets the
          criteria you add in this section.{' '}
          <IconTip
            title={
              <>
                <Text variant="body2" color="inherit" gutterBottom>
                  <b>More details</b>
                </Text>
                <Text variant="body2" color="inherit">
                  <b>Result of filters in this section</b> /{' '}
                  <b>Total result of the metric</b>
                  <Divider />
                  Displayed in percent
                </Text>
              </>
            }
            variant="info"
            size={'small'}
          />
        </>
      ),
      show_share: 'Show share',
      indication_title: 'Indication',
      increase_is: 'Increase is',
      positive: 'Positive',
      negative: 'Negative',
      status: 'Status',
      bound: 'Bound',
      add_intermediate_mode_helper_text:
        'Add an intermediate mode to give your data a status between positive and negative.',
      add_intermediate_mode: 'Add intermediate mode',
      remove_intermediate_mode: 'Remove intermediate mode',
      latest_closed_financial_period: 'Latest closed financial period',
      lock_date_filter_helper_text:
        'If you lock the time period, the user\'s own time filter will not affect the widget.',
      restrict_to_closed_period_helper_text:
        'If you restrict the period to the latest closed financial period, your widget will never display data later than that, regardless of settings.',
      forecast_available_with_intro:
        'Forecast can only be shown together with:',
      historical_periods: 'Historical periods',
      comparisons: 'Comparisons',
      missing_financial_period_setting: 'Missing financial period setting',
      missing_period_setting_error:
        'This widget is restricted to the latest closed accounting period, but no accounting period has been set.',
      configure_accounting_periods: 'Set up accounting periods',
      cannot_compare_with_breakdown:
        'Cannot compare when a metric has been broken down.',
      cannot_compare_for_metric_or_period:
        'Cannot compare this metric or the selected time period.',
      cannot_restrict_period_intro:
        'The time period cannot be restricted to the latest closed financial period because it does not cover the full period. Financial period is set to',
      adjust_interval_instruction:
        '. Adjust the interval to include a full financial period.',
      camera: 'Camera',
      longitude: 'Longitude',
      latitude: 'Latitude',
      zoom: 'Zoom',
      viewport_helper_text:
        'Move and zoom the map to the desired position. Then click Save above to update the map\'s initial position.',
      pie_segments: 'Pie segments',
      disabled_show_total_if_preview:
        'You can\'t show total in widgets that are included in the preview.',
      show_headers: 'Show headers',
      show_total: 'Show total',
      total_column: 'Total',
      show_vertical_lines: 'Show vertical lines',
      use_like_for_like_real_estates: 'Like-for-like',
      use_like_for_like_real_estates_helper_text:
        'When this setting is enabled, only properties that have existed throughout the selected period are included. ' +
        'New acquisitions and sold properties are automatically excluded, ensuring a fair and consistent comparison over time.',
      use_start_of_period: ' Start of period reference',
      use_start_of_period_helper_text:
        'For point-in-time metrics (e.g., vacancy rate), ' +
        'the default reference is the end of the period or the last date of the segment. ' +
        'With this setting, you can instead choose to use the start of the period as the reference point.',
      horizontal_text_alignment: 'Horizontal text alignment',
      vertical_text_alignment: 'Vertical text alignment',
      latest_exchange_rate_warning:
        'Latest exchange rate for accumulated metrics',
      latest_exchange_rate_tooltip:
        'Accumulated metrics are calculated using the latest available ' +
        'exchange rate, not the actual exchange rates for the period like ' +
        'other metrics.',
      weighted_average_warning: 'Weighted average',
      weighted_average_tooltip:
        'The value is based on a weighted average calculated from the selected properties.'
    },

    users: {
      admin_data_access_tooltip:
        'System administrators always have access to all data in the system.',
      'logged_in_via_{{name}}': 'Logged in via {{name}}',
      cant_find_user: 'Can\'t find the user?',
      contact_system_admin:
        'Contact a system administrator to invite the person to Homepal.',
      no_system_admin: 'No system administrator is assigned.',
      colleague: 'Colleague',
      company_group_user: 'Customer user',
      system_owner: 'System owner',
      invite_non_users_title:
        'Here you invite people to Homepal who are not already users.',
      already_a_user_question: 'Is the person already a user?',
      go_back_and_add_user: 'Go back and add user',
      company_group_data_access_tooltip:
        'Customer users only see data for the customer they belong to.',
      company_group_missing_error: 'You must select a customer.',
      company_group_not_support_for_group_tooltip:
        'Customer users are not supported in groups',
      company_group_removed_title: 'Customer removed',
      economy_description:
        'Gives the user access to view and edit financial settings.',
      analyses_description: 'Gives the user access to the analysis service.',
      edit_user: 'Edit user',
      email: 'Email',
      email_error: 'You must enter a valid email. Example: hello@homepal.se',
      first_name: 'First name',
      first_name_missing_error: 'User must have a first name.',
      last_name: 'Last name',
      last_name_missing_error: 'User must have a last name.',
      message: 'Message',
      message_information: (
        <>
          <Text fontSize="inherit" color="inherit" gutterBottom={true}>
            <b>Note!</b> This person has likely never used Homepal before.
          </Text>
          <Text fontSize="inherit" color="inherit">
            Including a short message in your invitation can be very helpful to
            explain <i>why</i> the person has been invited and <i>what</i> they
            are expected to do.
          </Text>
        </>
      ),
      not_activated_title: 'Not activated',
      not_activated_tooltip: 'The user has not activated their account yet',
      role: 'Role',
      sso_create_error:
        'Since your organization uses SSO, you can only invite users through your IDP service. Please contact your system administrator.',
      sso_delete_error:
        'Since you have an IDP integration enabled, the user must be removed from your IDP solution in order to revoke access to Homepal.',
      sso_title: 'SSO',
      unique_user: 'Unique user',
      unique_users: 'Unique users',
      email_change_disabled_tooltip:
        'Email cannot be changed after an account has been created',
      mfa_title: 'Two-factor authentication (2FA)',
      mfa_description:
        'Add an extra layer of security to your account by requiring a verification code from your mobile phone when you log in.',
      mfa_enabled: 'Enabled',
      mfa_disabled: 'Disabled',
      mfa_enable: 'Enable',
      mfa_disable: 'Disable',
      mfa_status_load_error: 'Could not fetch MFA status',
      mfa_disabled_success: 'Two-factor authentication has been disabled',
      mfa_disable_error: 'Could not disable two-factor authentication',
      mfa_enabled_success: 'Two-factor authentication has been enabled!',
      mfa_note:
        'You need an authenticator app such as Google Authenticator, Authy, or Microsoft Authenticator to use two-factor authentication.',
      mfa_note_label: 'Note!',
      mfa_setup_title: 'Enable two-factor authentication',
      mfa_setup_step1:
        '1. Scan the QR code with your authenticator app (Google Authenticator, Authy, etc.)',
      mfa_setup_manual: 'Or enter this code manually:',
      mfa_setup_step2: '2. Enter the verification code from your app:',
      mfa_verification_code: 'Verification code',
      mfa_cancel: 'Cancel',
      mfa_verify_and_enable: 'Verify and enable',
      mfa_qr_generation_error: 'Could not generate QR code. Please try again.',
      mfa_code_length_error: 'Enter a 6-digit verification code',
      mfa_invalid_code_error: 'Invalid verification code. Please try again.',
      search_placeholder: 'Search users by name or email',
      page_title: 'Manage users',
      page_body: 'Create users and manage their access and permissions.'
    },

    org_units: {
      unit: 'Property',
      units: 'Properties',
      all: 'All properties',
      custom: 'Custom properties',
      standard: 'My properties',
      helper_text:
        'Select the properties you want to save in your default selection.',
      unit_company: 'Company',
      units_company: 'Companies',
      all_company: 'All companies',
      custom_company: 'Custom companies',
      standard_company: 'My companies',
      helper_text_company:
        'Select the companies you want to save in your default selection.',
      global_filter: 'Global filter'
    },

    data_access: {
      data_access: 'Data access',
      tooltip:
        'Data access is set up and distributed by the organization\'s system administrator.',
      page_title: 'Manage data access',
      page_body: 'Create data accesses that later can be assigned to users.',
      helper_text:
        'Add properties to a data access that later can be assigned to users.',
      helper_text_company:
        'Add companies to a data access that later can be assigned to users.',
      title_placeholder: 'Ex. Northern Region',
      description_placeholder: 'Ex. Access to data from Northern Region only',
      users_using_access:
        'There is {{numberOfUsers}} users using this data access.',
      missing_data_access_title: 'Missing data access',
      missing_data_access_body:
        'You have no data access, contact one of the following system administrators.'
    },

    nps: {
      reason_question:
        'What is the most important thing that would make your experience even better?',
      score_question:
        'How likely are you to recommend Homepal to a friend or colleague?',
      skip: 'Skip',
      skip_loading: 'Skip...',
      submit: 'Submit',
      submit_loading: 'Submit...',
      thank_you_text:
        'Thank you for completing this survey. Your feedback is greatly appreciated!'
    },

    currency_converter: {
      currency: 'Currency',
      select_currency: 'Select currency'
    },

    mcp_tokens: {
      landing_name: 'MCP',
      landing_title: 'MCP connections',
      landing_body:
        'Connect Claude, ChatGPT, Microsoft Copilot or Lovable to Homepal over MCP.',
      page_title: 'MCP connections',
      page_intro:
        'Connect Claude, ChatGPT, Microsoft Copilot or Lovable to Homepal. Each button guides you step by step: the MCP URL is copied and the right settings page opens, then you sign in and approve. Microsoft Copilot is connected by your Microsoft 365 administrator.',
      localhost_warning:
        'You are running against localhost. External clients do not accept HTTP MCP URLs — start a devtunnel and set MCP_OAUTH_ISSUER_URL (see the compose file).',
      tunnel_active:
        'Public HTTPS tunnel detected — external clients (Claude web, ChatGPT, Copilot) connect through:',
      connect_claude_web: 'Connect to Claude (web)',
      connect_chatgpt: 'Connect to ChatGPT',
      connect_copilot: 'Connect to Microsoft Copilot',
      connect_lovable: 'Connect to Lovable',
      lovable_dialog_title: 'Connect Lovable',
      lovable_dialog_intro:
        'Add Homepal as an MCP server in Lovable so Lovable can fetch your data while you build. Each user connects with their own Homepal account.',
      lovable_not_enabled_warning:
        'Lovable is not allowed for your organisation yet. An administrator turns it on under "Lovable (admin)" on this page.',
      lovable_step_1: 'Copy the Homepal MCP URL',
      lovable_step_2: 'Add the MCP server in Lovable',
      lovable_step_2_item_1:
        'Click "Open Lovable" below. The MCP URL is copied automatically.',
      lovable_step_2_item_2: 'In Lovable: Connectors → + → MCP server.',
      lovable_step_2_item_3:
        'Server name: "Homepal". Server URL: paste the URL.',
      lovable_step_2_item_4:
        'Leave Authentication on OAuth (default) and click "Add & authorize".',
      lovable_open: 'Open Lovable',
      lovable_step_3: 'Approve the connection',
      lovable_step_3_item_1:
        'Lovable starts the sign-in. Sign in with your Homepal account and approve on our consent page.',
      lovable_step_3_note:
        'The connection is personal. Colleagues who want to use Homepal in Lovable connect with their own accounts.',
      lovable_step_4: 'How to use it',
      lovable_step_4_item_1:
        'Ask Lovable in the project chat, e.g. "Fetch the vacancy rate per property from Homepal and build an overview".',
      lovable_step_4_note:
        'Homepal is only used while you build. The published app gets no access to Homepal data.',
      lovable_section_title: 'Lovable (admin)',
      lovable_section_intro:
        'Lovable connects without client credentials, so your organisation must allow it here. Each user still signs in and approves on their own. Turning it off revokes every existing Lovable connection immediately.',
      lovable_enabled: 'Lovable is allowed',
      lovable_disabled: 'Lovable is not allowed',
      lovable_disable_dialog_title: 'Turn off Lovable?',
      lovable_disable_dialog_intro:
        'Every Lovable connection in your organisation stops working immediately. Users have to connect again if Lovable is turned on later.',
      hub_systems_section_title: 'Hub Systems (admin)',
      hub_systems_section_intro:
        'Hub Systems connects without client credentials, so your organisation must allow it here. Each user still signs in and approves on their own. Turning it off revokes every existing Hub Systems connection immediately.',
      hub_systems_enabled: 'Hub Systems is allowed',
      hub_systems_disabled: 'Hub Systems is not allowed',
      hub_systems_disable_dialog_title: 'Turn off Hub Systems?',
      hub_systems_disable_dialog_intro:
        'Every Hub Systems connection in your organisation stops working immediately. Users have to connect again if Hub Systems is turned on later.',
      platform_disable: 'Turn off',
      claude_web_dialog_title: 'Connect Claude (web)',
      claude_web_dialog_intro:
        'Connect Homepal as a custom connector in Claude’s settings. It takes under a minute.',
      claude_web_step_1: 'Copy Homepal’s MCP URL',
      claude_web_step_2: 'Add as a custom connector in Claude',
      claude_web_step_2_item_1:
        'Click "Open claude.ai" below — the MCP URL is copied automatically.',
      claude_web_step_2_item_2:
        'In Claude: Add → Add custom connector → paste the URL.',
      claude_web_step_2_item_3:
        'Open Advanced settings and fill in your organisation’s Client ID and client secret as below.',
      claude_web_step_3: 'Approve the connection',
      claude_web_step_3_item_1:
        'Claude starts the sign-in — log in with your Homepal account.',
      claude_web_step_3_item_2: 'Approve the access on our consent page.',
      claude_web_step_3_note:
        'On Claude Team/Enterprise the connector must instead be added by your organisation owner under Organization settings → Connectors.',
      claude_web_step_4: 'Allow the tools',
      claude_web_step_4_item_1:
        'Once connected, Homepal’s tools appear under "Tool permissions".',
      claude_web_step_4_item_2:
        'Set them to "Always allow" (the toggle at the top right, or per tool) so you are not asked to approve every single call in the chat.',
      claude_web_step_4_note:
        'All tools are read-only — they only fetch data, never change anything.',
      claude_web_step_5: 'How to use it in chat',
      claude_web_step_5_item_1:
        'Open a new chat, click the + button → Connectors and enable Homepal.',
      claude_web_step_5_item_2:
        'Ask questions in plain language, e.g. "What is the vacancy rate per property?" or "How has net operating income developed this year?".',
      claude_web_step_5_note:
        'Claude picks the right tool, fetches the data from Homepal and answers — all with your own permissions.',
      claude_web_open_settings: 'Open claude.ai',
      chatgpt_dialog_title: 'Connect ChatGPT',
      chatgpt_dialog_intro:
        'Custom connectors in ChatGPT require Developer mode and are added manually in settings. Works on Pro, Plus, Business, Enterprise and Edu (web app).',
      chatgpt_step_1: 'Copy Homepal’s MCP URL',
      chatgpt_step_2: 'Enable Developer mode',
      chatgpt_step_2_item_1:
        'Click "Open ChatGPT" below — the MCP URL is copied automatically.',
      chatgpt_step_2_item_2:
        'In ChatGPT: Settings → Apps → Advanced settings → turn on Developer mode.',
      chatgpt_step_2_note:
        'On Business/Enterprise a workspace admin must first allow it under Workspace Settings → Permissions & Roles → Connected Data → Create custom MCP connectors.',
      chatgpt_step_3: 'Create the connector',
      chatgpt_step_3_item_1: 'Go to Settings → Connectors → Create.',
      chatgpt_step_3_item_2:
        'Name: "Homepal". Description: e.g. "Homepal’s real estate analytics platform — metrics, vacancy, energy, economy".',
      chatgpt_step_3_item_3: 'Paste the MCP URL and choose OAuth.',
      chatgpt_step_3_item_4:
        'Under Client registration: choose "Custom OAuth client" and fill in your organisation’s Client ID and client secret as below.',
      chatgpt_step_3_item_5:
        'Set "Token endpoint authentication method" to client_secret_post — with "none" your secret is never sent and the connection is rejected.',
      chatgpt_step_4: 'Approve the connection',
      chatgpt_step_4_item_1:
        'ChatGPT starts the sign-in — log in with your Homepal account and approve on our consent page.',
      chatgpt_step_4_item_2: 'Then enable the connector in your chats.',
      chatgpt_step_4_note:
        'Standard mode uses search/fetch; Developer mode exposes all tools.',
      chatgpt_open_settings: 'Open ChatGPT',
      copilot_dialog_title: 'Connect Microsoft 365 Copilot',
      copilot_dialog_intro:
        'Microsoft 365 Copilot connects through a custom federated connector. A Microsoft 365 administrator (Global Administrator or AI Administrator) sets it up in two steps: an OAuth registration in the Teams Developer Portal and a connector in the Microsoft 365 admin center. Allow about 10 minutes. Each user then connects the source with their own Homepal account.',
      copilot_materialization_disclaimer:
        '⚠️ Important about wait time: Even once the connector shows as connected in Copilot, it can take up to 24–48 hours before Microsoft has materialized it so Copilot actually uses it. In the meantime Copilot may say it cannot find the source’s tools — this is expected and does not mean anything is wrong. Configure it ONCE and leave it: every reconfiguration or recreation resets Microsoft’s clock and extends the wait.',
      copilot_step_1: 'Register an OAuth client in the Teams Developer Portal',
      copilot_step_1_item_1:
        'Click "Open Teams Developer Portal" below (or go to Tools → OAuth client registration).',
      copilot_step_1_item_2: 'Choose "+ New OAuth connection".',
      copilot_step_1_item_3:
        'Fill in the fields from the table below — use the copy buttons. The client secret is not used by Homepal but the field is required, paste the value from the table.',
      copilot_step_1_item_4:
        'NOTE: do not create an app under "Apps" — only the OAuth registration under Tools is needed.',
      copilot_step_1_footnote_intro: 'Important before saving:',
      copilot_step_1_footnote_item_1:
        'Turn ON "Enable Proof Key for Code Exchange (PKCE)".',
      copilot_step_1_footnote_item_2:
        'Leave "Client password authentication method" on "Request body parameters (default)".',
      copilot_step_1_footnote_item_3:
        'Choose "My organization only" + "Any Teams app" under Restrict usage.',
      copilot_step_1_footnote_item_4:
        'Save and copy the registration ID (OAuth client registration ID) — you need it in step 2.',
      copilot_step_2: 'Create the connector in the Microsoft 365 admin center',
      copilot_step_2_item_1:
        'Click "Open Microsoft 365 admin center" below — it lands directly in the "Add connector" view (otherwise: Copilot → Connectors → Gallery → "Create a new connector").',
      copilot_step_2_item_2: 'Under "Connect to MCP server", choose Add.',
      copilot_step_2_item_3:
        'Fill in the Display name and MCP endpoint URL as below (the URL must end with /mcp).',
      copilot_step_2_item_4:
        'Choose Authentication type "OAuth 2.0" and paste the registration ID from step 1 as the Reference ID.',
      copilot_step_2_item_5:
        'Click Authorize — sign in with your Homepal account and approve.',
      copilot_step_2_item_6: 'Tick the Notice checkbox and save.',
      copilot_step_3: 'Roll the connector out to users',
      copilot_step_3_item_1: 'On the Your Connections tab, open the connector.',
      copilot_step_3_item_2:
        'Set Staged rollout to "Deploy to all users" (or pick specific groups).',
      copilot_step_3_item_3:
        'Make sure "Enable/disable this source for users" is On.',
      copilot_step_3_item_4:
        'Verify by checking that the Tools section in the connector pane lists Homepal’s tools.',
      copilot_step_3_note: 'Changes take up to 15 minutes to propagate.',
      copilot_step_4: 'Activate the source in chat (done by each user)',
      copilot_step_4_item_1:
        'In Microsoft 365 Copilot: open Settings (… menu) → Sources.',
      copilot_step_4_item_2:
        'Find "Homepal", click Connect, sign in with your Homepal account and approve.',
      copilot_step_4_item_3:
        'Start a new chat and try e.g. "What is the current vacancy rate per property?".',
      copilot_step_4_note_1:
        'The source works in Copilot Chat, the Researcher agent and Copilot in Excel — Copilot always fetches data with your own Homepal permissions.',
      copilot_step_4_note_2:
        'NOTE: Microsoft registers a new connector in several stages and it takes time. It can take 15–30 minutes before the source appears under Sources — and even once it is visible and connected, it can take up to 24–48 hours before Copilot actually starts using it (see the warning at the top). Be patient and try again in a new chat — no reconfiguration is needed (reconfiguring, in fact, resets Microsoft’s clock).',
      copilot_open_chat: 'Open Microsoft 365 Copilot',
      copilot_open_tdp: 'Open Teams Developer Portal',
      copilot_secret_from_generation:
        'your client secret (shown when the credentials were generated)',
      no_client_credentials_warning:
        'Your organisation has no client credentials yet — the connection requires them. Ask an administrator to generate them under "Client credentials" on this page first.',
      copilot_reference_id_hint:
        'Reference ID = the OAuth client registration ID you copied from the Teams Developer Portal in step 1.',
      client_section_title: 'Client credentials (admin)',
      client_section_intro:
        'Your organisation’s OAuth credentials (client ID + client secret) — used in all connection guides below. The client secret is shown only once, at generation. Rotating creates new credentials and invalidates the old ones immediately; revoking disables every connection using them.',
      client_created_at: 'Created',
      client_secret_shown_once:
        'the client secret was shown at generation and cannot be displayed again.',
      client_generate: 'Generate client credentials',
      client_rotate: 'Rotate',
      client_revoke: 'Revoke',
      client_rotate_dialog_title: 'Rotate client credentials?',
      client_rotate_dialog_intro:
        'New credentials are generated and the current ones stop working immediately. Every connection (Copilot, Claude, ChatGPT) using the old credentials must be updated with the new ones.',
      client_created_dialog_title: 'Client credentials created',
      client_created_dialog_intro:
        'Copy the client secret now — for security it is only shown once. If you lose it, rotate the credentials and update your connections.',
      client_delete_type: 'client credentials',
      copilot_open_admin_center: 'Open Microsoft 365 admin center',
      copilot_localhost_hint:
        'You are running against localhost. Copilot requires a publicly reachable HTTPS URL — start a devtunnel, set MCP_OAUTH_ISSUER_URL (see the compose file) and use the tunnel URL instead.',
      not_available:
        'The MCP integration is not enabled for this customer in the current environment.'
    },

    mcp_consent: {
      title: 'Approve connection',
      subtitle_with_client:
        '{{client}} wants to connect to your Homepal account.',
      subtitle_generic:
        'An MCP client wants to connect to your Homepal account.',
      platform_warning:
        'Only approve if you just clicked "Add & authorize" in your own {{client}} workspace. If someone else sent you this link, click Cancel.',
      access_heading: 'The client will be able to read:',
      access_metrics: 'Metrics, dashboards and key indicators',
      access_entities: 'Properties, rental units and tickets',
      access_reports: 'Reports and analyses available to your account',
      logged_in_as: 'Signed in as',
      customer: 'Customer',
      error_invalid_redirect:
        'The link contains a return address that is not registered for this client. The connection cannot be approved.',
      cancel: 'Cancel',
      approve: 'Approve',
      approving: 'Approving',
      revoke_hint:
        'You can revoke access at any time under Settings → MCP clients.',
      error_missing_params:
        'OAuth parameters are missing. Restart the integration from Claude / ChatGPT.',
      error_load_client: 'Could not load client information. Try again later.',
      error_generic: 'Something went wrong while approving.',
      not_available:
        'The MCP integration is not enabled for this customer in the current environment.'
    },

    resources: {
      all_resources: 'All resources',
      restore_dashboard_title: 'Restore dashboard',
      restore_dashboard_body: 'Do you want to restore this dashboard?',
      search_placeholder: 'Search resource'
    }
  }
} as const
